export const USER_REGISTRATION_REQUEST = "LEGACY_USER_REGISTRATION_REQUEST";
export const USER_REGISTRATION_SUCCEDDED = "LEGACY_USER_REGISTRATION_SUCCEDDED";
export const USER_REGISTRATION_FAILED = "LEGACY_USER_REGISTRATION_FAILED";
export const INVALIDATE_USER_REGISTRATION = "LEGACY_INVALIDATE_USER_REGISTRATION";

export const RESENDING_REGISTRATION_EMAIL_REQUEST =
  "LEGACY_RESENDING_REGISTRATION_EMAIL_REQUEST";
export const RESENDING_REGISTRATION_EMAIL_SUCCEDDED =
  "LEGACY_RESENDING_REGISTRATION_EMAIL_SUCCEDDED";
export const RESENDING_REGISTRATION_EMAIL_FAILED =
  "LEGACY_RESENDING_REGISTRATION_EMAIL_FAILED";
export const INVALIDATE_RESEND_REGISTRATION_EMAIL =
  "LEGACY_INVALIDATE_RESEND_REGISTRATION_EMAIL";

export const USER_ACTIVATION_REQUEST = "LEGACY_USER_ACTIVATION_REQUEST";
export const USER_ACTIVATION_SUCCEDDED = "LEGACY_USER_ACTIVATION_SUCCEDDED";
export const USER_ACTIVATION_FAILED = "LEGACY_USER_ACTIVATION_FAILED";

export const VALIDATING_USER_ACTIVATION_REQUEST =
  "LEGACY_VALIDATING_USER_ACTIVATION_REQUEST";
export const VALIDATING_USER_ACTIVATION_SUCCEDDED =
  "LEGACY_VALIDATING_USER_ACTIVATION_SUCCEDDED";
export const VALIDATING_USER_ACTIVATION_FAILED =
  "LEGACY_VALIDATING_USER_ACTIVATION_FAILED";

export const FETCHING_USER_INVITATION = "LEGACY_FETCHING_USER_INVITATION";
export const FETCHING_USER_INVITATION_SUCCEDDED =
  "LEGACY_FETCHING_USER_INVITATION_SUCCEDDED";
export const FETCHING_USER_INVITATION_FAILED =
  "LEGACY_FETCHING_USER_INVITATION_FAILED";

export const INVITE_USER_REGISTRATION_REQUEST =
  "LEGACY_INVITE_USER_REGISTRATION_REQUEST";
export const INVITE_USER_REGISTRATION_REQUEST_SUCCEDDED =
  "LEGACY_INVITE_USER_REGISTRATION_REQUEST_SUCCEDDE`D";
export const INVITE_USER_REGISTRATION_REQUEST_FAILED =
  "LEGACY_INVITE_USER_REGISTRATION_REQUEST_FAILED";

export const AUTHENTICATING_USER = "LEGACY_AUTHENTICATING_USER";
export const AUTHENTICATING_USER_SUCCEDDED = "LEGACY_AUTHENTICATING_USER_SUCCEDDED";
export const AUTHENTICATING_USER_FAILED = "LEGACY_AUTHENTICATING_USER_FAILED";

export const FORGOT_PASSWORD_REQUEST = "LEGACY_FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCEDDED = "LEGACY_FORGOT_PASSWORD_SUCCEDDED";
export const FORGOT_PASSWORD_FAILED = "LEGACY_FORGOT_PASSWORD_FAILED";

export const VALIDATING_PASSWORD_RESET_LINK = "LEGACY_VALIDATING_PASSWORD_RESET_LINK";
export const VALIDATING_PASSWORD_RESET_LINK_SUCCEDDED =
  "LEGACY_VALIDATING_PASSWORD_RESET_LINK_SUCCEDDED";
export const VALIDATING_PASSWORD_RESET_LINK_FAILED =
  "LEGACY_VALIDATING_PASSWORD_RESET_LINK_FAILED";

export const LOGOUT_USER = "LEGACY_LOGOUT_USER";

export const FETCHING_SSO_URL_REQUEST = "LEGACY_FETCHING_SSO_URL_REQUEST";
export const FETCHING_SSO_URL_SUCCEDDED = "LEGACY_FETCHING_SSO_URL_SUCCEDDED";
export const FETCHING_SSO_URL_FAILED = "LEGACY_FETCHING_SSO_URL_FAILED";

export const SSO_AUTHENTICATED_FAILED = "LEGACY_SSO_AUTHENTICATED_FAILED";

export const FETCHING_USER_PROFILE = "LEGACY_FETCHING_USER_PROFILE";
export const FETCHING_USER_PROFILE_SUCCEDDED =
  "LEGACY_FETCHING_USER_PROFILE_SUCCEDDED";
export const FETCHING_USER_PROFILE_FAILED = "LEGACY_FETCHING_USER_PROFILE_FAILED";

export const CHANGING_PASSWORD = "LEGACY_CHANGING_PASSWORD";
export const CHANGING_PASSWORD_SUCCEDDED = "LEGACY_CHANGING_PASSWORD_SUCCEDDED";
export const CHANGING_PASSWORD_FAILED = "LEGACY_CHANGING_PASSWORD_FAILED";

export const UPDATING_USER_PROFILE = "LEGACY_UPDATING_USER_PROFILE";
export const UPDATING_USER_PROFILE_SUCCEDDED =
  "LEGACY_UPDATING_USER_PROFILE_SUCCEDDED";
export const UPDATING_USER_PROFILE_FAILED = "LEGACY_UPDATING_USER_PROFILE_FAILED";

export const UPDATING_USER_ONBOARD_REQUEST = "LEGACY_UPDATING_USER_ONBOARD_REQUEST";
export const UPDATING_USER_ONBOARD_SUCCEDDED =
  "LEGACY_UPDATING_USER_ONBOARD_SUCCEDDED";
export const UPDATING_USER_ONBOARD_FAILED = "LEGACY_UPDATING_USER_ONBOARD_FAILED";

export const UPDATING_USER_RELEASE_NOTES_REQUEST =
  "LEGACY_UPDATING_USER_RELEASE_NOTES_REQUEST";
export const UPDATING_USER_RELEASE_NOTES_SUCCEDDED =
  "LEGACY_UPDATING_USER_RELEASE_NOTES_SUCCEDDED";
export const UPDATING_USER_RELEASE_NOTES_FAILED =
  "LEGACY_UPDATING_USER_RELEASE_NOTES_FAILED";

export const FETCHING_USER_NOTIFICATION_REQUEST =
  "LEGACY_FETCHING_USER_NOTIFICATION_REQUEST";
export const FETCHING_USER_NOTIFICATION_SUCCEEDED =
  "LEGACY_FETCHING_USER_NOTIFICATION_SUCCEEDED";
export const FETCHING_USER_NOTIFICATION_FAILED =
  "LEGACY_FETCHING_USER_NOTIFICATION_FAILED";

export const UPDATING_USER_NOTIFICATION_REQUEST =
  "LEGACY_UPDATING_USER_NOTIFICATION_REQUEST";
export const UPDATING_USER_NOTIFICATION_SUCCEEDED =
  "LEGACY_UPDATING_USER_NOTIFICATION_SUCCEEDED";
export const UPDATING_USER_NOTIFICATION_FAILED =
  "LEGACY_UPDATING_USER_NOTIFICATION_FAILED";

//Cookie Consent
export const UPDATING_USER_COOKIE_CONSENT_REQUEST =
  "LEGACY_UPDATING_USER_COOKIE_CONSENT_REQUEST";
export const UPDATING_USER_COOKIE_CONSENT_SUCCEDDED =
  "LEGACY_UPDATING_USER_COOKIE_CONSENT_SUCCEDDED";
export const UPDATING_USER_COOKIE_CONSENT_FAILED =
  "LEGACY_UPDATING_USER_COOKIE_CONSENT_FAILED";

export const FETCHING_ACCOUNT_REQUEST = "LEGACY_FETCHING_ACCOUNT_REQUEST";
export const FETCHING_ACCOUNT_SUCCEDDED = "LEGACY_FETCHING_ACCOUNT_SUCCEDDED";
export const FETCHING_ACCOUNT_FAILED = "LEGACY_FETCHING_ACCOUNT_FAILED";

export const UPDATING_ACCOUNT = "LEGACY_UPDATING_ACCOUNT";
export const UPDATING_ACCOUNT_SUCCEDDED = "LEGACY_UPDATING_ACCOUNT_SUCCEDDED";
export const UPDATING_ACCOUNT_FAILED = "LEGACY_UPDATING_ACCOUNT_FAILED";
export const INVALIDATE_UPDATE_ACCOUNT_ERROR =
  "LEGACY_INVALIDATE_UPDATE_ACCOUNT_ERROR";

export const UPDATING_ACCOUNT_STREAMS_ACCESS =
  "LEGACY_UPDATING_ACCOUNT_STREAMS_ACCESS";
export const UPDATING_ACCOUNT_STREAMS_ACCESS_SUCCEDDED =
  "LEGACY_UPDATING_ACCOUNT_STREAMS_ACCESS_SUCCEDDED";
export const UPDATING_ACCOUNT_STREAMS_ACCESS_FAILED =
  "LEGACY_UPDATING_ACCOUNT_STREAMS_ACCESS_FAILED";

export const UPDATING_ACCOUNT_GLOBAL_CONTACT_ACCESS =
  "LEGACY_UPDATING_ACCOUNT_GLOBAL_CONTACT_ACCESS";
export const UPDATING_ACCOUNT_GLOBAL_CONTACT_ACCESS_SUCCEDDED =
  "LEGACY_UPDATING_ACCOUNT_GLOBAL_CONTACT_ACCESS_SUCCEDDED";
export const UPDATING_ACCOUNT_GLOBAL_CONTACT_ACCESS_FAILED =
  "LEGACY_UPDATING_ACCOUNT_GLOBAL_CONTACT_FAILED";

//fetching account invoices 
export const FETCHING_ACCOUNT_INVOICE_REQUEST = "LEGACY_FETCHING_ACCOUNT_INVOICE_REQUEST";
export const FETCHING_ACCOUNT_INVOICE_SUCCEDDED = "LEGACY_FETCHING_ACCOUNT_INVOICE_SUCCEDDED";
export const FETCHING_ACCOUNT_INVOICE_FAILED = "LEGACY_FETCHING_ACCOUNT_INVOICE_FAILED";

//download account invoice
export const DOWNLOAD_ACCOUNT_INVOICE_REQUEST = "LEGACY_DOWNLOAD_ACCOUNT_INVOICE_REQUEST";
export const DOWNLOAD_ACCOUNT_INVOICE_SUCCEDDED = "LEGACY_DOWNLOAD_ACCOUNT_INVOICE_SUCCEDDED";
export const DOWNLOAD_ACCOUNT_INVOICE_FAILED = "LEGACY_DOWNLOAD_ACCOUNT_INVOICE_FAILED";


//updating privacy policy control
export const UPDATING_ACCOUNT_PRIVACY_POLICY_CONTROL_REQUEST =
  "LEGACY_UPDATING_ACCOUNT_PRIVACY_POLICY_CONTROL_REQUEST";
export const UPDATING_ACCOUNT_PRIVACY_POLICY_CONTROL_SUCCEDDED =
  "LEGACY_UPDATING_ACCOUNT_PRIVACY_POLICY_CONTROL_SUCCEDDED";
export const UPDATING_ACCOUNT_PRIVACY_POLICY_CONTROL_FAILED =
  "LEGACY_UPDATING_ACCOUNT_PRIVACY_POLICY_CONTROL_FAILED";

//Updating Promoted Content
export const UPDATING_PROMOTED_CONTENT = "LEGACY_UPDATING_PROMOTED_CONTENT";
export const UPDATING_PROMOTED_CONTENT_SUCCEDDED =
  "LEGACY_UPDATING_PROMOTED_CONTENT_SUCCEDDED";
export const UPDATING_PROMOTED_CONTENT_FAILED =
  "LEGACY_UPDATING_PROMOTED_CONTENT_FAILED";

//Fetching Promoted Content
export const FETCHING_PROMOTED_CONTENT = "LEGACY_FETCHING_PROMOTED_CONTENT";
export const FETCHING_PROMOTED_CONTENT_SUCCEDDED =
  "LEGACY_FETCHING_PROMOTED_CONTENT_SUCCEDDED";
export const FETCHING_PROMOTED_CONTENT_FAILED =
  "LEGACY_FETCHING_PROMOTED_CONTENT_FAILED";

//Deleting Promoted Content
export const DELETING_PROMOTED_CONTENT = "LEGACY_DELETING_PROMOTED_CONTENT";
export const DELETING_PROMOTED_CONTENT_SUCCEDDED =
  "LEGACY_DELETING_PROMOTED_CONTENT_SUCCEDDED";
export const DELETING_PROMOTED_CONTENT_FAILED =
  "LEGACY_DELETING_PROMOTED_CONTENT_FAILED";

export const CREATE_STREAM = "LEGACY_CREATE_STREAM";
export const CREATE_STREAM_SUCCEDDED = "LEGACY_CREATE_STREAM_SUCCEDDED";
export const CREATE_STREAM_FAILED = "LEGACY_CREATE_STREAM_FAILED";
export const INVALIDATE_CREATE_STREAM_ERRORS =
  "LEGACY_INVALIDATE_CREATE_STREAM_ERRORS";

export const FETCHING_HUB_STREAMS = "LEGACY_FETCHING_HUB_STREAMS";
export const FETCHING_HUB_STREAMS_SUCCEDDED = "LEGACY_FETCHING_HUB_STREAMS_SUCCEDDED";
export const FETCHING_HUB_STREAMS_FAILED = "LEGACY_FETCHING_HUB_STREAMS_FAILED";
export const INVALIDATE_HUB_STREAMS = "LEGACY_INVALIDATE_HUB_STREAMS";

export const FETCHING_HUB_LAYOUT_REQUEST = "LEGACY_FETCHING_HUB_LAYOUT_REQUEST";
export const FETCHING_HUB_LAYOUT_SUCCEDDED = "LEGACY_FETCHING_HUB_LAYOUT_SUCCEDDED";
export const FETCHING_HUB_LAYOUT_FAILED = "LEGACY_FETCHING_HUB_LAYOUT_FAILED";
export const INVALIDATE_HUB_LAYOUT = "LEGACY_INVALIDATE_HUB_LAYOUT";

export const FETCHING_HUB_LAYOUTS_REQUEST = "LEGACY_FETCHING_HUB_LAYOUTS_REQUEST";
export const FETCHING_HUB_LAYOUTS_SUCCEEDED = "LEGACY_FETCHING_HUB_LAYOUTS_SUCCEEDED";
export const FETCHING_HUB_LAYOUTS_FAILED = "LEGACY_FETCHING_HUB_LAYOUTS_FAILED";

export const UPDATING_HUB_LAYOUT_REQUEST = "LEGACY_UPDATING_HUB_LAYOUT_REQUEST";
export const UPDATING_HUB_LAYOUT_SUCCEEDED = "LEGACY_UPDATING_HUB_LAYOUT_SUCCEEDED";
export const UPDATING_HUB_LAYOUT_FAILED = "LEGACY_UPDATING_HUB_LAYOUT_FAILED";

export const REARRANGING_HUB_LAYOUT_SUCCEEDED = "LEGACY_REARRANGING_HUB_LAYOUT_SUCCEEDED";

export const DELETING_HUB_ROW_REQUEST = "LEGACY_DELETING_HUB_ROW_REQUEST";
export const DELETING_HUB_ROW_SUCCEEDED = "LEGACY_DELETING_HUB_ROW_SUCCEEDED";
export const DELETING_HUB_ROW_FAILED = "LEGACY_DELETING_HUB_ROW_FAILED";

export const ENABLING_ACCESS_FOR_USER_GROUPS = "LEGACY_ENABLING_ACCESS_FOR_USER_GROUPS";
export const ENABLING_ACCESS_FOR_USER_GROUPS_SUCCEEDED = "LEGACY_ENABLING_ACCESS_FOR_USER_GROUPS_SUCCEEDED";
export const ENABLING_ACCESS_FOR_USER_GROUPS_FAILED = "LEGACY_ENABLING_ACCESS_FOR_USER_GROUPS_FAILED"

export const DELETING_HUB_LAYOUT_REQUEST = "LEGACY_DELETING_HUB_LAYOUT_REQUEST";
export const DELETING_HUB_LAYOUT_SUCCEEDED = "LEGACY_DELETING_HUB_LAYOUT_SUCCEEDED";
export const DELETING_HUB_LAYOUT_FAILED = "LEGACY_DELETING_HUB_LAYOUT_FAILED";

export const FETCHING_HUB_SECTION_REQUEST = "LEGACY_FETCHING_HUB_SECTION_REQUEST";
export const FETCHING_HUB_SECTION_SUCCEDDED = "LEGACY_FETCHING_HUB_SECTION_SUCCEDDED";
export const FETCHING_HUB_SECTION_FAILED = "LEGACY_FETCHING_HUB_SECTION_FAILED";
export const INVALIDATE_HUB_SECTION = "LEGACY_INVALIDATE_HUB_SECTION";

export const FETCHING_RECOMMENDED_STREAMS = "LEGACY_FETCHING_RECOMMENDED_STREAMS";
export const FETCHING_RECOMMENDED_STREAMS_SUCCEDDED =
  "LEGACY_FETCHING_RECOMMENDED_STREAMS_SUCCEDDED";
export const FETCHING_RECOMMENDED_STREAMS_FAILED =
  "LEGACY_FETCHING_RECOMMENDED_STREAMS_FAILED";
export const INVALIDATE_RECOMMENDED_STREAMS = "LEGACY_INVALIDATE_RECOMMENDED_STREAMS";

export const ADD_ASSET_TO_STREAM = "LEGACY_ADD_ASSET_TO_STREAM";
export const ADD_ASSET_TO_STREAM_SUCCEDDED = "LEGACY_ADD_ASSET_TO_STREAM_SUCCEDDED";
export const ADD_ASSET_TO_STREAM_FAILED = "LEGACY_ADD_ASSET_TO_STREAM_FAILED";

export const REMOVE_ASSET_FROM_STREAM = "LEGACY_REMOVE_ASSET_FROM_STREAM";
export const REMOVE_ASSET_FROM_STREAM_SUCCEDDED =
  "LEGACY_REMOVE_ASSET_FROM_STREAM_SUCCEDDED";
export const REMOVE_ASSET_FROM_STREAM_FAILED =
  "LEGACY_REMOVE_ASSET_FROM_STREAM_FAILED";

export const ADD_ASSET_TO_GROUP = "LEGACY_ADD_ASSET_TO_GROUP";
export const ADD_ASSET_TO_GROUP_SUCCEDDED = "LEGACY_ADD_ASSET_TO_GROUP_SUCCEDDED";
export const ADD_ASSET_TO_GROUP_FAILED = "LEGACY_ADD_ASSET_TO_GROUP_FAILED";

export const REMOVE_ASSET_FROM_GROUP = "LEGACY_REMOVE_ASSET_FROM_GROUP";
export const REMOVE_ASSET_FROM_GROUP_SUCCEDDED =
  "LEGACY_REMOVE_ASSET_FROM_GROUP_SUCCEDDED";
export const REMOVE_ASSET_FROM_GROUP_FAILED = "LEGACY_REMOVE_ASSET_FROM_GROUP_FAILED";

export const FETCHING_HUB_MOST_VIEWED_ASSETS =
  "LEGACY_FETCHING_HUB_MOST_VIEWED_ASSETS";
export const FETCHING_HUB_MOST_VIEWED_ASSETS_SUCCEDDED =
  "LEGACY_FETCHING_HUB_MOST_VIEWED_ASSETS_SUCCEDDED";
export const FETCHING_HUB_MOST_VIEWED_ASSETS_FAILED =
  "LEGACY_FETCHING_HUB_MOST_VIEWED_ASSETS_FAILED";
export const INVALIDATE_HUB_MOST_VIEWED_ASSETS =
  "LEGACY_INVALIDATE_HUB_MOST_VIEWED_ASSETS";

export const FETCHING_HUB_RECOMMENDED_ASSETS =
  "LEGACY_FETCHING_HUB_RECOMMENDED_ASSETS";
export const FETCHING_HUB_RECOMMENDED_ASSETS_SUCCEDDED =
  "LEGACY_FETCHING_HUB_RECOMMENDED_ASSETS_SUCCEDDED";
export const FETCHING_HUB_RECOMMENDED_ASSETS_FAILED =
  "LEGACY_FETCHING_HUB_RECOMMENDED_ASSETS_FAILED";
export const INVALIDATE_HUB_RECOMMENDED_ASSETS =
  "LEGACY_INVALIDATE_HUB_RECOMMENDED_ASSETS";

export const FETCHING_HUB_RECENT_ASSETS = "LEGACY_FETCHING_HUB_RECENT_ASSETS";
export const FETCHING_HUB_RECENT_ASSETS_SUCCEDDED =
  "LEGACY_FETCHING_HUB_RECENT_ASSETS_SUCCEDDED";
export const FETCHING_HUB_RECENT_ASSETS_FAILED =
  "LEGACY_FETCHING_HUB_RECENT_ASSETS_FAILED";
export const INVALIDATE_HUB_RECENT_ASSETS = "LEGACY_INVALIDATE_HUB_RECENT_ASSETS";

export const FETCHING_STREAM = "LEGACY_FETCHING_STREAM";
export const FETCHING_STREAM_SUCCEDDED = "LEGACY_FETCHING_STREAM_SUCCEDDED";
export const FETCHING_STREAM_FAILED = "LEGACY_FETCHING_STREAM_FAILED";
export const INVALIDATE_STREAM = "LEGACY_INVALIDATE_STREAM";

export const FETCHING_STREAM_CHILDREN = "LEGACY_FETCHING_STREAM_CHILDREN";
export const FETCHING_STREAM_CHILDREN_SUCCEDDED =
  "LEGACY_FETCHING_STREAM_CHILDREN_SUCCEDDED";
export const FETCHING_STREAM_CHILDREN_FAILED =
  "LEGACY_FETCHING_STREAM_CHILDREN_FAILED";

export const FETCHING_STREAM_ANALYTICS_REQUEST =
  "LEGACY_FETCHING_STREAM_ANALYTICS_REQUEST";
export const FETCHING_STREAM_ANALYTICS_SUCCEDDED =
  "LEGACY_FETCHING_STREAM_ANALYTICS_SUCCEDDED";
export const FETCHING_STREAM_ANALYTICS_FAILED =
  "LEGACY_FETCHING_STREAM_ANALYTICS_FAILED";

export const UPDATING_STREAM = "LEGACY_UPDATING_STREAM";
export const UPDATING_STREAM_SUCCEDDED = "LEGACY_UPDATING_STREAM_SUCCEDDED";
export const UPDATING_STREAM_FAILED = "LEGACY_UPDATING_STREAM_FAILED";

export const DELETING_STREAM = "LEGACY_DELETING_STREAM";
export const DELETING_STREAM_SUCCEDDED = "LEGACY_DELETING_STREAM_SUCCEDDED";
export const DELETING_STREAM_FAILED = "LEGACY_DELETING_STREAM_FAILED";

export const CREATING_GROUP_SECTION = "LEGACY_CREATING_GROUP_SECTION";
export const CREATING_GROUP_SECTION_SUCCEDDED =
  "LEGACY_CREATING_GROUP_SECTION_SUCCEDDED";
export const CREATING_GROUP_SECTION_FAILED = "LEGACY_CREATING_GROUP_SECTION_FAILED";

export const CREATING_GROUP = "LEGACY_CREATING_GROUP";
export const CREATING_GROUP_SUCCEDDED = "LEGACY_CREATING_GROUP_SUCCEDDED";
export const CREATING_GROUP_FAILED = "LEGACY_CREATING_GROUP_FAILED";

export const CREATING_GROUP_PARENT_GROUP = "LEGACY_CREATING_GROUP_PARENT_GROUP";
export const CREATING_GROUP_PARENT_GROUP_SUCCEDDED =
  "LEGACY_CREATING_GROUP_PARENT_GROUP_SUCCEDDED";
export const CREATING_GROUP_PARENT_GROUP_FAILED =
  "LEGACY_CREATING_GROUP_PARENT_GROUP_FAILED";

export const UPDATING_GROUP = "LEGACY_UPDATING_GROUP";
export const UPDATING_GROUP_SUCCEDDED = "LEGACY_UPDATING_GROUP_SUCCEDDED";
export const UPDATING_GROUP_FAILED = "LEGACY_UPDATING_GROUP_FAILED";

export const FETCHING_GROUP = "LEGACY_FETCHING_GROUP";
export const FETCHING_GROUP_SUCCEDDED = "LEGACY_FETCHING_GROUP_SUCCEDDED";
export const FETCHING_GROUP_FAILED = "LEGACY_FETCHING_GROUP_FAILED";
export const INVALIDATE_GROUP = "LEGACY_INVALIDATE_GROUP";

export const FETCHING_GROUP_CHILDREN = "LEGACY_FETCHING_GROUP_CHILDREN";
export const FETCHING_GROUP_CHILDREN_SUCCEDDED =
  "LEGACY_FETCHING_GROUP_CHILDREN_SUCCEDDED";
export const FETCHING_GROUP_CHILDREN_FAILED = "LEGACY_FETCHING_GROUP_CHILDREN_FAILED";

export const DELETING_GROUP = "LEGACY_DELETING_GROUP";
export const DELETING_GROUP_SUCCEDDED = "LEGACY_DELETING_GROUP_SUCCEDDED";
export const DELETING_GROUP_FAILED = "LEGACY_DELETING_GROUP_FAILED";

export const DELETING_ASSET = "LEGACY_DELETING_ASSET";
export const DELETING_ASSET_SUCCEDDED = "LEGACY_DELETING_ASSET_SUCCEDDED";
export const DELETING_ASSET_FAILED = "LEGACY_DELETING_ASSET_FAILED";

export const FETCHING_ASSET = "LEGACY_FETCHING_ASSET";
export const FETCHING_ASSET_SUCCEDDED = "LEGACY_FETCHING_ASSET_SUCCEDDED";
export const FETCHING_ASSET_FAILED = "LEGACY_FETCHING_ASSET_FAILED";
export const INVALIDATE_ASSET = "LEGACY_INVALIDATE_ASSET";

export const UPDATING_ASSET = "LEGACY_UPDATING_ASSET";
export const UPDATING_ASSET_SUCCEDDED = "LEGACY_UPDATING_ASSET_SUCCEDDED";
export const UPDATING_ASSET_FAILED = "LEGACY_UPDATING_ASSET_FAILED";

export const FETCHING_ASSET_SUBTITLE = "LEGACY_FETCHING_ASSET_SUBTITLE";
export const FETCHING_ASSET_SUBTITLE_SUCCEDDED = "LEGACY_FETCHING_ASSET_SUBTITLE_SUCCEDDED";
export const FETCHING_ASSET_SUBTITLE_FAILED = "LEGACY_FETCHING_ASSET_SUBTITLE_FAILED";

export const UPDATING_ASSET_SUBTITLE = "LEGACY_UPDATING_ASSET_SUBTITLE";
export const UPDATING_ASSET_SUBTITLE_SUCCEDDED = "LEGACY_UPDATING_ASSET_SUBTITLE_SUCCEDDED";
export const UPDATING_ASSET_SUBTITLE_FAILED = "LEGACY_UPDATING_ASSET_SUBTITLE_FAILED";

export const UPLOAD_NEW_ASSET_VERSION_REQUEST =
  "LEGACY_UPLOAD_NEW_ASSET_VERSION_REQUEST";
export const UPLOAD_NEW_ASSET_VERSION_SUCCEDDED =
  "LEGACY_UPLOAD_NEW_ASSET_VERSION_SUCCEDDED";
export const UPLOAD_NEW_ASSET_VERSION_FAILED =
  "LEGACY_UPLOAD_NEW_ASSET_VERSION_FAILED";
export const UPLOADING_NEW_ASSET_VERSION_PROGRESS =
  "LEGACY_UPLOADING_NEW_ASSET_VERSION_PROGRESS";
export const UPLOAD_NEW_ASSET_VERSION_CANCEL =
  "LEGACY_UPLOAD_NEW_ASSET_VERSION_CANCEL";

export const FETCHING_ASSET_ANALYTICS_REQUEST =
  "LEGACY_FETCHING_ASSET_ANALYTICS_REQUEST";
export const FETCHING_ASSET_ANALYTICS_SUCCEDDED =
  "LEGACY_FETCHING_ASSET_ANALYTICS_SUCCEDDED";
export const FETCHING_ASSET_ANALYTICS_FAILED =
  "LEGACY_FETCHING_ASSET_ANALYTICS_FAILED";

export const FAVORITING_ASSET_REQUEST = "LEGACY_FAVORITING_ASSET_REQUEST";
export const FAVORITING_ASSET_SUCCEDDED = "LEGACY_FAVORITING_ASSET_SUCCEDDED";
export const FAVORITING_ASSET_FAILED = "LEGACY_FAVORITING_ASSET_FAILED";

export const UNFAVORITING_ASSET_REQUEST = "LEGACY_UNFAVORITING_ASSET_REQUEST";
export const UNFAVORITING_ASSET_SUCCEDDED = "LEGACY_UNFAVORITING_ASSET_SUCCEDDED";
export const UNFAVORITING_ASSET_FAILED = "LEGACY_UNFAVORITING_ASSET_FAILED";

export const UPLOADING_FILE_REQUEST = "LEGACY_UPLOADING_FILE_REQUEST";
export const UPLOADING_FILE_SUCCEDDED = "LEGACY_UPLOADING_FILE_SUCCEDDED";
export const UPLOADING_FILE_FAILED = "LEGACY_UPLOADING_FILE_FAILED";
export const UPLOADING_FILE_PROGRESS = "LEGACY_UPLOADING_FILE_PROGRESS";
export const CANCELING_UPLOAD_ASSET = "LEGACY_CANCELING_UPLOAD_ASSET";

export const CREATING_ASSET_REQUEST = "LEGACY_CREATING_ASSET_REQUEST";
export const CREATING_ASSET_SUCCEDDED = "LEGACY_CREATING_ASSET_SUCCEDDED";
export const CREATING_ASSET_FAILED = "LEGACY_CREATING_ASSET_FAILED";

export const ADD_ASSET_URL = "LEGACY_ADD_ASSET_URL";
export const ADD_ASSET_URL_SUCCEDDED = "LEGACY_ADD_ASSET_URL_SUCCEDDED";
export const ADD_ASSET_URL_FAILED = "LEGACY_ADD_ASSET_URL_FAILED";

export const FETCHING_ASSET_PREVIEW = "LEGACY_FETCHING_ASSET_PREVIEW";
export const FETCHING_ASSET_PREVIEW_SUCCEDDED =
  "LEGACY_FETCHING_ASSET_PREVIEW_SUCCEDDED";
export const FETCHING_ASSET_PREVIEW_FAILED = "LEGACY_FETCHING_ASSET_PREVIEW_FAILED";

export const FETCHING_ASSET_PREVIEW_TEXT = "LEGACY_FETCHING_ASSET_PREVIEW_TEXT";
export const FETCHING_ASSET_PREVIEW_TEXT_SUCCEDDED =
  "LEGACY_FETCHING_ASSET_PREVIEW_TEXT_SUCCEDDED";
export const FETCHING_ASSET_PREVIEW_TEXT_FAILED =
  "LEGACY_FETCHING_ASSET_PREVIEW_TEXT_FAILED";

export const FETCHING_PREVIEW_HTML_TEMPLATE = "LEGACY_FETCHING_PREVIEW_HTML_TEMPLATE";
export const FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED =
  "LEGACY_FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED";
export const FETCHING_PREVIEW_HTML_TEMPLATE_FAILED =
  "LEGACY_FETCHING_PREVIEW_HTML_TEMPLATE_FAILED";

export const FETCHING_ASSET_INSIGHTS_REQUEST = "LEGACY_FETCHING_ASSET_INSIGHTS_REQUEST";
export const FETCHING_ASSET_INSIGHTS_REQUEST_SUCCEDDED = "LEGACY_FETCHING_ASSET_INSIGHTS_REQUEST_SUCCEDDED";
export const FETCHING_ASSET_INSIGHTS_REQUEST_FAILED = "LEGACY_FETCHING_ASSET_INSIGHTS_REQUEST_FAILED";
export const FETCHING_ASSET_STORAGE_LIMIT = "LEGACY_FETCHING_ASSET_STORAGE_LIMIT";
export const FETCHING_ASSET_STORAGE_LIMIT_SUCCEDDED = "LEGACY_FETCHING_ASSET_STORAGE_LIMIT_SUCCEDDED";
export const FETCHING_ASSET_STORAGE_LIMIT_FAILED = "LEGACY_FETCHING_ASSET_STORAGE_LIMIT_FAILED"

export const SUBSCRIBING_STREAM_REQUEST = "LEGACY_SUBSCRIBING_STREAM_REQUEST";
export const SUBSCRIBING_STREAM_SUCCEDDED = "LEGACY_SUBSCRIBING_STREAM_SUCCEDDED";
export const SUBSCRIBING_STREAM_FAILED = "LEGACY_SUBSCRIBING_STREAM_FAILED";

export const UNSUBSCRIBING_STREAM_REQUEST = "LEGACY_UNSUBSCRIBING_STREAM_REQUEST";
export const UNSUBSCRIBING_STREAM_SUCCEDDED = "LEGACY_UNSUBSCRIBING_STREAM_SUCCEDDED";
export const UNSUBSCRIBING_STREAM_FAILED = "LEGACY_UNSUBSCRIBING_STREAM_FAILED";

export const TRACKING_ASSET_VIEW_REQUEST = "LEGACY_TRACKING_ASSET_VIEW_REQUEST";
export const TRACKING_ASSET_VIEW_SUCCEDDED = "LEGACY_TRACKING_ASSET_VIEW_SUCCEDDED";
export const TRACKING_ASSET_VIEW_FAILED = "LEGACY_TRACKING_ASSET_VIEW_FAILED";

export const TRACKING_ASSET_DOWNLOAD_REQUEST =
  "LEGACY_TRACKING_ASSET_DOWNLOAD_REQUEST";
export const TRACKING_ASSET_DOWNLOAD_SUCCEDDED =
  "LEGACY_TRACKING_ASSET_DOWNLOAD_SUCCEDDED";
export const TRACKING_ASSET_DOWNLOAD_FAILED = "LEGACY_TRACKING_ASSET_DOWNLOAD_FAILED";

export const SORT_STREAM_CHILDREN = "LEGACY_SORT_STREAM_CHILDREN";
export const SORT_GROUP_CHILDREN = "LEGACY_SORT_GROUP_CHILDREN";
export const SORT_STREAM_CHILDREN_BY_TYPE = "LEGACY_SORT_STREAM_CHILDREN_BY_TYPE";
export const SORT_GROUP_CHILDREN_BY_TYPE = "LEGACY_SORT_GROUP_CHILDREN_BY_TYPE";
export const SORT_UNCATEGORIZED_COLLECTION_CHILDREN =
  "LEGACY_SORT_UNCATEGORIZED_COLLECTION_CHILDREN";
export const TOGGLE_STREAM_LIST_VIEW = "LEGACY_TOGGLE_STREAM_LIST_VIEW";

//Generate link asset
export const GENERATE_ASSET_LINK_REQUEST = "LEGACY_GENERATE_ASSET_LINK_REQUEST";
export const GENERATE_ASSET_LINK_SUCCEDDED = "LEGACY_GENERATE_ASSET_LINK_SUCCEDDED";
export const GENERATE_ASSET_LINK_FAILED = "LEGACY_GENERATE_ASSET_LINK_FAILED";

export const FETCHING_ASSET_LINKS_REQUEST = "LEGACY_FETCHING_ASSET_LINKS_REQUEST";
export const FETCHING_ASSET_LINKS_SUCCEDDED = "LEGACY_FETCHING_ASSET_LINKS_SUCCEDDED";
export const FETCHING_ASSET_LINKS_FAILED = "LEGACY_FETCHING_ASSET_LINKS_FAILED";

//Analytics events
export const RECORDING_ASSET_SESSION_EVENT_REQUEST =
  "LEGACY_RECORDING_ASSET_SESSION_EVENT_REQUEST";
export const RECORDING_ASSET_SESSION_EVENT_SUCCEDDED =
  "LEGACY_RECORDING_ASSET_SESSION_EVENT_SUCCEDDED";
export const RECORDING_ASSET_SESSION_EVENT_FAILED =
  "LEGACY_RECORDING_ASSET_SESSION_EVENT_FAILED";

export const RECORDING_ASSET_ANALYTICS_EVENT_REQUEST =
  "LEGACY_RECORDING_ASSET_ANALYTICS_EVENT_REQUEST";
export const RECORDING_ASSET_ANALYTICS_EVENT_SUCCEDDED =
  "LEGACY_RECORDING_ASSET_ANALYTICS_EVENT_SUCCEDDED";
export const RECORDING_ASSET_ANALYTICS_EVENT_FAILED =
  "LEGACY_RECORDING_ASSET_ANALYTICS_EVENT_FAILED";

// Video Analytics
export const CAPTURED_ASSET_VIDEO_NEW_RANGE = "LEGACY_CAPTURED_ASSET_VIDEO_NEW_RANGE";
export const UPDATED_ASSET_VIDEO_RANGE = "LEGACY_UPDATED_ASSET_VIDEO_RANGE";
export const REMOVED_ASSET_VIDEO_RANGE = "LEGACY_REMOVED_ASSET_VIDEO_RANGE";
export const SYNCING_ASSET_VIEW_RANGE_REQUEST =
  "LEGACY_SYNCING_ASSET_VIEW_RANGE_REQUEST";
export const SYNCING_ASSET_VIEW_RANGE_SUCCEDDED =
  "LEGACY_SYNCING_ASSET_VIEW_RANGE_SUCCEDDED";
export const SYNCING_ASSET_VIEW_RANGE_FAILED =
  "LEGACY_SYNCING_ASSET_VIEW_RANGE_FAILED";

//My Collections
export const FETCHING_MYCOLLECTION_FOLIOS = "LEGACY_FETCHING_MYCOLLECTION_FOLIOS";
export const FETCHING_MYCOLLECTION_FOLIOS_SUCCEDDED =
  "LEGACY_FETCHING_MYCOLLECTION_FOLIOS_SUCCEDDED";
export const FETCHING_MYCOLLECTION_FOLIOS_FAILED =
  "LEGACY_FETCHING_MYCOLLECTION_FOLIOS_FAILED";
export const INVALIDATE_MYCOLLECTION_FOLIOS = "LEGACY_INVALIDATE_MYCOLLECTION_FOLIOS";
export const INVALIDATE_FILTERED_MYCOLLECTION_FOLIOS =
  "LEGACY_INVALIDATE_FILTERED_MYCOLLECTION_FOLIOS";

export const FETCHING_MYCOLLECTION_SUBSCRIPTIONS =
  "LEGACY_FETCHING_MYCOLLECTION_SUBSCRIPTIONS";
export const FETCHING_MYCOLLECTION_SUBSCRIPTIONS_SUCCEDDED =
  "LEGACY_FETCHING_MYCOLLECTION_SUBSCRIPTIONS_SUCCEDDED";
export const FETCHING_MYCOLLECTION_SUBSCRIPTIONS_FAILED =
  "LEGACY_FETCHING_MYCOLLECTION_SUBSCRIPTIONS_FAILED";
export const INVALIDATE_MYCOLLECTION_SUBSCRIPTIONS =
  "LEGACY_INVALIDATE_MYCOLLECTION_SUBSCRIPTIONS";

export const FETCHING_MYCOLLECTION_FAVOURITES =
  "LEGACY_FETCHING_MYCOLLECTION_FAVOURITES";
export const FETCHING_MYCOLLECTION_FAVOURITES_SUCCEDDED =
  "LEGACY_FETCHING_MYCOLLECTION_FAVOURITES_SUCCEDDED";
export const FETCHING_MYCOLLECTION_FAVOURITES_FAILED =
  "LEGACY_FETCHING_MYCOLLECTION_FAVOURITES_FAILED";
export const INVALIDATE_MYCOLLECTION_FAVOURITES =
  "LEGACY_INVALIDATE_MYCOLLECTION_FAVOURITES";

export const FOLIO_INITIALIZE_ASSET_SELECTION =
  "LEGACY_FOLIO_INITIALIZE_ASSET_SELECTION";
export const FOLIO_TOGGLE_ASSET_SELECTION = "LEGACY_FOLIO_TOGGLE_ASSET_SELECTION";
export const FOLIO_INVALIDATE_ASSET_SELECTION =
  "LEGACY_FOLIO_INVALIDATE_ASSET_SELECTION";

export const CREATING_FOLIO_REQUEST = "LEGACY_CREATING_FOLIO_REQUEST";
export const CREATING_FOLIO_SUCCEDDED = "LEGACY_CREATING_FOLIO_SUCCEDDED";
export const CREATING_FOLIO_FAILED = "LEGACY_CREATING_FOLIO_FAILED";

export const UPDATING_FOLIO_REQUEST = "LEGACY_UPDATING_FOLIO_REQUEST";
export const UPDATING_FOLIO_SUCCEDDED = "LEGACY_UPDATING_FOLIO_SUCCEDDED";
export const UPDATING_FOLIO_FAILED = "LEGACY_UPDATING_FOLIO_FAILED";

export const DELETING_FOLIO_REQUEST = "LEGACY_DELETING_FOLIO_REQUEST";
export const DELETING_FOLIO_SUCCEDDED = "LEGACY_DELETING_FOLIO_SUCCEDDED";
export const DELETING_FOLIO_FAILED = "LEGACY_DELETING_FOLIO_FAILED";

export const FETCHING_FOLIO_REQUEST = "LEGACY_FETCHING_FOLIO_REQUEST";
export const FETCHING_FOLIO_SUCCEDDED = "LEGACY_FETCHING_FOLIO_SUCCEDDED";
export const FETCHING_FOLIO_FAILED = "LEGACY_FETCHING_FOLIO_FAILED";
export const INVALIDATE_FOLIO = "LEGACY_INVALIDATE_FOLIO";

export const TOGGLE_EDIT_FOLIO_REQUEST = "LEGACY_TOGGLE_EDIT_FOLIO_REQUEST";
export const FOLIO_ADD_ASSETS = "LEGACY_FOLIO_ADD_ASSETS";
export const FOLIO_REMOVE_ASSETS = "LEGACY_FOLIO_REMOVE_ASSETS";
export const FOLIO_UPDATE_NAME = "LEGACY_FOLIO_UPDATE_NAME";
export const FOLIO_MOVE_ASSETS = "LEGACY_FOLIO_MOVE_ASSETS";

export const FOLIO_UPLOADING_ASSET_REQUEST = "LEGACY_FOLIO_UPLOADING_ASSET_REQUEST";
export const FOLIO_UPLOADING_ASSET_SUCCEDDED =
  "LEGACY_FOLIO_UPLOADING_ASSET_SUCCEDDED";
export const FOLIO_UPLOADING_ASSET_FAILED = "LEGACY_FOLIO_UPLOADING_ASSET_FAILED";
export const FOLIO_UPLOADING_ASSET_PROGRESS = "LEGACY_FOLIO_UPLOADING_ASSET_PROGRESS";
export const FOLIO_CANCELING_UPLOAD_ASSET = "LEGACY_FOLIO_CANCELING_UPLOAD_ASSET";
export const FOLIO_ADD_ASSET_SELECTION = "LEGACY_FOLIO_ADD_ASSET_SELECTION";
export const FOLIO_REMOVE_ASSET_SELECTION = "LEGACY_FOLIO_REMOVE_ASSET_SELECTION";

export const GENERATE_COLLECTION_LINK_REQUEST =
  "LEGACY_GENERATE_COLLECTION_LINK_REQUEST";
export const GENERATE_COLLECTION_LINK_SUCCEDDED =
  "LEGACY_GENERATE_COLLECTION_LINK_SUCCEDDED";
export const GENERATE_COLLECTION_LINK_FAILED =
  "LEGACY_GENERATE_COLLECTION_LINK_FAILED";

export const UPDATE_COLLECTION_LINK_REQUEST = "LEGACY_UPDATE_COLLECTION_LINK_REQUEST";
export const UPDATE_COLLECTION_LINK_SUCCEDDED =
  "LEGACY_UPDATE_COLLECTION_LINK_SUCCEDDED";
export const UPDATE_COLLECTION_LINK_FAILED = "LEGACY_UPDATE_COLLECTION_LINK_FAILED";

export const FETCHING_COLLECTION_LINKS_REQUEST =
  "LEGACY_FETCHING_COLLECTION_LINKS_REQUEST";
export const FETCHING_COLLECTION_LINKS_SUCCEDDED =
  "LEGACY_FETCHING_COLLECTION_LINKS_SUCCEDDED";
export const FETCHING_COLLECTION_LINKS_FAILED =
  "LEGACY_FETCHING_COLLECTION_LINKS_FAILED";

export const ADD_ASSET_TO_COLLECTION = "LEGACY_ADD_ASSET_TO_COLLECTION";
export const ADD_ASSET_TO_COLLECTION_SUCCEDDED =
  "LEGACY_ADD_ASSET_TO_COLLECTION_SUCCEDDED";
export const ADD_ASSET_TO_COLLECTION_FAILED = "LEGACY_ADD_ASSET_TO_COLLECTION_FAILED";

export const FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION =
  "LEGACY_FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION";
export const FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_SUCCEDDED =
  "LEGACY_FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_SUCCEDDED";
export const FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_FAILED =
  "LEGACY_FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_FAILED";
export const INVALIDATE_ASSETS_FROM_UNCATEGORIZED_COLLECTION =
  "LEGACY_INVALIDATE_ASSETS_FROM_UNCATEGORIZED_COLLECTION";

export const REMOVE_ASSET_FROM_UNCATEGORIZED_COLLECTION =
  "LEGACY_REMOVE_ASSET_FROM_UNCATEGORIZED_COLLECTION";
export const REMOVE_ASSET_FROM_UNCATEGORIZED_COLLECTION_SUCCEDDED =
  "LEGACY_REMOVE_ASSET_FROM_UNCATEGORIZED_COLLECTION_SUCCEDDED";
export const REMOVE_ASSET_FROM_UNCATEGORIZED_COLLECTION_FAILED =
  "LEGACY_REMOVE_ASSET_FROM_UNCATEGORIZED_COLLECTION_FAILED";

//Collaboration
export const FETCHING_COLLECTION_COLLABORATORS_REQUEST =
  "LEGACY_FETCHING_COLLECTION_COLLABORATORS_REQUEST";
export const FETCHING_COLLECTION_COLLABORATORS_SUCCEDDED =
  "LEGACY_FETCHING_COLLECTION_COLLABORATORS_SUCCEDDED";
export const FETCHING_COLLECTION_COLLABORATORS_FAILED =
  "LEGACY_FETCHING_COLLECTION_COLLABORATORS_FAILED";
export const INVALIDATE_COLLECTION_COLLABORATORS =
  "LEGACY_INVALIDATE_COLLECTION_COLLABORATORS";

export const UPDATING_COLLECTION_COLLABORATORS_REQUEST =
  "LEGACY_UPDATING_COLLECTION_COLLABORATORS_REQUEST";
export const UPDATING_COLLECTION_COLLABORATORS_SUCCEDDED =
  "LEGACY_UPDATING_COLLECTION_COLLABORATORS_SUCCEDDED";
export const UPDATING_COLLECTION_COLLABORATORS_FAILED =
  "LEGACY_UPDATING_COLLECTION_COLLABORATORS_FAILED";

export const TOGGLE_IS_READ_COLLABORATION_ACCESS =
  "LEGACY_TOGGLE_IS_READ_COLLABORATION_ACCESS";
export const TOGGLE_IS_WIRTE_COLLABORATION_ACCESS =
  "LEGACY_TOGGLE_IS_WRITE_COLLABORATION_ACCESS";

//Live Collection
export const UPDATING_COLLECTION_LIVE_STATUS_REQUEST =
  "LEGACY_UPDATING_COLLECTION_LIVE_STATUS_REQUEST";
export const UPDATING_COLLECTION_LIVE_STATUS_SUCCEDDED =
  "LEGACY_UPDATING_COLLECTION_LIVE_STATUS_SUCCEDDED";
export const UPDATING_COLLECTION_LIVE_STATUS_FAILED =
  "LEGACY_UPDATING_COLLECTION_LIVE_STATUS_FAILED";

export const FETCHING_FOLIO_SHARED_CONTACTS_REQUEST =
  "LEGACY_FETCHING_FOLIO_SHARED_CONTACTS_REQUEST";
export const FETCHING_FOLIO_SHARED_CONTACTS_SUCCEDDED =
  "LEGACY_FETCHING_FOLIO_SHARED_CONTACTS_SUCCEDDED";
export const FETCHING_FOLIO_SHARED_CONTACTS_FAILED =
  "LEGACY_FETCHING_FOLIO_SHARED_CONTACTS_FAILED";
export const INVALIDATE_COLLECTION_SHARED_CONTACTS =
  "LEGACY_INVALIDATE_COLLECTION_SHARED_CONTACTS";

//Rolodex
export const FETCHING_ROLODEX_CONTACTS_REQUEST =
  "LEGACY_FETCHING_ROLODEX_CONTACTS_REQUEST";
export const FETCHING_ROLODEX_CONTACTS_SUCCEDDED =
  "LEGACY_FETCHING_ROLODEX_CONTACTS_SUCCEDDED";
export const FETCHING_ROLODEX_CONTACTS_FAILED =
  "LEGACY_FETCHING_ROLODEX_CONTACTS_FAILED";
export const INVALIDATE_ROLODEX_CONTACTS = "LEGACY_INVALIDATE_ROLODEX_CONTACTS";

export const VIEW_CONTACT_REQUEST = "LEGACY_VIEW_CONTACT_REQUEST";
export const INVALIDATE_CONTACT = "LEGACY_INVALIDATE_CONTACT";

export const CREATING_CONTACT_REQUEST = "LEGACY_CREATING_CONTACT_REQUEST";
export const CREATING_CONTACT_SUCCEDDED = "LEGACY_CREATING_CONTACT_SUCCEDDED";
export const CREATING_CONTACT_FAILED = "LEGACY_CREATING_CONTACT_FAILED";

export const UPDATING_CONTACT_REQUEST = "LEGACY_UPDATING_CONTACT_REQUEST";
export const UPDATING_CONTACT_SUCCEDDED = "LEGACY_UPDATING_CONTACT_SUCCEDDED";
export const UPDATING_CONTACT_FAILED = "LEGACY_UPDATING_CONTACT_FAILED";

export const DELETING_CONTACT_REQUEST = "LEGACY_DELETING_CONTACT_REQUEST";
export const DELETING_CONTACT_SUCCEDDED = "LEGACY_DELETING_CONTACT_SUCCEDDED";
export const DELETING_CONTACT_FAILED = "LEGACY_DELETING_CONTACT_FAILED";

export const FETCHING_CONTACT_REQUEST = "LEGACY_FETCHING_CONTACT_REQUEST";
export const FETCHING_CONTACT_SUCCEDDED = "LEGACY_FETCHING_CONTACT_SUCCEDDED";
export const FETCHING_CONTACT_FAILED = "LEGACY_FETCHING_CONTACT_FAILED";

export const FETCHING_NOTIFICATIONS_REQUEST = "LEGACY_FETCHING_NOTIFICATIONS_REQUEST";
export const FETCHING_NOTIFICATIONS_SUCCEDDED = "LEGACY_FETCHING_NOTIFICATIONS_SUCCEDDED";
export const FETCHING_NOTIFICATIONS_FAILED = "LEGACY_FETCHING_NOTIFICATIONS_FAILED";
export const INVALIDATE_NOTIFICATIONS = "LEGACY_INVALIDATE_NOTIFICATIONS";

export const FETCHING_NOTIFICATIONS_COUNT_REQUEST = "LEGACY_FETCHING_NOTIFICATIONS_COUNT_REQUEST";
export const FETCHING_NOTIFICATIONS_COUNT_SUCCEDDED = "LEGACY_FETCHING_NOTIFICATIONS_COUNT_SUCCEDDED";
export const FETCHING_NOTIFICATIONS_COUNT_FAILED = "LEGACY_FETCHING_NOTIFICATIONS_COUNT_FAILED";

export const UPDATING_NOTIFICATIONS_AS_READ = "LEGACY_UPDATING_NOTIFICATIONS_AS_READ";
export const UPDATING_NOTIFICATIONS_AS_READ_SUCCEEDED = "LEGACY_UPDATING_NOTIFICATIONS_AS_READ_SUCCEEDED";
export const UPDATING_NOTIFICATIONS_AS_READ_FAILED = "LEGACY_UPDATING_NOTIFICATIONS_AS_READ_FAILED";

export const DELETE_ALL_NOTIFICATIONS_REQUEST = "LEGACY_DELETE_ALL_NOTIFICATIONS_REQUEST";
export const DELETE_ALL_NOTIFICATIONS_SUCCEEDED = "LEGACY_DELETE_ALL_NOTIFICATIONS_SUCCEEDED";
export const DELETE_ALL_NOTIFICATIONS_FAILED = "LEGACY_DELETE_ALL_NOTIFICATIONS_FAILED";

export const FETCHING_CONTACT_SHARE_REQUEST = "LEGACY_FETCHING_CONTACT_SHARE_REQUEST";
export const FETCHING_CONTACT_SHARE_SUCCEDDED = "LEGACY_FETCHING_CONTACT_SHARE_SUCCEDDED";
export const FETCHING_CONTACT_SHARE_FAILED = "LEGACY_FETCHING_CONTACT_SHARE_FAILED";

export const FETCHING_CONTACT_SHARES_ANALYTICS_REQUEST = "LEGACY_FETCHING_CONTACT_SHARES_ANALYTICS_REQUEST";
export const FETCHING_CONTACT_SHARES_ANALYTICS_SUCCEDDED = "LEGACY_FETCHING_CONTACT_SHARES_ANALYTICS_SUCCEDDED";
export const FETCHING_CONTACT_SHARES_ANALYTICS_FAILED = "LEGACY_FETCHING_CONTACT_SHARES_ANALYTICS_FAILED";

export const FETCHING_CONTACT_ASSET_ANALYTICS_REQUEST = "LEGACY_FETCHING_CONTACT_ASSET_ANALYTICS_REQUEST";
export const FETCHING_CONTACT_ASSET_ANALYTICS_SUCCEDDED = "LEGACY_FETCHING_CONTACT_ASSET_ANALYTICS_SUCCEDDED";
export const FETCHING_CONTACT_ASSET_ANALYTICS_FAILED = "LEGACY_FETCHING_CONTACT_ASSET_ANALYTICS_FAILED";

export const FETCHING_CONTACT_SHARE_SECTION_REQUEST = "LEGACY_FETCHING_CONTACT_SHARE_SECTION_REQUEST";
export const FETCHING_CONTACT_SHARE_SECTION_SUCCEDDED = "LEGACY_FETCHING_CONTACT_SHARE_SECTION_SUCCEDDED";
export const FETCHING_CONTACT_SHARE_SECTION_FAILED = "LEGACY_FETCHING_CONTACT_SHARE_SECTION_FAILED";

export const IMPORTING_CONTACTS_REQUEST = "LEGACY_IMPORTING_CONTACTS_REQUEST";
export const IMPORTING_CONTACTS_SUCCEDDED = "LEGACY_IMPORTING_CONTACTS_SUCCEDDED";
export const IMPORTING_CONTACTS_FAILED = "LEGACY_IMPORTING_CONTACTS_FAILED";

//Search
export const SEARCHING_STREAM = "LEGACY_SEARCHING_STREAM";
export const SEARCHING_STREAM_SUCCEDDED = "LEGACY_SEARCHING_STREAM_SUCCEDDED";
export const SEARCHING_STREAM_FAILED = "LEGACY_SEARCHING_STREAM_FAILED";
export const INVALIDATE_STREAM_SEARCH_RESULT = "LEGACY_INVALIDATE_STREAM_SEARCH_RESULT";

export const SEARCHING_GROUP = "LEGACY_SEARCHING_GROUP";
export const SEARCHING_GROUP_SUCCEDDED = "LEGACY_SEARCHING_GROUP_SUCCEDDED";
export const SEARCHING_GROUP_FAILED = "LEGACY_SEARCHING_GROUP_FAILED";
export const INVALIDATE_GROUP_SEARCH_RESULT = "LEGACY_INVALIDATE_GROUP_SEARCH_RESULT";

export const SEARCHING_ASSET = "LEGACY_SEARCHING_ASSET";
export const SEARCHING_ASSET_SUCCEDDED = "LEGACY_SEARCHING_ASSET_SUCCEDDED";
export const SEARCHING_ASSET_FAILED = "LEGACY_SEARCHING_ASSET_FAILED";
export const INVALIDATE_ASSET_SEARCH_RESULT = "LEGACY_INVALIDATE_ASSET_SEARCH_RESULT";

export const SEARCHING_COLLECTION = "LEGACY_SEARCHING_COLLECTION";
export const SEARCHING_COLLECTION_SUCCEDDED = "LEGACY_SEARCHING_COLLECTION_SUCCEDDED";
export const SEARCHING_COLLECTION_FAILED = "LEGACY_SEARCHING_COLLECTION_FAILED";
export const INVALIDATE_COLLECTION_SEARCH_RESULT = "LEGACY_INVALIDATE_COLLECTION_SEARCH_RESULT";

export const SEARCHING_CONTACT = "LEGACY_SEARCHING_CONTACT";
export const SEARCHING_CONTACT_SUCCEDDED = "LEGACY_SEARCHING_CONTACT_SUCCEDDED";
export const SEARCHING_CONTACT_FAILED = "LEGACY_SEARCHING_CONTACT_FAILED";
export const INVALIDATE_CONTACT_SEARCH_RESULT = "LEGACY_INVALIDATE_CONTACT_SEARCH_RESULT";

export const SEARCHING_COMPANIES = "LEGACY_SEARCHING_COMPANIES";
export const SEARCHING_COMPANIES_SUCCEDDED = "LEGACY_SEARCHING_COMPANIES_SUCCEDDED";
export const SEARCHING_COMPANIES_FAILED = "LEGACY_SEARCHING_COMPANIES_FAILED";
export const INVALIDATE_COMPANIES_SEARCH_RESULT = "LEGACY_INVALIDATE_COMPANIES_SEARCH_RESULT";

export const SEARCHING_CONTACT_LIST = "LEGACY_SEARCHING_CONTACT_LIST";
export const SEARCHING_CONTACT_LIST_SUCCEDDED = "LEGACY_SEARCHING_CONTACT_LIST_SUCCEDDED";
export const SEARCHING_CONTACT_LIST_FAILED = "LEGACY_SEARCHING_CONTACT_LIST_FAILED";
export const INVALIDATE_CONTACT_LIST = "LEGACY_INVALIDATE_CONTACT_LIST";

export const SEARCHING_CONTACT_FOR_AUTOCOMPLETE = "LEGACY_SEARCHING_CONTACT_FOR_AUTOCOMPLETE";
export const SEARCHING_CONTACT_FOR_AUTOCOMPLETE_SUCCEDDED = "LEGACY_SEARCHING_CONTACT_FOR_AUTOCOMPLETE_SUCCEDDED";
export const SEARCHING_CONTACT_FOR_AUTOCOMPLETE_FAILED = "LEGACY_SEARCHING_CONTACT_FOR_AUTOCOMPLETE_FAILED";
export const INVALIDATE_AUTOCOMPLETE_CONTACT = "LEGACY_INVALIDATE_AUTOCOMPLETE_CONTACT";

export const FETCHING_TAGS = "LEGACY_FETCHING_TAGS";
export const FETCHING_TAGS_SUCCEDDED = "LEGACY_FETCHING_TAGS_SUCCEDDED";
export const FETCHING_TAGS_FAILED = "LEGACY_FETCHING_TAGS_FAILED";
export const INVALIDATE_TAGS = "LEGACY_INVALIDATE_TAGS";

export const SEARCHING_ASSET_DETAIL = "LEGACY_SEARCHING_ASSET_DETAIL";
export const SEARCHING_ASSET_DETAIL_SUCCEDDED = "LEGACY_SEARCHING_ASSET_DETAIL_SUCCEDDED";
export const SEARCHING_ASSET_DETAIL_FAILED = "LEGACY_SEARCHING_ASSET_DETAIL_FAILED";
export const INVALIDATE_ASSET_DETAIL_SEARCH_RESULT = "LEGACY_INVALIDATE_ASSET_DETAIL_SEARCH_RESULT";

export const SEARCHING_USERS_REQUEST = "LEGACY_SEARCHING_USERS_REQUEST";
export const SEARCHING_USERS_SUCCEDDED = "LEGACY_SEARCHING_USERS_SUCCEDDED";
export const SEARCHING_USERS_FAILED = "LEGACY_SEARCHING_USERS_FAILED";

export const SEARCHING_USER_GROUPS_REQUEST = "LEGACY_SEARCHING_USER_GROUPS_REQUEST";
export const SEARCHING_USER_GROUPS_SUCCEDDED = "LEGACY_SEARCHING_USER_GROUPS_SUCCEDDED";
export const SEARCHING_USER_GROUPS_FAILED = "LEGACY_SEARCHING_USER_GROUPS_FAILED";
export const INVALIDATE_AUTOCOMPLETE_USER_GROUP = "LEGACY_INVALIDATE_AUTOCOMPLETE_USER_GROUP";

export const SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST = "LEGACY_SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST";
export const SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED = "LEGACY_SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED";
export const SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED = "LEGACY_SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED";

export const SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST = "LEGACY_SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST";
export const SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED = "LEGACY_SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED";
export const SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED = "LEGACY_SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED";

export const SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_REQUEST = "LEGACY_SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_REQUEST";
export const SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_SUCCEEDED = "LEGACY_SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_SUCCEEDED";
export const SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_FAILED = "LEGACY_SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_FAILED";

export const SEARCHING_OPPORTUNITY_SHARED_ASSETS_REQUEST = "LEGACY_SEARCHING_OPPORTUNITY_SHARED_ASSETS_REQUEST";
export const SEARCHING_OPPORTUNITY_SHARED_ASSETS_SUCCEEDED = "LEGACY_SEARCHING_OPPORTUNITY_SHARED_ASSETS_SUCCEEDED";
export const SEARCHING_OPPORTUNITY_SHARED_ASSETS_FAILED = "LEGACY_SEARCHING_OPPORTUNITY_SHARED_ASSETS_FAILED";

export const RECORDING_SEARCH_QUERY_REQUEST = "LEGACY_RECORDING_SEARCH_QUERY_REQUEST";
export const RECORDING_SEARCH_QUERY_SUCCEDDED = "LEGACY_RECORDING_SEARCH_QUERY_SUCCEDDED";
export const RECORDING_SEARCH_QUERY_FAILED = "LEGACY_RECORDING_SEARCH_QUERY_FAILED";

export const NOTIFY_CONTENT_MODERATOR_REQUEST = "LEGACY_NOTIFY_CONTENT_MODERATOR_REQUEST";
export const NOTIFYING_CONTENT_MODERATOR_SUCCEEDED = "LEGACY_NOTIFYING_CONTENT_MODERATOR_SUCCEEDED";
export const NOTIFYING_CONTENT_MODERATOR_FAILED = "LEGACY_NOTIFYING_CONTENT_MODERATOR_FAILED";

//DATA SOURCES
export const AUTHENTICATING_DATA_SOURCE_REQUEST = "LEGACY_AUTHENTICATING_DATA_SOURCE_REQUEST";
export const AUTHENTICATING_DATA_SOURCE_SUCCEDDED = "LEGACY_AUTHENTICATING_DATA_SOURCE_SUCCEDDED";
export const AUTHENTICATING_DATA_SOURCE_FAILED = "LEGACY_AUTHENTICATING_DATA_SOURCE_FAILED";

export const FETCHING_DATA_SOURCES_REQUEST = "LEGACY_FETCHING_DATA_SOURCES_REQUEST";
export const FETCHING_DATA_SOURCES_SUCCEDDED = "LEGACY_FETCHING_DATA_SOURCES_SUCCEDDED";
export const FETCHING_DATA_SOURCES_FAILED = "LEGACY_FETCHING_DATA_SOURCES_FAILED";
export const INVALIDATE_DATA_SOURCES = "LEGACY_INVALIDATE_DATA_SOURCES";

export const SYNCRONISE_DATA_SOURCE_REQUEST = "LEGACY_SYNCRONISE_DATA_SOURCE_REQUEST";
export const SYNCRONISE_DATA_SOURCE_SUCCEDDED = "LEGACY_SYNCRONISE_DATA_SOURCE_SUCCEDDED";
export const SYNCRONISE_DATA_SOURCE_FAILED = "LEGACY_SYNCRONISE_DATA_SOURCE_FAILED";
export const INVALIDATE_DATA_SOURCE_SYNC_STATUS = "LEGACY_INVALIDATE_DATA_SOURCE_SYNC_STATUS";

export const DELETING_DATA_SOURCE_REQUEST = "LEGACY_DELETING_DATA_SOURCE_REQUEST";
export const DELETING_DATA_SOURCE_SUCCEDDED = "LEGACY_DELETING_DATA_SOURCE_SUCCEDDED";
export const DELETING_DATA_SOURCE_FAILED = "LEGACY_DELETING_DATA_SOURCE_FAILED";

export const FETCHING_DATA_SOURCE_CHILDREN_REQUEST = "LEGACY_FETCHING_DATA_SOURCE_CHILDREN_REQUEST";
export const FETCHING_DATA_SOURCE_CHILDREN_SUCCEDDED = "LEGACY_FETCHING_DATA_SOURCE_CHILDREN_SUCCEDDED";
export const FETCHING_DATA_SOURCE_CHILDREN_FAILED = "LEGACY_FETCHING_DATA_SOURCE_CHILDREN_FAILED";

export const CREATING_DATA_SOURCE_MAPPING_REQUEST = "LEGACY_CREATING_DATA_SOURCE_MAPPING_REQUEST";
export const CREATING_DATA_SOURCE_MAPPING_SUCCEDDED = "LEGACY_CREATING_DATA_SOURCE_MAPPING_SUCCEDDED";
export const CREATING_DATA_SOURCE_MAPPING_FAILED = "LEGACY_CREATING_DATA_SOURCE_MAPPING_FAILED";

export const FETCHING_DATA_SOURCE_MAPPINGS_REQUEST = "LEGACY_FETCHING_DATA_SOURCE_MAPPINGS_REQUEST";
export const FETCHING_DATA_SOURCE_MAPPINGS_SUCCEDDED = "LEGACY_FETCHING_DATA_SOURCE_MAPPINGS_SUCCEDDED";
export const FETCHING_DATA_SOURCE_MAPPINGS_FAILED = "LEGACY_FETCHING_DATA_SOURCE_MAPPINGS_FAILED";

export const SYNCRONISING_DATA_SOURCE_MAPPING_REQUEST = "LEGACY_SYNCRONISING_DATA_SOURCE_MAPPING_REQUEST";
export const SYNCRONISING_DATA_SOURCE_MAPPING_SUCCEDDED = "LEGACY_SYNCRONISING_DATA_SOURCE_MAPPING_SUCCEDDED";
export const SYNCRONISING_DATA_SOURCE_MAPPING_FAILED = "LEGACY_SYNCRONISING_DATA_SOURCE_MAPPING_FAILED";

export const DELETING_DATA_SOURCE_MAPPING_REQUEST = "LEGACY_DELETING_DATA_SOURCE_MAPPING_REQUEST";
export const DELETING_DATA_SOURCE_MAPPING_SUCCEDDED = "LEGACY_DELETING_DATA_SOURCE_MAPPING_SUCCEDDED";
export const DELETING_DATA_SOURCE_MAPPING_FAILED = "LEGACY_DELETING_DATA_SOURCE_MAPPING_FAILED";
export const INVALIDATE_DATA_SOURCE_DELETION_STATUS = "LEGACY_INVALIDATE_DATA_SOURCE_DELETION_STATUS";

export const FETCHING_DATA_SOURCE_MAPPING_REQUEST = "LEGACY_FETCHING_DATA_SOURCE_MAPPING_REQUEST";
export const FETCHING_DATA_SOURCE_MAPPING_SUCCEDDED = "LEGACY_FETCHING_DATA_SOURCE_MAPPING_SUCCEDDED";
export const FETCHING_DATA_SOURCE_MAPPING_FAILED = "LEGACY_FETCHING_DATA_SOURCE_MAPPING_FAILED";

export const MIGRATE_DATA_SOURCE_REQUEST = "LEGACY_MIGRATE_DATA_SOURCE_REQUEST";
export const MIGRATE_DATA_SOURCE_SUCCEDDED = "LEGACY_MIGRATE_DATA_SOURCE_SUCCEDDED";
export const MIGRATE_DATA_SOURCE_FAILED = "LEGACY_MIGRATE_DATA_SOURCE_FAILED";
export const INVALIDATE_DATA_SOURCE_MIGRATION_STATUS = "LEGACY_INVALIDATE_DATA_SOURCE_MIGRATION_STATUS";

//SIDE WINDOW FOR POPUP
export const OPEN_LEFT_WINDOW = "LEGACY_OPEN_LEFT_WINDOW";
export const CLOSE_LEFT_WINDOW = "LEGACY_CLOSE_LEFT_WINDOW";

//SETTINGS
export const SHOW_SETTINGS_SIDE_MENU = "LEGACY_SHOW_SETTINGS_SIDE_MENU";
export const HIDE_SETTINGS_SIDE_MENU = "LEGACY_HIDE_SETTINGS_SIDE_MENU";

//STREAM ACCESS CONTROL
export const FETCHING_OWNER_STREAMS = "LEGACY_FETCHING_OWNER_STREAMS";
export const FETCHING_OWNER_STREAMS_SUCCEDDED = "LEGACY_FETCHING_OWNER_STREAMS_SUCCEDDED";
export const FETCHING_OWNER_STREAMS_FAILED = "LEGACY_FETCHING_OWNER_STREAMS_FAILED";
export const INVALIDATE_OWNER_STREAMS = "LEGACY_INVALIDATE_OWNER_STREAMS";

export const FETCHING_STREAM_ACCESS_USERS = "LEGACY_FETCHING_STREAM_ACCESS_USERS";
export const FETCHING_STREAM_ACCESS_USERS_SUCCEDDED = "LEGACY_FETCHING_STREAM_ACCESS_USERS_SUCCEDDED";
export const FETCHING_STREAM_ACCESS_USERS_FAILED = "LEGACY_FETCHING_STREAM_ACCESS_USERS_FAILED";
export const SELECT_STREAM_FOR_ACCESS_MANAGEMENT = "LEGACY_SELECT_STREAM_FOR_ACCESS_MANAGEMENT";
export const INVALIDATE_STREAM_ACCESS_USERS = "LEGACY_INVALIDATE_STREAM_ACCESS_USERS";

export const TOGGLE_IS_READ_ALL_ACCESS = "LEGACY_TOGGLE_IS_READ_ALL_ACCESS";
export const TOGGLE_IS_WRITE_ALL_ACCESS = "LEGACY_TOGGLE_IS_WRITE_ALL_ACCESS";

export const TOGGLE_IS_READ_USER_ACCESS = "LEGACY_TOGGLE_IS_READ_USER_ACCESS";
export const TOGGLE_IS_WRITE_USER_ACCESS = "LEGACY_TOGGLE_IS_WRITE_USER_ACCESS";

export const UPDATING_STREAM_ACCESS = "LEGACY_UPDATING_STREAM_ACCESS";
export const UPDATING_STREAM_ACCESS_SUCCEDDED = "LEGACY_UPDATING_STREAM_ACCESS_SUCCEDDED";
export const UPDATING_STREAM_ACCESS_FAILED = "LEGACY_UPDATING_STREAM_ACCESS_FAILED";

//USER MANAGEMENT
export const FETCHING_USERS_REQUEST = "LEGACY_FETCHING_USERS_REQUEST";
export const FETCHING_USERS_SUCCEDDED = "LEGACY_FETCHING_USERS_SUCCEDDED";
export const FETCHING_USERS_FAILED = "LEGACY_FETCHING_USERS_FAILED";
export const INVALIDATE_USERS = "LEGACY_INVALIDATE_USERS";

export const FETCHING_INVITATIONS_REQUEST = "LEGACY_FETCHING_INVITATIONS_REQUEST";
export const FETCHING_INVITATIONS_SUCCEDDED = "LEGACY_FETCHING_INVITATIONS_SUCCEDDED";
export const FETCHING_INVITATIONS_FAILED = "LEGACY_FETCHING_INVITATIONS_FAILED";

export const SELECT_USER = "LEGACY_SELECT_USER";
export const INVALIDATE_USER = "LEGACY_INVALIDATE_USER";

export const INVITE_USER_REQUEST = "LEGACY_INVITE_USER_REQUEST";
export const INIVITE_USER_SUCCEDDED = "LEGACY_INIVITE_USER_SUCCEDDED";
export const INIVITE_USER_FAILED = "LEGACY_INIVITE_USER_FAILED";
export const INVALIDATE_ERROR_MESSAGE = "LEGACY_INVALIDATE_ERROR_MESSAGE";

export const UPDATE_USER_ACTIVATION = "LEGACY_UPDATE_USER_ACTIVATION";
export const UPDATE_USER_ACTIVATION_SUCCEDDED = "LEGACY_UPDATE_USER_ACTIVATION_SUCCEDDED";
export const UPDATE_USER_ACTIVATION_FAILED = "LEGACY_UPDATE_USER_ACTIVATION_FAILED";

export const UPDATE_USER_ACCESS = "LEGACY_UPDATE_USER_ACCESS";
export const UPDATE_USER_ACCESS_SUCCEEDED = "LEGACY_UPDATE_USER_ACCESS_SUCCEEDED";
export const UPDATE_USER_ACCESS_FAILED = "LEGACY_UPDATE_USER_ACCESS_FAILED";

export const UPDATE_USER_ROLES = "LEGACY_UPDATE_USER_ROLES";
export const UPDATE_USER_ROLES_SUCCEEDED = "LEGACY_UPDATE_USER_ROLES_SUCCEEDED";
export const UPDATE_USER_ROLES_FAILED = "LEGACY_UPDATE_USER_ROLES_FAILED";

export const RESEND_USER_INVITATION = "LEGACY_RESEND_USER_INVITATION";
export const RESEND_USER_INVITATION_SUCCEDDED = "LEGACY_RESEND_USER_INVITATION_SUCCEDDED";
export const RESEND_USER_INVITATION_FAILED = "LEGACY_RESEND_USER_INVITATION_FAILED";

export const DELETE_USER_INVITATION = "LEGACY_DELETE_USER_INVITATION";
export const DELETE_USER_INVITATION_SUCCEDDED = "LEGACY_DELETE_USER_INVITATION_SUCCEDDED";
export const DELETE_USER_INVITATION_FAILED = "LEGACY_DELETE_USER_INVITATION_FAILED";

export const FETCHING_ACTIVE_USERS_COUNT = "LEGACY_FETCHING_ACTIVE_USERS_COUNT";
export const FETCHING_ACTIVE_USERS_COUNT_SUCCEEDED = "LEGACY_FETCHING_ACTIVE_USERS_COUNT_SUCCEEDED";
export const FETCHING_ACTIVE_USERS_COUNT_FAILED = "LEGACY_FETCHING_ACTIVE_USERS_COUNT_FAILED";

//Integrations
export const FETCHING_INTEGRATIONS_REQUEST = "LEGACY_FETCHING_INTEGRATIONS_REQUEST";
export const FETCHING_INTEGRATIONS_SUCCEDDED = "LEGACY_FETCHING_INTEGRATIONS_SUCCEDDED";
export const FETCHING_INTEGRATIONS_FAILED = "LEGACY_FETCHING_INTEGRATIONS_FAILED";
export const INVALIDATE_INTEGRATIONS = "LEGACY_INVALIDATE_INTEGRATIONS";

export const FETCHING_INTEGRATION_REQUEST = "LEGACY_FETCHING_INTEGRATION_REQUEST";
export const FETCHING_INTEGRATION_SUCCEDDED = "LEGACY_FETCHING_INTEGRATION_SUCCEDDED";
export const FETCHING_INTEGRATION_FAILED = "LEGACY_FETCHING_INTEGRATION_FAILED";

export const ACTIVATING_INTEGRATION_SUCCEDDED = "LEGACY_ACTIVATING_INTEGRATION_SUCCEDDED";
export const SYNCHRONISING_INTEGRATION_SUCCEDDED = "LEGACY_SYNCHRONISING_INTEGRATION_SUCCEDDED";

export const DEACTIVATING_INTEGRATION_REQUEST = "LEGACY_DEACTIVATING_INTEGRATION_REQUEST";
export const DEACTIVATING_INTEGRATION_SUCCEDDED = "LEGACY_DEACTIVATING_INTEGRATION_SUCCEDDED";
export const DEACTIVATING_INTEGRATION_FAILED = "LEGACY_DEACTIVATING_INTEGRATION_FAILED";


//hubspot new integration
export const FETCHING_HUBSPOT_INTEGRATION_REQUEST = "LEGACY_FETCHING_HUBSPOT_INTEGRATION_REQUEST";
export const FETCHING_HUBSPOT_INTEGRATION_REQUEST_SUCCEDDED = "LEGACY_FETCHING_HUBSPOT_INTEGRATION_REQUEST_SUCCEDDED";
export const FETCHING_HUBSPOT_INTEGRATION_REQUEST_FAILED = "LEGACY_FETCHING_HUBSPOT_INTEGRATION_REQUEST_FAILED";

export const DEACTIVATING_HUBSPOT_INTEGRATION = "LEGACY_DEACTIVATING_HUBSPOT_INTEGRATION";
export const DEACTIVATING_HUBSPOT_INTEGRATION_SUCCEDDED = "LEGACY_DEACTIVATING_HUBSPOT_INTEGRATION_SUCCEDDED";
export const DEACTIVATING_HUBSPOT_INTEGRATION_FAILED = "LEGACY_DEACTIVATING_HUBSPOT_INTEGRATION_FAILED";

export const DELETING_SECONDARY_CONFIGURATION = "LEGACY_DELETING_SECONDARY_CONFIGURATION";
export const DELETING_SECONDARY_CONFIGURATION_SUCCEEDED= "LEGACY_DELETING_SECONDARY_CONFIGURATION_SUCCEEDED";
export const DELETING_SECONDARY_CONFIGURATION_FAILED = "LEGACY_DELETING_SECONDARY_CONFIGURATION_FAILED";

export const FETCHING_TOTAL_HUBSPOT_INTEGRATIONS = "LEGACY_FETCHING_TOTAL_HUBSPOT_INTEGRATIONS";
export const FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_SUCCEEDED = "LEGACY_FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_SUCCEEDED";
export const FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_FAILED = "LEGACY_FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_FAILED";

export const INTEGRATION_AUTH_EXPIRED = "LEGACY_INTEGRATION_AUTH_EXPIRED";

export const FETCHING_INTEGRATION_CONTACTS = "LEGACY_FETCHING_INTEGRATION_CONTACTS";
export const FETCHING_INTEGRATION_CONTACTS_SUCCEEDED = "LEGACY_FETCHING_INTEGRATION_CONTACTS_SUCCEEDED";
export const FETCHING_INTEGRATION_CONTACTS_FAILED = "LEGACY_FETCHING_INTEGRATION_CONTACTS_FAILED";

export const INVALIDATE_INTEGRATION_CONTACTS = "LEGACY_INVALIDATE_INTEGRATION_CONTACTS";

export const FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST = "LEGACY_FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST";
export const FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEDDED = "LEGACY_FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEDDED";
export const FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED = "LEGACY_FETCHING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED";

export const FETCHING_INTEGRATION_CUSTOM_FIELDS_REQUEST = "LEGACY_FETCHING_INTEGRATION_CUSTOM_FIELDS_REQUEST";
export const FETCHING_INTEGRATION_CUSTOM_FIELDS_SUCCEDDED = "LEGACY_FETCHING_INTEGRATION_CUSTOM_FIELDS_SUCCEDDED";
export const FETCHING_INTEGRATION_CUSTOM_FIELDS_FAILED = "LEGACY_FETCHING_INTEGRATION_CUSTOM_FIELDS_FAILED";

export const SAVING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST = "LEGACY_SAVING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST";
export const SAVING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED = "LEGACY_SAVING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED";
export const SAVING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED = "LEGACY_SAVING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED";

export const SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST = "LEGACY_SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_REQUEST";
export const SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED = "LEGACY_SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_SUCCEEDED";
export const SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED = "LEGACY_SYNCING_INTEGRATION_OPPORTUNITY_FIELDS_FAILED";

export const DELETING_INTEGRATION_CUSTOM_FIELDS_REQUEST = "LEGACY_DELETING_INTEGRATION_CUSTOM_FIELDS_REQUEST";
export const DELETING_INTEGRATION_CUSTOM_FIELDS_SUCCEEDED = "LEGACY_DELETING_INTEGRATION_CUSTOM_FIELDS_SUCCEEDED";
export const DELETING_INTEGRATION_CUSTOM_FIELDS_FAILED = "LEGACY_DELETING_INTEGRATION_CUSTOM_FIELDS_FAILED";

export const SAVING_FRESHSALES_REQUEST = "LEGACY_SAVING_FRESHSALES_REQUEST";
export const SAVING_FRESHSALES_SUCCEDDED = "LEGACY_SAVING_FRESHSALES_SUCCEDDED";
export const SAVING_FRESHSALES_FAILED = "LEGACY_SAVING_FRESHSALES_FAILED";

export const FETCHING_FRESHSALES_INTEGRATION_REQUEST =
  "LEGACY_FETCHING_FRESHSALES_INTEGRATION_REQUEST";
export const FETCHING_FRESHSALES_INTEGRATION_SUCCEDDED =
  "LEGACY_FETCHING_FRESHSALES_INTEGRATION_SUCCEDDED";
export const FETCHING_FRESHSALES_INTEGRATION_FAILED =
  "LEGACY_FETCHING_FRESHSALES_INTEGRATION_FAILED";

//suitecrm Integration
export const AUTHENTICATING_SUITECRM_REQUEST =
  "LEGACY_AUTHENTICATING_SUITECRM_REQUEST";
export const AUTHENTICATING_SUITECRM_SUCCEDDED =
  "LEGACY_AUTHENTICATING_SUITECRM_SUCCEDDED";
export const AUTHENTICATING_SUITECRM_FAILED = "LEGACY_AUTHENTICATING_SUITECRM_FAILED";

export const UPDATING_SUITECRM_REQUEST = "LEGACY_UPDATING_SUITECRM_REQUEST";
export const UPDATING_SUITECRM_SUCCEDDED = "LEGACY_UPDATING_SUITECRM_SUCCEDDED";
export const UPDATING_SUITECRM_FAILED = "LEGACY_UPDATING_SUITECRM_FAILED";

export const SYNCHRONISING_SUITECRM_REQUEST = "LEGACY_SYNCHRONISING_SUITECRM_REQUEST";
export const SYNCHRONISING_SUITECRM_SUCCEDDED =
  "LEGACY_SYNCHRONISING_SUITECRM_SUCCEDDED";
export const SYNCHRONISING_SUITECRM_FAILED = "LEGACY_SYNCHRONISING_SUITECRM_FAILED";

export const FETCHING_SUITECRM_SYNC_DETAILS_REQUEST =
  "LEGACY_FETCHING_SUITECRM_SYNC_DETAILS_REQUEST";
export const FETCHING_SUITECRM_SYNC_DETAILS_SUCCEDDED =
  "LEGACY_FETCHING_SUITECRM_SYNC_DETAILS_SUCCEDDED";
export const FETCHING_SUITECRM_SYNC_DETAILS_FAILED =
  "LEGACY_FETCHING_SUITECRM_SYNC_DETAILS_FAILED";

export const FETCHING_SUITECRM_MASTER_CONFIG_REQUEST =
  "LEGACY_FETCHING_SUITECRM_MASTER_CONFIG_REQUEST";
export const FETCHING_SUITECRM_MASTER_CONFIG_SUCCEDDED =
  "LEGACY_FETCHING_SUITECRM_MASTER_CONFIG_SUCCEDDED";
export const FETCHING_SUITECRM_MASTER_CONFIG_FAILED =
  "LEGACY_FETCHING_SUITECRM_MASTER_CONFIG_FAILED";

//hubspot Integration
export const AUTHENTICATING_HUBSPOT_REQUEST = "LEGACY_AUTHENTICATING_HUBSPOT_REQUEST";
export const AUTHENTICATING_HUBSPOT_SUCCEDDED =
  "LEGACY_AUTHENTICATING_HUBSPOT_SUCCEDDED";
export const AUTHENTICATING_HUBSPOT_FAILED = "LEGACY_AUTHENTICATING_HUBSPOT_FAILED";

export const UPDATING_HUBSPOT_REQUEST = "LEGACY_UPDATING_HUBSPOT_REQUEST";
export const UPDATING_HUBSPOT_SUCCEDDED = "LEGACY_UPDATING_HUBSPOT_SUCCEDDED";
export const UPDATING_HUBSPOT_FAILED = "LEGACY_UPDATING_HUBSPOT_FAILED";

//slack Integration
export const AUTHENTICATING_SLACK_REQUEST = "LEGACY_AUTHENTICATING_SLACK_REQUEST";
export const AUTHENTICATING_SLACK_SUCCEDDED = "LEGACY_AUTHENTICATING_SLACK_SUCCEDDED";
export const AUTHENTICATING_SLACK_FAILED = "LEGACY_AUTHENTICATING_SLACK_FAILED";

export const UPDATING_SLACK_REQUEST = "LEGACY_UPDATING_SLACK_REQUEST";
export const UPDATING_SLACK_SUCCEDDED = "LEGACY_UPDATING_SLACK_SUCCEDDED";
export const UPDATING_SLACK_FAILED = "LEGACY_UPDATING_SLACK_FAILED";

//pipedrive Integration
export const AUTHENTICATING_PIPEDRIVE_REQUEST =
  "LEGACY_AUTHENTICATING_PIPEDRIVE_REQUEST";
export const AUTHENTICATING_PIPEDRIVE_SUCCEDDED =
  "LEGACY_AUTHENTICATING_PIPEDRIVE_SUCCEDDED";
export const AUTHENTICATING_PIPEDRIVE_FAILED =
  "LEGACY_AUTHENTICATING_PIPEDRIVE_FAILED";

export const FETCHING_PIPEDRIVE_MASTER_CONFIG_REQUEST =
  "LEGACY_FETCHING_PIPEDRIVE_MASTER_CONFIG_REQUEST";
export const FETCHING_PIPEDRIVE_MASTER_CONFIG_SUCCEDDED =
  "LEGACY_FETCHING_PIPEDRIVE_MASTER_CONFIG_SUCCEDDED";
export const FETCHING_PIPEDRIVE_MASTER_CONFIG_FAILED =
  "LEGACY_FETCHING_PIPEDRIVE_MASTER_CONFIG_FAILED";

export const UPDATING_PIPEDRIVE_REQUEST = "LEGACY_UPDATING_PIPEDRIVE_REQUEST";
export const UPDATING_PIPEDRIVE_SUCCEDDED = "LEGACY_UPDATING_PIPEDRIVE_SUCCEDDED";
export const UPDATING_PIPEDRIVE_FAILED = "LEGACY_UPDATING_PIPEDRIVE_FAILED";

export const SYNCHRONISING_PIPEDRIVE_REQUEST =
  "LEGACY_SYNCHRONISING_PIPEDRIVE_REQUEST";
export const SYNCHRONISING_PIPEDRIVE_SUCCEDDED =
  "LEGACY_SYNCHRONISING_PIPEDRIVE_SUCCEDDED";
export const SYNCHRONISING_PIPEDRIVE_FAILED = "LEGACY_SYNCHRONISING_PIPEDRIVE_FAILED";

export const FETCHING_PIPEDRIVE_SYNC_DETAILS_REQUEST =
  "LEGACY_FETCHING_PIPEDRIVE_SYNC_DETAILS_REQUEST";
export const FETCHING_PIPEDRIVE_SYNC_DETAILS_SUCCEDDED =
  "LEGACY_FETCHING_PIPEDRIVE_SYNC_DETAILS_SUCCEDDED";
export const FETCHING_PIPEDRIVE_SYNC_DETAILS_FAILED =
  "LEGACY_FETCHING_PIPEDRIVE_SYNC_DETAILS_FAILED";

//salesforce Integration
export const AUTHENTICATING_SALESFORCE_REQUEST =
  "LEGACY_AUTHENTICATING_SALESFORCE_REQUEST";
export const AUTHENTICATING_SALESFORCE_SUCCEDDED =
  "LEGACY_AUTHENTICATING_SALESFORCE_SUCCEDDED";
export const AUTHENTICATING_SALESFORCE_FAILED =
  "LEGACY_AUTHENTICATING_SALESFORCE_FAILED";

export const UPDATING_SALESFORCE_REQUEST = "LEGACY_UPDATING_SALESFORCE_REQUEST";
export const UPDATING_SALESFORCE_SUCCEDDED = "LEGACY_UPDATING_SALESFORCE_SUCCEDDED";
export const UPDATING_SALESFORCE_FAILED = "LEGACY_UPDATING_SALESFORCE_FAILED";

export const FETCHING_SALESFORCE_INTEGRATION_REQUEST =
  "LEGACY_FETCHING_SALESFORCE_INTEGRATION_REQUEST";
export const FETCHING_SALESFORCE_INTEGRATION_SUCCEDDED =
  "LEGACY_FETCHING_SALESFORCE_INTEGRATION_SUCCEDDED";
export const FETCHING_SALESFORCE_INTEGRATION_FAILED =
  "LEGACY_FETCHING_SALESFORCE_INTEGRATION_FAILED";

export const DEACTIVATING_SALESFORCE_INTEGRATION_REQUEST = "LEGACY_DEACTIVATING_SALESFORCE_INTEGRATION_REQUEST";
export const DEACTIVATING_SALESFORCE_INTEGRATION_SUCCEDDED = "LEGACY_DEACTIVATING_SALESFORCE_INTEGRATION_SUCCEDDED";
export const DEACTIVATING_SALESFORCE_INTEGRATION_FAILED = "LEGACY_DEACTIVATING_SALESFORCE_INTEGRATION_FAILED";


// salesforce sandbox integration
export const AUTHENTICATING_SALESFORCE_SANDBOX_REQUEST =
  "LEGACY_AUTHENTICATING_SALESFORCE_SANDBOX_REQUEST";
export const AUTHENTICATING_SALESFORCE_SANDBOX_SUCCEDDED =
  "LEGACY_AUTHENTICATING_SALESFORCE_SANDBOX_SUCCEDDED";
export const AUTHENTICATING_SALESFORCE_SANDBOX_FAILED =
  "LEGACY_AUTHENTICATING_SALESFORCE_SANDBOX_FAILED";

export const UPDATING_SALESFORCE_SANDBOX_REQUEST = "LEGACY_UPDATING_SALESFORCE_SANDBOX_REQUEST";
export const UPDATING_SALESFORCE_SANDBOX_SUCCEDDED = "LEGACY_UPDATING_SALESFORCE_SANDBOX_SUCCEDDED";
export const UPDATING_SALESFORCE_SANDBOX_FAILED = "LEGACY_UPDATING_SALESFORCE_SANDBOX_FAILED";

export const FETCHING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST =
  "LEGACY_FETCHING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST";
export const FETCHING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED =
  "LEGACY_FETCHING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED";
export const FETCHING_SALESFORCE_SANDBOX_INTEGRATION_FAILED =
  "LEGACY_FETCHING_SALESFORCE_SANDBOX_INTEGRATION_FAILED";
  
export const DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST = "LEGACY_DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST";
export const DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED = "LEGACY_DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED";
export const DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_FAILED = "LEGACY_DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_FAILED";

//Eloqua Integration
export const AUTHENTICATING_ELOQUA_REQUEST = "LEGACY_AUTHENTICATING_ELOQUA_REQUEST";
export const AUTHENTICATING_ELOQUA_SUCCEDDED =
  "LEGACY_AUTHENTICATING_ELOQUA_SUCCEDDED";
export const AUTHENTICATING_ELOQUA_FAILED = "LEGACY_AUTHENTICATING_ELOQUA_FAILED";

export const FETCHING_ELOQUA_MASTER_CONFIG_REQUEST =
  "LEGACY_FETCHING_ELOQUA_MASTER_CONFIG_REQUEST";
export const FETCHING_ELOQUA_MASTER_CONFIG_SUCCEDDED =
  "LEGACY_FETCHING_ELOQUA_MASTER_CONFIG_SUCCEDDED";
export const FETCHING_ELOQUA_MASTER_CONFIG_FAILED =
  "LEGACY_FETCHING_ELOQUA_MASTER_CONFIG_FAILED";

export const UPDATING_ELOQUA_REQUEST = "LEGACY_UPDATING_ELOQUA_REQUEST";
export const UPDATING_ELOQUA_SUCCEDDED = "LEGACY_UPDATING_ELOQUA_SUCCEDDED";
export const UPDATING_ELOQUA_FAILED = "LEGACY_UPDATING_ELOQUA_FAILED";

export const SYNCHRONISING_ELOQUA_REQUEST = "LEGACY_SYNCHRONISING_ELOQUA_REQUEST";
export const SYNCHRONISING_ELOQUA_SUCCEDDED = "LEGACY_SYNCHRONISING_ELOQUA_SUCCEDDED";
export const SYNCHRONISING_ELOQUA_FAILED = "LEGACY_SYNCHRONISING_ELOQUA_FAILED";

export const FETCHING_ELOQUA_SYNC_DETAILS_REQUEST =
  "LEGACY_FETCHING_ELOQUA_SYNC_DETAILS_REQUEST";
export const FETCHING_ELOQUA_SYNC_DETAILS_SUCCEDDED =
  "LEGACY_FETCHING_ELOQUA_SYNC_DETAILS_SUCCEDDED";
export const FETCHING_ELOQUA_SYNC_DETAILS_FAILED =
  "LEGACY_FETCHING_ELOQUA_SYNC_DETAILS_FAILED";

//outlook Integration
export const AUTHENTICATING_EMAIL_REQUEST = "LEGACY_AUTHENTICATING_EMAIL_REQUEST";
export const AUTHENTICATING_EMAIL_SUCCEDDED = "LEGACY_AUTHENTICATING_EMAIL_SUCCEDDED";
export const AUTHENTICATING_EMAIL_FAILED = "LEGACY_AUTHENTICATING_EMAIL_FAILED";

//klenty Integration
export const AUTHENTICATING_KLENTY_REQUEST = "LEGACY_AUTHENTICATING_KLENTY_REQUEST";
export const AUTHENTICATING_KLENTY_SUCCEDDED =
  "LEGACY_AUTHENTICATING_KLENTY_SUCCEDDED";
export const AUTHENTICATING_KLENTY_FAILED = "LEGACY_AUTHENTICATING_KLENTY_FAILED";

//Intercom Integration
export const ACTIVATING_INTERCOM_REQUEST = "LEGACY_ACTIVATING_INTERCOM_REQUEST";
export const ACTIVATING_INTERCOM_SUCCEDDED = "LEGACY_ACTIVATING_INTERCOM_SUCCEDDED";
export const ACTIVATING_INTERCOM_FAILED = "LEGACY_ACTIVATING_INTERCOM_FAILED";


export const UPDATING_INTERCOM_REQUEST = "LEGACY_UPDATING_INTERCOM_REQUEST";
export const UPDATING_INTERCOM_SUCCEDDED = "LEGACY_UPDATING_INTERCOM_SUCCEDDED";
export const UPDATING_INTERCOM_FAILED = "LEGACY_UPDATING_INTERCOM_FAILED";

export const ACTIVATING_CHAT_INTEGRATION_REQUEST =
  "LEGACY_ACTIVATING_CHAT_INTEGRATION_REQUEST";
export const ACTIVATING_CHAT_INTEGRATION_SUCCEDDED =
  "LEGACY_ACTIVATING_CHAT_INTEGRATION_SUCCEDDED";
export const ACTIVATING_CHAT_INTEGRATION_FAILED =
  "LEGACY_ACTIVATING_CHAT_INTEGRATION_FAILED";

export const UPDATING_CHAT_INTEGRATION_REQUEST =
  "LEGACY_UPDATING_CHAT_INTEGRATION_REQUEST";
export const UPDATING_CHAT_INTEGRATION_SUCCEDDED =
  "LEGACY_UPDATING_CHAT_INTEGRATION_SUCCEDDED";
export const UPDATING_CHAT_INTEGRATION_FAILED =
  "LEGACY_UPDATING_CHAT_INTEGRATION_FAILED";

//Google analytics Integration
export const ACTIVATING_GOOGLE_ANALYTICS_REQUEST =
  "LEGACY_ACTIVATING_GOOGLE_ANALYTICS_REQUEST";
export const ACTIVATING_GOOGLE_ANALYTICS_SUCCEDDED =
  "LEGACY_ACTIVATING_GOOGLE_ANALYTICS_SUCCEDDED";
export const ACTIVATING_GOOGLE_ANALYTICS_FAILED =
  "LEGACY_ACTIVATING_GOOGLE_ANALYTICS_FAILED";

export const UPDATING_GOOGLE_ANALYTICS_REQUEST =
  "LEGACY_UPDATING_GOOGLE_ANALYTICS_REQUEST";
export const UPDATING_GOOGLE_ANALYTICS_SUCCEDDED =
  "LEGACY_UPDATING_GOOGLE_ANALYTICS_SUCCEDDED";
export const UPDATING_GOOGLE_ANALYTICS_FAILED =
  "LEGACY_UPDATING_GOOGLE_ANALYTICS_FAILED";

// google analytics 4 integration
export const ACTIVATING_GOOGLE_ANALYTICS_4_REQUEST =
  "LEGACY_ACTIVATING_GOOGLE_ANALYTICS_4_REQUEST";
export const ACTIVATING_GOOGLE_ANALYTICS_4_SUCCEDDED =
  "LEGACY_ACTIVATING_GOOGLE_ANALYTICS_4_SUCCEDDED";
export const ACTIVATING_GOOGLE_ANALYTICS_4_FAILED =
  "LEGACY_ACTIVATING_GOOGLE_ANALYTICS_4_FAILED";

export const UPDATING_GOOGLE_ANALYTICS_4_REQUEST =
  "LEGACY_UPDATING_GOOGLE_ANALYTICS_4_REQUEST";
export const UPDATING_GOOGLE_ANALYTICS_4_SUCCEDDED =
  "LEGACY_UPDATING_GOOGLE_ANALYTICS_4_SUCCEDDED";
export const UPDATING_GOOGLE_ANALYTICS_4_FAILED =
  "LEGACY_UPDATING_GOOGLE_ANALYTICS_4_FAILED";

//Six Sense Integration
export const ACTIVATING_SIX_SENSE_REQUEST = "LEGACY_ACTIVATING_SIX_SENSE_REQUEST";
export const ACTIVATING_SIX_SENSE_SUCCEDDED = "LEGACY_ACTIVATING_SIX_SENSE_SUCCEDDED";
export const ACTIVATING_SIX_SENSE_FAILED = "LEGACY_ACTIVATING_SIX_SENSE_FAILED";

export const UPDATING_SIX_SENSE_REQUEST = "LEGACY_UPDATING_SIX_SENSE_REQUEST";
export const UPDATING_SIX_SENSE_SUCCEDDED = "LEGACY_UPDATING_SIX_SENSE_SUCCEDDED";
export const UPDATING_SIX_SENSE_FAILED = "LEGACY_UPDATING_SIX_SENSE_FAILED";

//Google tag manager Integration
export const ACTIVATING_GOOGLE_TAG_MANAGER_REQUEST =
  "LEGACY_ACTIVATING_GOOGLE_TAG_MANAGER_REQUEST";
export const ACTIVATING_GOOGLE_TAG_MANAGER_SUCCEDDED =
  "LEGACY_ACTIVATING_GOOGLE_TAG_MANAGER_SUCCEDDED";
export const ACTIVATING_GOOGLE_TAG_MANAGER_FAILED =
  "LEGACY_ACTIVATING_GOOGLE_TAG_MANAGER_FAILED";

export const UPDATING_GOOGLE_TAG_MANAGER_REQUEST =
  "LEGACY_UPDATING_GOOGLE_TAG_MANAGER_REQUEST";
export const UPDATING_GOOGLE_TAG_MANAGER_SUCCEDDED =
  "LEGACY_UPDATING_GOOGLE_TAG_MANAGER_SUCCEDDED";
export const UPDATING_GOOGLE_TAG_MANAGER_FAILED =
  "LEGACY_UPDATING_GOOGLE_TAG_MANAGER_FAILED";

//Smtp Integration
export const SAVING_SMTP_EMAIL_REQUEST = "LEGACY_SAVING_SMTP_EMAIL_REQUEST";
export const SAVING_SMTP_EMAIL_SUCCEDDED = "LEGACY_SAVING_SMTP_EMAIL_SUCCEDDED";
export const SAVING_SMTP_EMAIL_FAILED = "LEGACY_SAVING_SMTP_EMAIL_FAILED";

export const FETCHING_SMTP_EMAIL_INTEGRATION_REQUEST =
  "LEGACY_FETCHING_SMTP_EMAIL_INTEGRATION_REQUEST";
export const FETCHING_SMTP_EMAIL_INTEGRATION_SUCCEDDED =
  "LEGACY_FETCHING_SMTP_EMAIL_INTEGRATION_SUCCEDDED";
export const FETCHING_SMTP_EMAIL_INTEGRATION_FAILED =
  "LEGACY_FETCHING_SMTP_EMAIL_INTEGRATION_FAILED";

//Zoho CRM
export const AUTHENTICATING_ZOHO_REQUEST = "LEGACY_AUTHENTICATING_ZOHO_REQUEST";
export const AUTHENTICATING_ZOHO_SUCCEDDED = "LEGACY_AUTHENTICATING_ZOHO_SUCCEDDED";
export const AUTHENTICATING_ZOHO_FAILED = "LEGACY_AUTHENTICATING_ZOHO_FAILED";

export const UPDATING_ZOHO_REQUEST = "LEGACY_UPDATING_ZOHO_REQUEST";
export const UPDATING_ZOHO_SUCCEDDED = "LEGACY_UPDATING_ZOHO_SUCCEDDED";
export const UPDATING_ZOHO_FAILED = "LEGACY_UPDATING_ZOHO_FAILED";

//Outreach Integration
export const AUTHENTICATING_OUTREACH_REQUEST =
  "LEGACY_AUTHENTICATING_OUTREACH_REQUEST";
export const AUTHENTICATING_OUTREACH_SUCCEDDED =
  "LEGACY_AUTHENTICATING_OUTREACH_SUCCEDDED";
export const AUTHENTICATING_OUTREACH_FAILED = "LEGACY_AUTHENTICATING_OUTREACH_FAILED";

export const UPDATING_OUTREACH_REQUEST = "LEGACY_UPDATING_OUTREACH_REQUEST";
export const UPDATING_OUTREACH_SUCCEDDED = "LEGACY_UPDATING_OUTREACH_SUCCEDDED";
export const UPDATING_OUTREACH_FAILED = "LEGACY_UPDATING_OUTREACH_FAILED";

//Microsoft Dynamics CRM
export const VALIDATING_MS_DYNAMICS_INSTANCE_SUCCEDDED =
  "LEGACY_VALIDATING_MS_DYNAMICS_INSTANCE_SUCCEDDED";
export const VALIDATING_MS_DYNAMICS_INSTANCE_FAILED =
  "LEGACY_VALIDATING_MS_DYNAMICS_INSTANCE_FAILED";

export const AUTHENTICATING_MS_DYNAMICS_REQUEST =
  "LEGACY_AUTHENTICATING_MS_DYNAMICS_REQUEST";
export const AUTHENTICATING_MS_DYNAMICS_SUCCEDDED =
  "LEGACY_AUTHENTICATING_MS_DYNAMICS_SUCCEDDED";
export const AUTHENTICATING_MS_DYNAMICS_FAILED =
  "LEGACY_AUTHENTICATING_MS_DYNAMICS_FAILED";

export const UPDATING_MS_DYNAMICS_REQUEST = "LEGACY_UPDATING_MS_DYNAMICS_REQUEST";
export const UPDATING_MS_DYNAMICS_SUCCEDDED = "LEGACY_UPDATING_MS_DYNAMICS_SUCCEDDED";
export const UPDATING_MS_DYNAMICS_FAILED = "LEGACY_UPDATING_MS_DYNAMICS_FAILED";

export const FETCHING_MS_DYNAMICS_INTEGRATION_REQUEST =
  "LEGACY_FETCHING_MS_DYNAMICS_INTEGRATION_REQUEST";
export const FETCHING_MS_DYNAMICS_INTEGRATION_SUCCEDDED =
  "LEGACY_FETCHING_MS_DYNAMICS_INTEGRATION_SUCCEDDED";
export const FETCHING_MS_DYNAMICS_INTEGRATION_FAILED =
  "LEGACY_FETCHING_MS_DYNAMICS_INTEGRATION_FAILED";

export const DEACTIVATING_MS_DYNAMICS_INTEGRATION_REQUEST =
  "LEGACY_DEACTIVATING_MS_DYNAMICS_INTEGRATION_REQUEST";
export const DEACTIVATING_MS_DYNAMICS_INTEGRATION_SUCCEDDED =
  "LEGACY_DEACTIVATING_MS_DYNAMICS_INTEGRATION_SUCCEDDED";
export const DEACTIVATING_MS_DYNAMICS_INTEGRATION_FAILED =
  "LEGACY_DEACTIVATING_MS_DYNAMICS_INTEGRATION_FAILED";

//Salesloft Integration
export const AUTHENTICATING_SALESLOFT_REQUEST =
  "LEGACY_AUTHENTICATING_SALESLOFT_REQUEST";
export const AUTHENTICATING_SALESLOFT_SUCCEDDED =
  "LEGACY_AUTHENTICATING_SALESLOFT_SUCCEDDED";
export const AUTHENTICATING_SALESLOFT_FAILED =
  "LEGACY_AUTHENTICATING_SALESLOFT_FAILED";

export const UPDATING_SALESLOFT_REQUEST = "LEGACY_UPDATING_SALESLOFT_REQUEST";
export const UPDATING_SALESLOFT_SUCCEDDED = "LEGACY_UPDATING_SALESLOFT_SUCCEDDED";
export const UPDATING_SALESLOFT_FAILED = "LEGACY_UPDATING_SALESLOFT_FAILED";

//Marketo Integration

export const AUTHENTICATING_MARKETO_REQUEST = "LEGACY_AUTHENTICATING_MARKETO_REQUEST";
export const AUTHENTICATING_MARKETO_SUCCEDDED =
  "LEGACY_AUTHENTICATING_MARKETO_SUCCEDDED";
export const AUTHENTICATING_MARKETO_FAILED = "LEGACY_AUTHENTICATING_MARKETO_FAILED";

export const UPDATING_MARKETO_REQUEST = "LEGACY_UPDATING_MARKETO_REQUEST";
export const UPDATING_MARKETO_SUCCEDDED = "LEGACY_UPDATING_MARKETO_SUCCEDDED";
export const UPDATING_MARKETO_FAILED = "LEGACY_UPDATING_MARKETO_FAILED";

//Zoom Integration

export const AUTHENTICATING_ZOOM_REQUEST = "LEGACY_AUTHENTICATING_ZOOM_REQUEST";
export const AUTHENTICATING_ZOOM_SUCCEDDED = "AUTHENTICATING_ZOOM_SUCCEDDED";
export const AUTHENTICATING_ZOOM_FAILED = "LEGACY_AUTHENTICATING_ZOOM_FAILED";

export const UPDATING_ZOOM_REQUEST = "LEGACY_UPDATING_ZOOM_REQUEST";
export const UPDATING_ZOOM_SUCCEDDED = "LEGACY_UPDATING_ZOOM_SUCCEDDED";
export const UPDATING_ZOOM_FAILED = "LEGACY_UPDATING_ZOOM_FAILED";


export const UPDATING_ZOOM_RECORDING_TOGGLE_REQUEST = "LEGACY_UPDATING_ZOOM_RECORDING_TOGGLE_REQUEST";
export const UPDATING_ZOOM_RECORDING_TOGGLE_SUCCEEDED = "LEGACY_UPDATING_ZOOM_RECORDING_TOGGLE_SUCCEEDED";
export const UPDATING_ZOOM_RECORDING_TOGGLE_FAILED = "LEGACY_UPDATING_ZOOM_RECORDING_TOGGLE_FAILED";


// Reacful External Script Integration
export const ACTIVATING_EXTERNAL_SCRIPT_REQUEST =
  "LEGACY_ACTIVATING_EXTERNAL_SCRIPT_REQUEST";
export const ACTIVATING_EXTERNAL_SCRIPT_SUCCEDDED =
  "LEGACY_ACTIVATING_EXTERNAL_SCRIPT_SUCCEDDED";
export const ACTIVATING_EXTERNAL_SCRIPT_FAILED =
  "LEGACY_ACTIVATING_EXTERNAL_SCRIPT_FAILED";

export const UPDATING_EXTERNAL_SCRIPT_REQUEST =
  "LEGACY_UPDATING_EXTERNAL_SCRIPT_REQUEST";
export const UPDATING_EXTERNAL_SCRIPT_SUCCEDDED =
  "LEGACY_UPDATING_EXTERNAL_SCRIPT_SUCCEDDED";
export const UPDATING_EXTERNAL_SCRIPT_FAILED =
  "LEGACY_UPDATING_EXTERNAL_SCRIPT_FAILED";

//Pardot Integration
export const AUTHENTICATING_PARDOT_REQUEST = "LEGACY_AUTHENTICATING_PARDOT_REQUEST";
export const AUTHENTICATING_PARDOT_SUCCEDDED =
  "LEGACY_AUTHENTICATING_PARDOT_SUCCEDDED";
export const AUTHENTICATING_PARDOT_FAILED = "LEGACY_AUTHENTICATING_PARDOT_FAILED";

export const UPDATING_PARDOT_REQUEST = "LEGACY_UPDATING_PARDOT_REQUEST";
export const UPDATING_PARDOT_SUCCEDDED = "LEGACY_UPDATING_PARDOT_SUCCEDDED";
export const UPDATING_PARDOT_FAILED = "LEGACY_UPDATING_PARDOT_FAILED";

// fething crm enabled integration
export const FETCHING_CRM_ENABLED_INTEGRATION_REQUEST =
  "LEGACY_FETCHING_CRM_ENABLED_INTEGRATION_REQUEST";
export const FETCHING_CRM_ENABLED_INTEGRATION_SUCCEEDED =
  "LEGACY_FETCHING_CRM_ENABLED_INTEGRATION_SUCCEEDED";
export const FETCHING_CRM_ENABLED_INTEGRATION_FAILED =
  "LEGACY_FETCHING_CRM_ENABLED_INTEGRATION_FAILED";

//Selection
export const ADD_ASSET_SELECTION = "LEGACY_ADD_ASSET_SELECTION";
export const INVALIDATE_ASSETS_SELECTION = "LEGACY_INVALIDATE_ASSETS_SELECTION";
export const REMOVE_ASSET_SELECTION = "LEGACY_REMOVE_ASSET_SELECTION";

export const ADD_COLLECTION_SELECTION = "LEGACY_ADD_COLLECTION_SELECTION";
export const REMOVE_COLLECTION_SELECTION = "LEGACY_REMOVE_COLLECTION_SELECTION";
export const INVALIDATE_COLLECTIONS_SELECTION = "LEGACY_INVALIDATE_COLLECTIONS_SELECTION";

export const ADD_COLLECTION_LIST_SELECTION = "LEGACY_ADD_COLLECTION_LIST_SELECTION";
export const REMOVE_COLLECTION_LIST_SELECTION = "LEGACY_REMOVE_COLLECTION_LIST_SELECTION";
export const INVALIDATE_COLLECTION_LISTS_SELECTION = "LEGACY_INVALIDATE_COLLECTION_LISTS_SELECTION";

export const ADD_GROUP_SELECTION = "LEGACY_ADD_GROUP_SELECTION";
export const REMOVE_GROUP_SELECTION = "LEGACY_REMOVE_GROUP_SELECTION";
export const INVALIDATE_GROUPS_SELECTION = "LEGACY_INVALIDATE_GROUPS_SELECTION";

export const VIEW_ASSET_REQUEST = "LEGACY_VIEW_ASSET_REQUEST";

export const ADD_COLLECTION_SECTION_SELECTION = "LEGACY_ADD_COLLECTION_SECTION_SELECTION";
export const REMOVE_COLLECTION_SECTION_SELECTION = "LEGACY_REMOVE_COLLECTION_SECTION_SELECTION";
export const INVALIDATE_COLLECTION_SECTION_SELECTION = "LEGACY_INVALIDATE_COLLECTION_SECTION_SELECTION";

export const ADD_CONTACT_SELECTION = "LEGACY_ADD_CONTACT_SELECTION";
export const REMOVE_CONTACT_SELECTION = "LEGACY_REMOVE_CONTACT_SELECTION";
export const INVALIDATE_CONTACT_SELECTION = "LEGACY_INVALIDATE_CONTACT_SELECTION";

export const ADD_USER_SELECTION = "LEGACY_ADD_USER_SELECTION";
export const REMOVE_USER_SELECTION = "LEGACY_REMOVE_USER_SELECTION";
export const INVALIDATE_USER_SELECTION = "LEGACY_INVALIDATE_USER_SELECTION";

export const ADD_STREAM_SELECTION = "LEGACY_ADD_STREAM_SELECTION";
export const REMOVE_STREAM_SELECTION = "LEGACY_REMOVE_STREAM_SELECTION";
export const INVALIDATE_STREAMS_SELECTION = "LEGACY_INVALIDATE_STREAMS_SELECTION";

export const MOVE_ENTITY_IN_SELECTION = "LEGACY_MOVE_ENTITY_IN_SELECTION";

//Home screen
export const FETCHING_NUDGE_TYPE_REQUEST = "LEGACY_FETCHING_NUDGE_TYPE_REQUEST";
export const FETCHING_NUDGE_TYPE_SUCCEDDED = "LEGACY_FETCHING_NUDGE_TYPE_SUCCEDDED";
export const FETCHING_NUDGE_TYPE_FAILED = "LEGACY_FETCHING_NUDGE_TYPE_FAILED";

export const FETCHING_ENGAGED_CONTACTS_REQUEST = "LEGACY_FETCHING_ENGAGED_CONTACTS_REQUEST";
export const FETCHING_ENGAGED_CONTACTS_SUCCEDDED = "LEGACY_FETCHING_ENGAGED_CONTACTS_SUCCEDDED";
export const FETCHING_ENGAGED_CONTACTS_FAILED = "LEGACY_FETCHING_ENGAGED_CONTACTS_FAILED";

//Conversations
export const CREATING_CONVERSATION_REQUEST = "LEGACY_CREATING_CONVERSATION_REQUEST";
export const CREATING_CONVERSATION_SUCCEDDED = "LEGACY_CREATING_CONVERSATION_SUCCEDDED";
export const CREATING_CONVERSATION_FAILED = "LEGACY_CREATING_CONVERSATION_FAILED";

export const RESENDING_CONVERSATION_REQUEST = "LEGACY_RESENDING_CONVERSATION_REQUEST";
export const RESENDING_CONVERSATION_SUCCEDDED = "LEGACY_RESENDING_CONVERSATION_SUCCEDDED";
export const RESENDING_CONVERSATION_FAILED = "LEGACY_RESENDING_CONVERSATION_FAILED";

export const DELETING_CONVERSATION_REQUEST = "LEGACY_DELETING_CONVERSATION_REQUEST";
export const DELETING_CONVERSATION_SUCCEDDED = "LEGACY_DELETING_CONVERSATION_SUCCEDDED";
export const DELETING_CONVERSATION_FAILED = "LEGACY_DELETING_CONVERSATION_FAILED";

export const FETCHING_CONVERSATIONS_REQUEST = "LEGACY_FETCHING_CONVERSATIONS_REQUEST";
export const FETCHING_CONVERSATIONS_SUCCEDDED = "LEGACY_FETCHING_CONVERSATIONS_SUCCEDDED";
export const FETCHING_CONVERSATIONS_FAILED = "LEGACY_FETCHING_CONVERSATIONS_FAILED";
export const INVALIDATE_CONVERSATIONS = "LEGACY_INVALIDATE_CONVERSATIONS";

export const FETCHING_CONVERSATION_REQUEST = "LEGACY_FETCHING_CONVERSATION_REQUEST";
export const FETCHING_CONVERSATION_SUCCEDDED = "LEGACY_FETCHING_CONVERSATION_SUCCEDDED";
export const FETCHING_CONVERSATION_FAILED = "LEGACY_FETCHING_CONVERSATION_FAILED";
export const INVALIDATE_CONVERSATION = "LEGACY_INVALIDATE_CONVERSATION";

export const FETCHING_CONVERSATION_ASSET_ANALYTICS_REQUEST = "LEGACY_FETCHING_CONVERSATION_ASSET_ANALYTICS_REQUEST";
export const FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEDDED = "LEGACY_FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEDDED";
export const FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED = "LEGACY_FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED";

export const UPDATING_SHARE_REQUEST = "LEGACY_UPDATING_SHARE_REQUEST";
export const UPDATING_SHARE_SUCCEDDED = "LEGACY_UPDATING_SHARE_SUCCEDDED";
export const UPDATING_SHARE_FAILED = "LEGACY_UPDATING_SHARE_FAILED";

export const UPDATING_CONVERSATION_RECIPIENT_REQUEST = "LEGACY_UPDATING_CONVERSATION_RECIPIENT_REQUEST";
export const UPDATING_CONVERSATION_RECIPIENT_SUCCEDDED = "LEGACY_UPDATING_CONVERSATION_RECIPIENT_SUCCEDDED";
export const UPDATING_CONVERSATION_RECIPIENT_FAILED = "LEGACY_UPDATING_CONVERSATION_RECIPIENT_FAILED";

export const ADD_ASSET_TO_SHARE = "LEGACY_ADD_ASSET_TO_SHARE";
export const ADD_ASSET_TO_SHARE_SUCCEDDED = "LEGACY_ADD_ASSET_TO_SHARE_SUCCEDDED";
export const ADD_ASSET_TO_SHARE_FAILED = "LEGACY_ADD_ASSET_TO_SHARE_FAILED";

export const FETCHING_SHARE_SECTION_REQUEST = "LEGACY_FETCHING_SHARE_SECTION_REQUEST";
export const FETCHING_SHARE_SECTION_SUCCEDDED = "LEGACY_FETCHING_SHARE_SECTION_SUCCEDDED";
export const FETCHING_SHARE_SECTION_FAILED = "LEGACY_FETCHING_SHARE_SECTION_FAILED";

export const FETCHING_SHARE_RECIPIENTS_REQUEST = "LEGACY_FETCHING_SHARE_RECIPIENTS_REQUEST";
export const FETCHING_SHARE_RECIPIENTS_SUCCEDDED = "LEGACY_FETCHING_SHARE_RECIPIENTS_SUCCEDDED";
export const FETCHING_SHARE_RECIPIENTS_FAILED = "LEGACY_FETCHING_SHARE_RECIPIENTS_FAILED";
export const INVALIDATE_SHARE_RECIPIENTS = "LEGACY_INVALIDATE_SHARE_RECIPIENTS";

export const FETCHING_SHARE_ASSETS_REQUEST = "LEGACY_FETCHING_SHARE_ASSETS_REQUEST";
export const FETCHING_SHARE_ASSETS_SUCCEDDED = "LEGACY_FETCHING_SHARE_ASSETS_SUCCEDDED";
export const FETCHING_SHARE_ASSETS_FAILED = "LEGACY_FETCHING_SHARE_ASSETS_FAILED";

//Conversation timeline
export const SEARCHING_ENTITIES_IN_SHARE_REQUEST = "LEGACY_SEARCHING_ENTITIES_IN_SHARE_REQUEST";
export const SEARCHING_ENTITIES_IN_SHARE_SUCCEDDED = "LEGACY_SEARCHING_ENTITIES_IN_SHARE_SUCCEDDED";
export const SEARCHING_ENTITIES_IN_SHARE_FAILED = "LEGACY_SEARCHING_ENTITIES_IN_SHARE_FAILED";

export const FETCHING_TIMELINE_ACTIVITIES_REQUEST = "LEGACY_FETCHING_TIMELINE_ACTIVITIES_REQUEST";
export const FETCHING_TIMELINE_ACTIVITIES_SUCCEDDED = "LEGACY_FETCHING_TIMELINE_ACTIVITIES_SUCCEDDED";
export const FETCHING_TIMELINE_ACTIVITIES_FAILED = "LEGACY_FETCHING_TIMELINE_ACTIVITIES_FAILED";

//Recipient Info
export const FETCH_RECIPIENT_INFO = "LEGACY_FETCH_RECIPIENT_INFO";
export const FETCHING_RECIPIENT_INFO_SUCCEEDED = "LEGACY_FETCHING_RECIPIENT_INFO_SUCCEEDED";
export const FETCHING_RECIPIENT_INFO_FAILED = "LEGACY_FETCHING_RECIPIENT_INFO_FAILED";

//Conversation Message
export const FETCHING_MESSAGE_REQUEST = "LEGACY_FETCHING_MESSAGE_REQUEST";
export const FETCHING_MESSAGE_SUCCEDDED = "LEGACY_FETCHING_MESSAGE_SUCCEDDED";
export const FETCHING_MESSAGE_FAILED = "LEGACY_FETCHING_MESSAGE_FAILED";

//Convesration Events
export const FETCHING_CONVERSATION_EVENTS = "LEGACY_FETCHING_CONVERSATION_EVENTS";
export const FETCHING_CONVERSATION_EVENTS_SUCCEEDED = "LEGACY_FETCHING_CONVERSATION_EVENTS_SUCCEEDED";
export const FETCHING_CONVERSATION_EVENTS_FAILED = "LEGACY_FETCHING_CONVERSATION_EVENTS_FAILED";

// Report Summary
export const FETCHING_REPORT_SUMMARY_REQUEST = "LEGACY_FETCHING_REPORT_SUMMARY_REQUEST";
export const FETCHING_REPORT_SUMMARY_SUCCEDDED = "LEGACY_FETCHING_REPORT_SUMMARY_SUCCEDDED";
export const FETCHING_REPORT_SUMMARY_FAILED = "LEGACY_FETCHING_REPORT_SUMMARY_FAILED";

//Email Contacts
export const FETCHING_EMAIL_CONTACTS_REQUEST = "LEGACY_FETCHING_EMAIL_CONTACTS_REQUEST";
export const FETCHING_EMAIL_CONTACTS_SUCCEDDED = "LEGACY_FETCHING_EMAIL_CONTACTS_SUCCEDDED";
export const FETCHING_EMAIL_CONTACTS_FAILED = "LEGACY_FETCHING_EMAIL_CONTACTS_FAILED";

//Background Task
export const STARTING_BACKGROUND_UPLOAD_TASK = "LEGACY_STARTING_BACKGROUND_UPLOAD_TASK";
export const COMPLETING_BACKGROUND_UPLOAD_TASK = "LEGACY_COMPLETING_BACKGROUND_UPLOAD_TASK";
export const CANCELING_BACKGROUND_UPLOAD_TASK = "LEGACY_CANCELING_BACKGROUND_UPLOAD_TASK";

//Exporting asset to background task
export const ADD_ASSET_TO_BACKGROUND_TASK = "LEGACY_ADD_ASSET_TO_BACKGROUND_TASK";

//Websocket message
export const WS_ASSET_PROCESSED = "WS_ASSET_PROCESSED";
export const WS_DATASOURCE_SYNC_STATUS = "LEGACY_WS_DATASOURCE_SYNC_STATUS";
export const WS_DATASOURCE_SYNC_COMPLETION = "LEGACY_WS_DATASOURCE_SYNC_COMPLETION";
export const WS_DATASOURCE_DELETION_STATUS = "LEGACY_WS_DATASOURCE_DELETION_STATUS";
export const WS_SAMPLE_DATA_STREAM_COMPLETION = "LEGACY_WS_SAMPLE_DATA_STREAM_COMPLETION";
export const WS_ASSET_EDITOR_CREATED = "LEGACY_WS_ASSET_EDITOR_CREATED";
export const WS_ASSET_MERGE_STATUS = "LEGACY_WS_ASSET_MERGE_STATUS";
export const WS_DATASOURCE_MIGRATION_STATUS = "LEGACY_WS_DATASOURCE_MIGRATION_STATUS";
export const WS_DATASOURCE_MIGRATION_COMPLETION = "LEGACY_WS_DATASOURCE_MIGRATION_COMPLETION";
export const WS_ASSET_ANALYTICS_UPDATED = "LEGACY_WS_ASSET_ANALYTICS_UPDATED";

//Unsubscribe Contact
export const UNSUBSCRIBING_CONTACT_REQUEST = "LEGACY_UNSUBSCRIBING_CONTACT_REQUEST";
export const UNSUBSCRIBING_CONTACT_SUCCEDDED = "LEGACY_UNSUBSCRIBING_CONTACT_SUCCEDDED";
export const UNSUBSCRIBING_CONTACT_FAILED = "LEGACY_UNSUBSCRIBING_CONTACT_FAILED";

//Resubscribe Contact
export const RESUBSCRIBING_CONTACT_REQUEST = "LEGACY_RESUBSCRIBING_CONTACT_REQUEST";
export const RESUBSCRIBING_CONTACT_SUCCEDDED = "LEGACY_RESUBSCRIBING_CONTACT_SUCCEDDED";
export const RESUBSCRIBING_CONTACT_FAILED = "LEGACY_RESUBSCRIBING_CONTACT_FAILED";

//Dashboard Report
export const FETCHING_ACCOUNT_SUMMARY_REQUEST = "LEGACY_FETCHING_ACCOUNT_SUMMARY_REQUEST";
export const FETCHING_ACCOUNT_SUMMARY_SUCCEDDED = "LEGACY_FETCHING_ACCOUNT_SUMMARY_SUCCEDDED";
export const FETCHING_ACCOUNT_SUMMARY_FAILED = "LEGACY_FETCHING_ACCOUNT_SUMMARY_FAILED";

export const FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST =
  "LEGACY_FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST";
export const FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED";
export const FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED =
  "LEGACY_FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED";

export const FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST =
  "LEGACY_FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST";
export const FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED";
export const FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED =
  "LEGACY_FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED";
export const INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS =
  "LEGACY_INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS";

export const FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT =
  "LEGACY_FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT";
export const FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED =
  "LEGACY_FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED";

export const FETCHING_DISCOVERY_ASSET_GRAPH_REPORT =
  "LEGACY_FETCHING_DISCOVERY_ASSET_GRAPH_REPORT";
export const FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED =
  "LEGACY_FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED";

export const FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT =
  "LEGACY_FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT";
export const FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_FAILED =
  "LEGACY_FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_FAILED";

export const FETCHING_DISCOVERY_SHARE_GRAPH_REPORT =
  "LEGACY_FETCHING_DISCOVERY_SHARE_GRAPH_REPORT";
export const FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED =
  "LEGACY_FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED";

export const FETCHING_DISCOVERY_POPULAR_ASSETS =
  "LEGACY_FETCHING_DISCOVERY_POPULAR_ASSETS";
export const FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED";
export const FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED =
  "LEGACY_FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED";

export const FETCHING_DISCOVERY_TOP_USERS = "LEGACY_FETCHING_DISCOVERY_TOP_USERS";
export const FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED";
export const FETCHING_DISCOVERY_TOP_USERS_FAILED =
  "LEGACY_FETCHING_DISCOVERY_TOP_USERS_FAILED";

export const FETCHING_DISCOVERY_TOP_USER_GROUPS =
  "LEGACY_FETCHING_DISCOVERY_TOP_USER_GROUPS";
export const FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED";
export const FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED =
  "LEGACY_FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED";

export const FETCHING_DISCOVERY_SEARCH_QUERIES =
  "LEGACY_FETCHING_DISCOVERY_SEARCH_QUERIES";
export const FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED";
export const FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED =
  "LEGACY_FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED";

export const FETCHING_DISCOVERY_SEARCH_TAGS = "LEGACY_FETCHING_DISCOVERY_SEARCH_TAGS";
export const FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED";
export const FETCHING_DISCOVERY_SEARCH_TAGS_FAILED =
  "LEGACY_FETCHING_DISCOVERY_SEARCH_TAGS_FAILED";

export const FETCHING_DISCOVERY_USER_ACTIVITIES =
  "LEGACY_FETCHING_DISCOVERY_USER_ACTIVITIES";
export const FETCHING_DISCOVERY_USER_ACTIVITIES_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_USER_ACTIVITIES_SUCCEDDED";
export const FETCHING_DISCOVERY_USER_ACTIVITIES_FAILED =
  "LEGACY_FETCHING_DISCOVERY_USER_ACTIVITIES_FAILED";

export const FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT =
  "LEGACY_FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT";
export const FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED =
  "LEGACY_FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED";

export const FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT =
  "LEGACY_FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT";
export const FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED =
  "LEGACY_FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED";

export const FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT =
  "LEGACY_FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT";
export const FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED =
  "LEGACY_FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED";

export const FETCHING_DISCOVERY_COLLECTIONS_REPORT =
  "LEGACY_FETCHING_DISCOVERY_COLLECTIONS_REPORT";
export const FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED =
  "LEGACY_FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED";

export const FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT =
  "LEGACY_FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT";
export const FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED =
  "LEGACY_FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED";

export const FETCHING_DISCOVERY_TOP_SHARERS = "LEGACY_FETCHING_DISCOVERY_TOP_SHARERS";
export const FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED =
  "LEGACY_FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED";
export const FETCHING_DISCOVERY_TOP_SHARERS_FAILED =
  "LEGACY_FETCHING_DISCOVERY_TOP_SHARERS_FAILED";

export const FETCHING_DISCOVERY_ASSETS_SHARED_REPORT =
  "LEGACY_FETCHING_DISCOVERY_ASSETS_SHARED_REPORT";
export const FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED =
  "LEGACY_FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED";

//Engagement Reports
export const FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT =
  "LEGACY_FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT";
export const FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED =
  "LEGACY_FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED";

export const FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT =
  "LEGACY_FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT";
export const FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED =
  "LEGACY_FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED =
  "LEGACY_FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED";

export const FETCHING_ENGAGEMENT_POPULAR_ASSETS =
  "LEGACY_FETCHING_ENGAGEMENT_POPULAR_ASSETS";
export const FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED =
  "LEGACY_FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED";
export const FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED =
  "LEGACY_FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED";

export const FETCHING_ENGAGEMENT_TOP_USERS = "LEGACY_FETCHING_ENGAGEMENT_TOP_USERS";
export const FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED =
  "LEGACY_FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED";
export const FETCHING_ENGAGEMENT_TOP_USERS_FAILED =
  "LEGACY_FETCHING_ENGAGEMENT_TOP_USERS_FAILED";

export const FETCHING_ENGAGEMENT_TOP_ACCOUNTS =
  "LEGACY_FETCHING_ENGAGEMENT_TOP_ACCOUNTS";
export const FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED =
  "LEGACY_FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED";
export const FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED =
  "LEGACY_FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED";

export const FETCHING_ENGAGEMENT_TOP_CAMPAIGNS =
  "LEGACY_FETCHING_ENGAGEMENT_TOP_CAMPAIGNS";
export const FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED =
  "LEGACY_FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED";
export const FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED =
  "LEGACY_FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED";

export const FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES =
  "LEGACY_FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES";
export const FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED =
  "LEGACY_FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED";
export const FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED =
  "LEGACY_FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED";

export const FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES =
  "LEGACY_FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES";
export const FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED =
  "LEGACY_FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED";
export const FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED =
  "LEGACY_FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED";

export const FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES =
  "LEGACY_FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES";
export const FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED =
  "LEGACY_FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED";
export const FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED =
  "LEGACY_FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED";

export const INTIALIZING_DOWNLOAD_REPORT_REQUEST =
  "LEGACY_INTIALIZING_DOWNLOAD_REPORT_REQUEST";
export const INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED =
  "LEGACY_INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED";
export const INTIALIZING_DOWNLOAD_REPORT_FAILED =
  "LEGACY_INTIALIZING_DOWNLOAD_REPORT_FAILED";

//Email Templates
export const FETCHING_EMAIL_TEMPLATES_REQUEST =
  "LEGACY_FETCHING_EMAIL_TEMPLATES_REQUEST";
export const FETCHING_EMAIL_TEMPLATES_SUCCEDDED =
  "LEGACY_FETCHING_EMAIL_TEMPLATES_SUCCEDDED";
export const FETCHING_EMAIL_TEMPLATES_FAILED =
  "LEGACY_FETCHING_EMAIL_TEMPLATES_FAILED";
export const INVALIDATE_EMAIL_TEMPLATES = "LEGACY_INVALIDATE_EMAIL_TEMPLATES";

export const SELECTION_EMAIL_TEMPLATE = "SELECTION_EMAIL_TEMPLATE";
export const INVALIDATE_SELECTION_EMAIL_TEMPLATE =
  "INVALIDATE_SELECTION_EMAIL_TEMPLATE";

export const FETCHING_EMAIL_TEMPLATE_REQUEST =
  "LEGACY_FETCHING_EMAIL_TEMPLATE_REQUEST";
export const FETCHING_EMAIL_TEMPLATE_SUCCEDDED =
  "LEGACY_FETCHING_EMAIL_TEMPLATE_SUCCEDDED";
export const FETCHING_EMAIL_TEMPLATE_FAILED = "LEGACY_FETCHING_EMAIL_TEMPLATE_FAILED";

export const CREATING_EMAIL_TEMPLATE_REQUEST =
  "LEGACY_CREATING_EMAIL_TEMPLATE_REQUEST";
export const CREATING_EMAIL_TEMPLATE_SUCCEDDED =
  "LEGACY_CREATING_EMAIL_TEMPLATE_SUCCEDDED";
export const CREATING_EMAIL_TEMPLATE_FAILED = "LEGACY_CREATING_EMAIL_TEMPLATE_FAILED";

export const UPDATING_EMAIL_TEMPLATE_REQUEST =
  "LEGACY_UPDATING_EMAIL_TEMPLATE_REQUEST";
export const UPDATING_EMAIL_TEMPLATE_SUCCEDDED =
  "LEGACY_UPDATING_EMAIL_TEMPLATE_SUCCEDDED";
export const UPDATING_EMAIL_TEMPLATE_FAILED = "LEGACY_UPDATING_EMAIL_TEMPLATE_FAILED";

export const DELETING_EMAIL_TEMPLATE_REQUEST =
  "LEGACY_DELETING_EMAIL_TEMPLATE_REQUEST";
export const DELETING_EMAIL_TEMPLATE_SUCCEDDED =
  "LEGACY_DELETING_EMAIL_TEMPLATE_SUCCEDDED";
export const DELETING_EMAIL_TEMPLATE_FAILED = "LEGACY_DELETING_EMAIL_TEMPLATE_FAILED";

export const FETCHING_DEFAULT_EMAIL_TEMPLATE_REQUEST =
  "LEGACY_FETCHING_DEFAULT_EMAIL_TEMPLATE_REQUEST";
export const FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED =
  "LEGACY_FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED";
export const FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED =
  "LEGACY_FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED";
export const INVALIDATE_DEFAULT_EMAIL_TEMPLATE =
  "LEGACY_INVALIDATE_DEFAULT_EMAIL_TEMPLATE";

// Generate Link
export const UPDATING_LINK_REQUEST = "LEGACY_UPDATING_LINK_REQUEST";
export const UPDATING_LINK_SUCCEDDED = "LEGACY_UPDATING_LINK_SUCCEDDED";
export const UPDATING_LINK_FAILED = "LEGACY_UPDATING_LINK_FAILED";

export const DELETING_LINK_REQUEST = "LEGACY_DELETING_LINK_REQUEST";
export const DELETING_LINK_SUCCEDDED = "LEGACY_DELETING_LINK_SUCCEDDED";
export const DELETING_LINK_FAILED = "LEGACY_DELETING_LINK_FAILED";

export const SELECT_LINK_REQUEST = "LEGACY_SELECT_LINK_REQUEST";
export const RESET_SELECT_LINK_REQUEST = "LEGACY_RESET_SELECT_LINK_REQUEST";

export const INVALIDATE_LINKS = "LEGACY_INVALIDATE_LINKS";

//rearrange action
export const COPYING_ENTITY_REQUEST = "LEGACY_COPYING_ENTITY_REQUEST";
export const COPYING_ENTITY_SUCCEDDED = "LEGACY_COPYING_ENTITY_SUCCEDDED";
export const COPYING_ENTITY_FAILED = "LEGACY_COPYING_ENTITY_FAILED";

export const MOVING_ENTITY_REQUEST = "LEGACY_MOVING_ENTITY_REQUEST";
export const MOVING_ENTITY_SUCCEDDED = "LEGACY_MOVING_ENTITY_SUCCEDDED";
export const MOVING_ENTITY_FAILED = "LEGACY_MOVING_ENTITY_FAILED";

//Collection sections
export const ADD_ASSETS_TO_SECTION = "LEGACY_ADD_ASSETS_TO_SECTION";
export const ADD_ASSETS_TO_SECTION_SUCCEDDED =
  "LEGACY_ADD_ASSETS_TO_SECTION_SUCCEDDED";
export const ADD_ASSETS_TO_SECTION_FAILED = "LEGACY_ADD_ASSETS_TO_SECTION_FAILED";

export const FETCHING_COLLECTION_SECTION_REQUEST =
  "LEGACY_FETCHING_COLLECTION_SECTION_REQUEST";
export const FETCHING_COLLECTION_SECTION_SUCCEDDED =
  "LEGACY_FETCHING_COLLECTION_SECTION_SUCCEDDED";
export const FETCHING_COLLECTION_SECTION_FAILED =
  "LEGACY_FETCHING_COLLECTION_SECTION_FAILED";

//Share sections
export const ADD_ASSETS_TO_SHARE_SECTION = "LEGACY_ADD_ASSETS_TO_SHARE_SECTION";
export const ADD_ASSETS_TO_SHARE_SECTION_SUCCEDDED =
  "LEGACY_ADD_ASSETS_TO_SHARE_SECTION_SUCCEDDED";
export const ADD_ASSETS_TO_SHARE_SECTION_FAILED =
  "LEGACY_ADD_ASSETS_TO_SHARE_SECTION_FAILED";

// Edit Collection
export const EDIT_COLLECTION_REQUEST = "LEGACY_EDIT_COLLECTION_REQUEST";
export const INVALIDATE_EDIT_COLLECTION_REQUEST =
  "LEGACY_INVALIDATE_EDIT_COLLECTION_REQUEST";

export const CREATE_COLLECTION_SECTION_REQUEST =
  "LEGACY_CREATE_COLLECTION_SECTION_REQUEST";
export const UPDATE_COLLECTION_SECTION_REQUEST =
  "LEGACY_UPDATE_COLLECTION_SECTION_REQUEST";
export const REMOVE_COLLECTION_SECTION_REQUEST =
  "LEGACY_REMOVE_COLLECTION_SECTION_REQUEST";

export const COLLECTION_ADD_ASSETS = "COLLECTION_ADD_ASSETS";
export const COLLECTION_REMOVE_ASSETS = "LEGACY_COLLECTION_REMOVE_ASSETS";
export const COLLECTION_REARRANGE_ASSETS = "LEGACY_COLLECTION_REARRANGE_ASSETS";
export const COLLECTION_MOVE_SECTIONS = "LEGACY_COLLECTION_MOVE_SECTIONS";

export const COLLECTION_UPDATE_PROPERTY = "LEGACY_COLLECTION_UPDATE_PROPERTY";

export const COLLECTION_APPLY_ADDITIONAL_CHANGES =
  "LEGACY_COLLECTION_APPLY_ADDITIONAL_CHANGES";

export const COLLECTION_HIGHLIGHT_SECTION_DRAG_OVER =
  "LEGACY_COLLECTION_HIGHLIGHT_SECTION_DRAG_OVER";
export const COLLECTION_MOVE_ASSET_BETWEEN_SECTIONS =
  "LEGACY_COLLECTION_MOVE_ASSET_BETWEEN_SECTIONS";
export const INVALIDATE_COLLECTION_MOVE_ASSET_BETWEEN_SECTIONS =
  "LEGACY_INVALIDATE_COLLECTION_MOVE_ASSET_BETWEEN_SECTIONS";

//Edit Conversation
export const EDIT_CONVERSATION_REQUEST = "LEGACY_EDIT_CONVERSATION_REQUEST";
export const INVALIDATE_EDIT_CONVERSATION_REQUEST =
  "LEGACY_INVALIDATE_EDIT_CONVERSATION_REQUEST";

export const CREATE_CONVERSATION_SECTION_REQUEST =
  "LEGACY_CREATE_CONVERSATION_SECTION_REQUEST";
export const UPDATE_CONVERSATION_SECTION_REQUEST =
  "LEGACY_UPDATE_CONVERSATION_SECTION_REQUEST";
export const REMOVE_CONVERSATION_SECTION_REQUEST =
  "LEGACY_REMOVE_CONVERSATION_SECTION_REQUEST";

export const CONVERSATION_REMOVE_ASSETS = "LEGACY_CONVERSATION_REMOVE_ASSETS";
export const CONVERSATION_ADD_ASSETS = "LEGACY_CONVERSATION_ADD_ASSETS";
export const CONVERSATION_MOVE_ASSETS = "LEGACY_CONVERSATION_MOVE_ASSETS";

export const CONVERSATION_MOVE_SECTIONS = "LEGACY_CONVERSATION_MOVE_SECTIONS";

export const CONVERSATION_APPLY_ADDITIONAL_CHANGES =
  "LEGACY_CONVERSATION_APPLY_ADDITIONAL_CHANGES";
export const CONVERSATION_UPDATE_PROPERTY = "LEGACY_CONVERSATION_UPDATE_PROPERTY";

// Sort Collection
export const SORT_COLLECTION = "LEGACY_SORT_COLLECTION";

//Contact List
export const CREATING_CONTACT_LIST_REQUEST = "LEGACY_CREATING_CONTACT_LIST_REQUEST";
export const CREATING_CONTACT_LIST_SUCCEDDED =
  "LEGACY_CREATING_CONTACT_LIST_SUCCEDDED";
export const CREATING_CONTACT_LIST_FAILED = "LEGACY_CREATING_CONTACT_LIST_FAILED";

export const UPDATING_CONTACT_LIST_REQUEST = "LEGACY_UPDATING_CONTACT_LIST_REQUEST";
export const UPDATING_CONTACT_LIST_SUCCEDDED =
  "LEGACY_UPDATING_CONTACT_LIST_SUCCEDDED";
export const UPDATING_CONTACT_LIST_FAILED = "LEGACY_UPDATING_CONTACT_LIST_FAILED";

export const DELETING_CONTACT_LIST_REQUEST = "LEGACY_DELETING_CONTACT_LIST_REQUEST";
export const DELETING_CONTACT_LIST_SUCCEDDED =
  "LEGACY_DELETING_CONTACT_LIST_SUCCEDDED";
export const DELETING_CONTACT_LIST_FAILED = "LEGACY_DELETING_CONTACT_LIST_FAILED";

export const VIEW_CONTACT_LIST = "LEGACY_VIEW_CONTACT_LIST";

export const FETCHING_CONTACT_LIST_REQUEST = "LEGACY_FETCHING_CONTACT_LIST_REQUEST";
export const FETCHING_CONTACT_LIST_SUCCEDDED =
  "LEGACY_FETCHING_CONTACT_LIST_SUCCEDDED";
export const FETCHING_CONTACT_LIST_FAILED = "LEGACY_FETCHING_CONTACT_LIST_FAILED";

export const FETCHING_CONTACT_LISTS_REQUEST = "LEGACY_FETCHING_CONTACT_LISTS_REQUEST";
export const FETCHING_CONTACT_LISTS_SUCCEDDED =
  "LEGACY_FETCHING_CONTACT_LISTS_SUCEEDDED";
export const FETCHING_CONTACT_LISTS_FAILED = "LEGACY_FETCHING_CONTACT_LISTS_FAILED";

export const ADD_CONTACT_TO_CONTACTLIST = "LEGACY_ADD_CONTACT_TO_CONTACTLIST";
export const REMOVE_CONTACT_FROM_CONTACTLIST =
  "LEGACY_REMOVE_CONTACT_FROM_CONTACTLIST";

//User groups
export const CREATING_USER_GROUP_REQUEST = "LEGACY_CREATING_USER_GROUP_REQUEST";
export const CREATING_USER_GROUP_SUCCEDDED = "LEGACY_CREATING_USER_GROUP_SUCCEDDED";
export const CREATING_USER_GROUP_FAILED = "LEGACY_CREATING_USER_GROUP_FAILED";

export const UPDATING_USER_GROUP_REQUEST = "LEGACY_UPDATING_USER_GROUP_REQUEST";
export const UPDATING_USER_GROUP_SUCCEDDED = "LEGACY_UPDATING_USER_GROUP_SUCCEDDED";
export const UPDATING_USER_GROUP_FAILED = "LEGACY_UPDATING_USER_GROUP_FAILED";

export const FETCHING_USER_GROUPS_REQUEST = "LEGACY_FETCHING_USER_GROUPS_REQUEST";
export const FETCHING_USER_GROUPS_SUCCEDDED = "LEGACY_FETCHING_USER_GROUPS_SUCCEDDED";
export const FETCHING_USER_GROUPS_FAILED = "LEGACY_FETCHING_USER_GROUPS_FAILED";

export const FETCHING_USER_GROUP_REQUEST = "LEGACY_FETCHING_USER_GROUP_REQUEST";
export const FETCHING_USER_GROUP_SUCCEDDED = "LEGACY_FETCHING_USER_GROUP_SUCCEDDED";
export const FETCHING_USER_GROUP_FAILED = "LEGACY_FETCHING_USER_GROUP_FAILED";

export const DELETING_USER_GROUP_REQUEST = "LEGACY_DELETING_USER_GROUP_REQUEST";
export const DELETING_USER_GROUP_SUCCEDDED = "LEGACY_DELETING_USER_GROUP_SUCCEDDED";
export const DELETING_USER_GROUP_FAILED = "LEGACY_DELETING_USER_GROUP_FAILED";

export const FETCHING_ACCOUNT_USERS_REQUEST = "LEGACY_FETCHING_ACCOUNT_USERS_REQUEST";
export const FETCHING_ACCOUNT_USERS_SUCCEDDED =
  "LEGACY_FETCHING_ACCOUNT_USERS_SUCCEDDED";
export const FETCHING_ACCOUNT_USERS_FAILED = "LEGACY_FETCHING_ACCOUNT_USERS_FAILED";
export const INVALIDATE_ACCOUNT_USERS = "LEGACY_INVALIDATE_ACCOUNT_USERS";

export const ADD_USER_TO_USER_GROUP = "LEGACY_ADD_USER_TO_USER_GROUP";
export const REMOVE_USER_FROM_USER_GROUP = "LEGACY_REMOVE_USER_FROM_USER_GROUP";

//Custom fields
export const CREATING_CUSTOM_FIELD_REQUEST = "LEGACY_CREATING_CUSTOM_FIELD_REQUEST";
export const CREATING_CUSTOM_FIELD_SUCCEEDED =
  "LEGACY_CREATING_CUSTOM_FIELD_SUCCEEDED";
export const CREATING_CUSTOM_FIELD_FAILED = "LEGACY_CREATING_CUSTOM_FIELD_FAILED";

export const UPDATING_CUSTOM_FIELD_REQUEST = "LEGACY_UPDATING_CUSTOM_FIELD_REQUEST";
export const UPDATING_CUSTOM_FIELD_SUCCEEDED =
  "LEGACY_UPDATING_CUSTOM_FIELD_SUCCEEDED";
export const UPDATING_CUSTOM_FIELD_FAILED = "LEGACY_UPDATING_CUSTOM_FIELD_FAILED";

export const FETCHING_CUSTOM_FIELD_REQUEST = "LEGACY_FETCHING_CUSTOM_FIELD_REQUEST";
export const FETCHING_CUSTOM_FIELD_SUCCEEDED =
  "LEGACY_FETCHING_CUSTOM_FIELD_SUCCEEDED";
export const FETCHING_CUSTOM_FIELD_FAILED = "LEGACY_FETCHING_CUSTOM_FIELD_FAILED";

export const FETCHING_CUSTOM_FIELDS_REQUEST = "LEGACY_FETCHING_CUSTOM_FIELDS_REQUEST";
export const FETCHING_CUSTOM_FIELDS_SUCCEEDED =
  "LEGACY_FETCHING_CUSTOM_FIELDS_SUCCEEDED";
export const FETCHING_CUSTOM_FIELDS_FAILED = "LEGACY_FETCHING_CUSTOM_FIELDS_FAILED";

export const DELETING_CUSTOM_FIELD_REQUEST = "LEGACY_DELETING_CUSTOM_FIELD_REQUEST";
export const DELETING_CUSTOM_FIELD_SUCCEEDED =
  "LEGACY_DELETING_CUSTOM_FIELD_SUCCEEDED";
export const DELETING_CUSTOM_FIELD_FAILED = "LEGACY_DELETING_CUSTOM_FIELD_FAILED";

export const REORDERING_CUSTOM_FIELD_REQUEST =
  "LEGACY_REORDERING_CUSTOM_FIELD_REQUEST";
export const REORDERING_CUSTOM_FIELD_SUCCEEDED =
  "LEGACY_REORDERING_CUSTOM_FIELD_SUCCEEDED";
export const REORDERING_CUSTOM_FIELD_FAILED = "LEGACY_REORDERING_CUSTOM_FIELD_FAILED";

//Image Library
export const FETCHING_LIBRARY_IMAGES = "LEGACY_FETCHING_LIBRARY_IMAGES";
export const FETCHING_LIBRARY_IMAGES_SUCCEEDED =
  "LEGACY_FETCHING_LIBRARY_IMAGES_SUCCEEDED";
export const FETCHING_LIBRARY_IMAGES_FAILED = "LEGACY_FETCHING_LIBRARY_IMAGES_FAILED";
export const INVALIDATE_LIBRARY_IMAGES = "LEGACY_INVALIDATE_LIBRARY_IMAGES";

//Email TEMPLATE
export const UPDATING_EMAIL_SIGNATURE_REQUEST =
  "LEGACY_UPDATING_EMAIL_SIGNATURE_REQUEST";
export const UPDATING_EMAIL_SIGNATURE_SUCCEDDED =
  "LEGACY_UPDATING_EMAIL_SIGNATURE_SUCCEDDED";
export const UPDATING_EMAIL_SIGNATURE_FAILED =
  "LEGACY_UPDATING_EMAIL_SIGNATURE_FAILED";

//Microsoft Wopi Integration
export const FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_REQUEST =
  "LEGACY_FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_REQUEST";
export const FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_SUCCEDDED =
  "LEGACY_FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_SUCCEDDED";
export const FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_FAILED =
  "LEGACY_FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_FAILED";

export const UPDATING_WOPI_INTEGRATION_ASSET_REQUEST =
  "LEGACY_UPDATING_WOPI_INTEGRATION_ASSET_REQUEST";
export const UPDATING_WOPI_INTEGRATION_ASSET_SUCCEDDED =
  "LEGACY_UPDATING_WOPI_INTEGRATION_ASSET_SUCCEDDED";
export const UPDATING_WOPI_INTEGRATION_ASSET_FAILED =
  "LEGACY_UPDATING_WOPI_INTEGRATION_ASSET_FAILED";

export const INVALIDATE_WOPI_INTEGRATION = "LEGACY_INVALIDATE_WOPI_INTEGRATION";

//Recently Viewed Streams
export const FETCHING_RECENTLY_VIEWED_STREAM_REQUEST =
  "LEGACY_FETCHING_RECENTLY_VIEWED_STREAM_REQUEST";
export const FETCHING_RECENTLY_VIEWED_STREAM_SUCCEDDED =
  "LEGACY_FETCHING_RECENTLY_VIEWED_STREAM_SUCCEDDED";
export const FETCHING_RECENTLY_VIEWED_STREAM_FAILED =
  "LEGACY_FETCHING_RECENTLY_VIEWED_STREAM_FAILED";

//Recently Viewed Assets
export const FETCHING_HUB_RECENTLY_VIEWED_ASSETS =
  "LEGACY_FETCHING_HUB_RECENTLY_VIEWED_ASSETS";
export const FETCHING_HUB_RECENTLY_VIEWED_ASSETS_SUCCEDDED =
  "LEGACY_FETCHING_HUB_RECENTLY_VIEWED_ASSETS_SUCCEDDED";
export const FETCHING_HUB_RECENTLY_VIEWED_ASSETS_FAILED =
  "LEGACY_FETCHING_HUB_RECENTLY_VIEWED_ASSETS_FAILED";
export const INVALIDATE_HUB_RECENTLY_VIEWED_ASSETS =
  "LEGACY_INVALIDATE_HUB_RECENTLY_VIEWED_ASSETS";

//webinr action Types
export const WEBINR_USER_REGISTRATION_REQUEST =
  "LEGACY_WEBINR_USER_REGISTRATION_REQUEST";
export const WEBINR_USER_REGISTRATION_SUCCEDDED =
  "LEGACY_WEBINR_USER_REGISTRATION_SUCCEDDED";
export const WEBINR_USER_REGISTRATION_FAILED =
  "LEGACY_WEBINR_USER_REGISTRATION_FAILED";

//clone asset action
export const CLONING_ASSET_REQUEST = "LEGACY_CLONING_ASSET_REQUEST";
export const CLONING_ASSET_SUCCEDDED = "LEGACY_CLONING_ASSET_SUCCEDDED";
export const CLONING_ASSET_FAILED = "LEGACY_CLONING_ASSET_FAILED";

//Recommended Assets
export const FETCHING_RECOMMENDED_ASSETS = "LEGACY_FETCHING_RECOMMENDED_ASSETS";
export const FETCHING_RECOMMENDED_ASSETS_SUCCEDDED =
  "LEGACY_FETCHING_RECOMMENDED_ASSETS_SUCCEDDED";
export const FETCHING_RECOMMENDED_ASSETS_FAILED =
  "LEGACY_FETCHING_RECOMMENDED_ASSETS_FAILED";
export const INVALIDATE_RECOMMENDED_ASSETS = "LEGACY_INVALIDATE_RECOMMENDED_ASSETS";

//GDocs Editor
export const CREATING_ASSET_EDITOR_REFERENCE_REQUEST =
  "LEGACY_CREATING_ASSET_EDITOR_REFERENCE_REQUEST";
export const CREATING_ASSET_EDITOR_REFERENCE_SUCCEDDED =
  "LEGACY_CREATING_ASSET_EDITOR_REFERENCE_SUCCEDDED";
export const CREATING_ASSET_EDITOR_REFERENCE_FAILED =
  "LEGACY_CREATING_ASSET_EDITOR_REFERENCE_FAILED";


//NDA Template
export const CREATING_NDA_TEMPLATE_REQUEST = "LEGACY_CREATING_NDA_TEMPLATE_REQUEST";
export const CREATING_NDA_TEMPLATE_SUCCEDDED = "LEGACY_CREATING_NDA_TEMPLATE_SUCCEDDED";
export const CREATING_NDA_TEMPLATE_FAILED = "LEGACY_CREATING_NDA_TEMPLATE_FAILED";

export const UPDATING_NDA_TEMPLATE_REQUEST = "LEGACY_UPDATING_NDA_TEMPLATE_REQUEST";
export const UPDATING_NDA_TEMPLATE_SUCCEDDED = "LEGACY_UPDATING_NDA_TEMPLATE_SUCCEDDED";
export const UPDATING_NDA_TEMPLATE_FAILED = "LEGACY_UPDATING_NDA_TEMPLATE_FAILED";

export const FETCHING_NDA_TEMPLATE_REQUEST = "LEGACY_FETCHING_NDA_TEMPLATE_REQUEST";
export const FETCHING_NDA_TEMPLATE_SUCCEDDED = "LEGACY_FETCHING_NDA_TEMPLATE_SUCCEDDED";
export const FETCHING_NDA_TEMPLATE_FAILED = "LEGACY_FETCHING_NDA_TEMPLATE_FAILED";

export const FETCHING_ALL_NDA_TEMPLATE_REQUEST = "LEGACY_FETCHING_ALL_NDA_TEMPLATE_REQUEST";
export const FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED = "LEGACY_FETCHING_ALL_NDA_TEMPLATE_SUCCEDDED";
export const FETCHING_ALL_NDA_TEMPLATE_FAILED = "LEGACY_FETCHING_ALL_NDA_TEMPLATE_FAILED";

export const DELETING_NDA_TEMPLATE_REQUEST = "LEGACY_DELETING_NDA_TEMPLATE_REQUEST";
export const DELETING_NDA_TEMPLATE_SUCCEDDED = "LEGACY_DELETING_NDA_TEMPLATE_SUCCEDDED";
export const DELETING_NDA_TEMPLATE_FAILED = "LEGACY_DELETING_NDA_TEMPLATE_FAILED";
export const SYNCING_ASSET_EDITOR_REFERENCE_REQUEST = "LEGACY_SYNCING_ASSET_EDITOR_REFERENCE_REQUEST";
export const SYNCING_ASSET_EDITOR_REFERENCE_SUCCEDDED = "LEGACY_SYNCING_ASSET_EDITOR_REFERENCE_SUCCEDDED";
export const SYNCING_ASSET_EDITOR_REFERENCE_FAILED = "LEGACY_SYNCING_ASSET_EDITOR_REFERENCE_FAILED";

export const INVALIDATE_ASSET_EDITOR_REFERENCE = "LEGACY_INVALIDATE_ASSET_EDITOR_REFERENCE";

//Allocadia Integration
export const SAVING_ALLOCADIA_INTEGRATION_REQUEST = "LEGACY_SAVING_ALLOCADIA_INTEGRATION_REQUEST";
export const SAVING_ALLOCADIA_INTEGRATION_SUCCEDDED = "LEGACY_SAVING_ALLOCADIA_INTEGRATION_SUCCEDDED";
export const SAVING_ALLOCADIA_INTEGRATION_FAILED = "LEGACY_SAVING_ALLOCADIA_INTEGRATION_FAILED";

export const FETCHING_ALLOCADIA_INTEGRATION_REQUEST = "LEGACY_FETCHING_ALLOCADIA_INTEGRATION_REQUEST";
export const FETCHING_ALLOCADIA_INTEGRATION_SUCCEDDED = "LEGACY_FETCHING_ALLOCADIA_INTEGRATION_SUCCEDDED";
export const FETCHING_ALLOCADIA_INTEGRATION_FAILED = "LEGACY_FETCHING_ALLOCADIA_INTEGRATION_FAILED";

export const FETCHING_ALLOCADIA_BUDGETS_REQUEST = "LEGACY_FETCHING_ALLOCADIA_BUDGETS_REQUEST";
export const FETCHING_ALLOCADIA_BUDGETS_SUCCEDDED = "LEGACY_FETCHING_ALLOCADIA_BUDGETS_SUCCEDDED";
export const FETCHING_ALLOCADIA_BUDGETS_FAILED = "LEGACY_FETCHING_ALLOCADIA_BUDGETS_FAILED";

export const FETCHING_ALLOCADIA_CATEGORIES_REQUEST = "LEGACY_FETCHING_ALLOCADIA_CATEGORIES_REQUEST";
export const FETCHING_ALLOCADIA_CATEGORIES_SUCCEDDED = "LEGACY_FETCHING_ALLOCADIA_CATEGORIES_SUCCEDDED";
export const FETCHING_ALLOCADIA_CATEGORIES_FAILED = "LEGACY_FETCHING_ALLOCADIA_CATEGORIES_FAILED";

export const FETCHING_ALLOCADIA_COLUMNS_REQUEST = "LEGACY_FETCHING_ALLOCADIA_COLUMNS_REQUEST";
export const FETCHING_ALLOCADIA_COLUMNS_SUCCEDDED = "LEGACY_FETCHING_ALLOCADIA_COLUMNS_SUCCEDDED";
export const FETCHING_ALLOCADIA_COLUMNS_FAILED = "LEGACY_FETCHING_ALLOCADIA_COLUMNS_FAILED";

export const FETCHING_ALLOCADIA_COLUMN_CHOICES_REQUEST = "LEGACY_FETCHING_ALLOCADIA_COLUMN_CHOICES_REQUEST";
export const FETCHING_ALLOCADIA_COLUMN_CHOICES_SUCCEDDED = "LEGACY_FETCHING_ALLOCADIA_COLUMN_CHOICES_SUCCEDDED";
export const FETCHING_ALLOCADIA_COLUMN_CHOICES_FAILED = "LEGACY_FETCHING_ALLOCADIA_COLUMN_CHOICES_FAILED";

export const CREATING_ALLOCADIA_LINE_ITEM_REQUEST = "LEGACY_CREATING_ALLOCADIA_LINE_ITEM_REQUEST";
export const CREATING_ALLOCADIA_LINE_ITEM_SUCCEDDED = "LEGACY_CREATING_ALLOCADIA_LINE_ITEM_SUCCEDDED";
export const CREATING_ALLOCADIA_LINE_ITEM_FAILED = "LEGACY_CREATING_ALLOCADIA_LINE_ITEM_FAILED";

export const FETCHING_ALLOCADIA_MAPPING_REQUEST = "LEGACY_FETCHING_ALLOCADIA_MAPPING_REQUEST";
export const FETCHING_ALLOCADIA_MAPPING_SUCCEDDED = "LEGACY_FETCHING_ALLOCADIA_MAPPING_SUCCEDDED";
export const FETCHING_ALLOCADIA_MAPPING_FAILED = "LEGACY_FETCHING_ALLOCADIA_MAPPING_FAILED";

//Opportunities
export const FETCHING_INTEGRATION_OPPORTUNITIES = "LEGACY_FETCHING_INTEGRATION_OPPORTUNITIES";
export const FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED = "LEGACY_FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED";
export const FETCHING_INTEGRATION_OPPORTUNITIES_FAILED = "LEGACY_FETCHING_INTEGRATION_OPPORTUNITIES_FAILED";

export const INVALIDATE_INTEGRATION_OPPORTUNITIES = "LEGACY_INVALIDATE_INTEGRATION_OPPORTUNITIES";

export const ADD_OPPORTUNITY_TO_SHARE = "LEGACY_ADD_OPPORTUNITY_TO_SHARE";
export const ADD_OPPORTUNITY_TO_SHARE_SUCCEEDED = "LEGACY_ADD_OPPORTUNITY_TO_SHARE_SUCCEEDED";
export const ADD_OPPORTUNITY_TO_SHARE_FAILED = "LEGACY_ADD_OPPORTUNITY_TO_SHARE_FAILED";

export const REMOVE_OPPORTUNITY_FROM_SHARE = "LEGACY_REMOVE_OPPORTUNITY_FROM_SHARE";
export const REMOVE_OPPORTUNITY_FROM_SHARE_SUCCEEDED = "LEGACY_REMOVE_OPPORTUNITY_FROM_SHARE_SUCCEEDED";
export const REMOVE_OPPORTUNITY_FROM_SHARE_FAILED = "LEGACY_REMOVE_OPPORTUNITY_FROM_SHARE_FAILED";

//Update Pages
export const UPDATING_PAGES_TO_ASSET_REQUEST = "LEGACY_UPDATING_PAGES_TO_ASSET_REQUEST";
export const UPDATING_PAGES_TO_ASSET_SUCCEDDED = "LEGACY_UPDATING_PAGES_TO_ASSET_SUCCEDDED";
export const UPDATING_PAGES_TO_ASSET_FAILED = "LEGACY_UPDATING_PAGES_TO_ASSET_FAILED";

export const INVALIDATE_MERGE_TASK = "LEGACY_INVALIDATE_MERGE_TASK";

//Collection List
export const CREATING_COLLECTION_LIST_REQUEST = "LEGACY_CREATING_COLLECTION_LIST_REQUEST";
export const CREATING_COLLECTION_LIST_SUCCEEDED = "LEGACY_CREATING_COLLECTION_LIST_SUCCEEDED";
export const CREATING_COLLECTION_LIST_FAILED = "LEGACY_CREATING_COLLECTION_LIST_FAILED";

export const FETCHING_COLLECTION_LISTS_REQUEST = "LEGACY_FETCHING_COLLECTION_LISTS_REQUEST";
export const FETCHING_COLLECTION_LISTS_SUCCEEDED = "LEGACY_FETCHING_COLLECTION_LISTS_SUCCEEDED";
export const FETCHING_COLLECTION_LISTS_FAILED = "LEGACY_FETCHING_COLLECTION_LISTS_FAILED";

export const FETCHING_COLLECTION_LIST_REQUEST = "LEGACY_FETCHING_COLLECTION_LIST_REQUEST";
export const FETCHING_COLLECTION_LIST_SUCCEEDED = "LEGACY_FETCHING_COLLECTION_LIST_SUCCEEDED";
export const FETCHING_COLLECTION_LIST_FAILED = "LEGACY_FETCHING_COLLECTION_LIST_FAILED";

export const DELETING_COLLECTION_LIST_REQUEST = "LEGACY_DELETING_COLLECTION_LIST_REQUEST";
export const DELETING_COLLECTION_LIST_SUCCEEDED = "LEGACY_DELETING_COLLECTION_LIST_SUCCEEDED";
export const DELETING_COLLECTION_LIST_FAILED = "LEGACY_DELETING_COLLECTION_LIST_FAILED";

export const UPDATING_COLLECTION_LIST_REQUEST = "LEGACY_UPDATING_COLLECTION_LIST_REQUEST";
export const UPDATING_COLLECTION_LIST_SUCCEEDED = "LEGACY_UPDATING_COLLECTION_LIST_SUCCEEDED";
export const UPDATING_COLLECTION_LIST_FAILED = "LEGACY_UPDATING_COLLECTION_LIST_FAILED";

export const ADDING_COLLECTION_TO_LIST_REQUEST = "LEGACY_ADDING_COLLECTION_TO_LIST_REQUEST";
export const ADDING_COLLECTION_TO_LIST_SUCCEEDED = "LEGACY_ADDING_COLLECTION_TO_LIST_SUCCEEDED";
export const ADDING_COLLECTION_TO_LIST_FAILED = "LEGACY_ADDING_COLLECTION_TO_LIST_FAILED";

export const REMOVING_COLLECTION_FROM_LIST_REQUEST = "LEGACY_REMOVING_COLLECTION_FROM_LIST_REQUEST";
export const REMOVING_COLLECTION_FROM_LIST_SUCCEEDED = "LEGACY_REMOVING_COLLECTION_FROM_LIST_SUCCEEDED";
export const REMOVING_COLLECTION_FROM_LIST_FAILED = "LEGACY_REMOVING_COLLECTION_FROM_LIST_FAILED";

// Performance Reports
export const FETCHING_PERFORMANCE_SUMMARY_REQUEST = "LEGACY_FETCHING_PERFORMANCE_SUMMARY_REQUEST";
export const FETCHING_PERFORMANCE_SUMMARY_SUCCEEDED = "LEGACY_FETCHING_PERFORMANCE_SUMMARY_SUCCEDDED";
export const FETCHING_PERFORMANCE_SUMMARY_FAILED = "LEGACY_FETCHING_PERFORMANCE_SUMMARY_FAILED";

export const FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT = "LEGACY_FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED = "LEGACY_FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED";
export const FETCHING_PERFORMANCE_INTERACTIONS_FAILED = "LEGACY_FETCHING_PERFORMANCE_INTERACTIONS_FAILED";

export const FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT = "LEGACY_FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_LEADS_SUCCEEDED = "LEGACY_FETCHING_PERFORMANCE_LEADS_SUCCEEDED";
export const FETCHING_PERFORMANCE_LEADS_FAILED = "LEGACY_FETCHING_PERFORMANCE_LEADS_FAILED";

export const FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT = "LEGACY_FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_DEALS_SUCCEEDED = "LEGACY_FETCHING_PERFORMANCE_DEALS_SUCCEEDED";
export const FETCHING_PERFORMANCE_DEALS_FAILED = "LEGACY_FETCHING_PERFORMANCE_DEALS_FAILED";

export const FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT = "LEGACY_FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED = "LEGACY_FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED";
export const FETCHING_PERFORMANCE_DEAL_VALUE_FAILED = "LEGACY_FETCHING_PERFORMANCE_DEAL_VALUE_FAILED";

export const FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT = "LEGACY_FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED = "LEGACY_FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED";
export const FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED = "LEGACY_FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED";

export const FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT = "LEGACY_FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED = "LEGACY_FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED";
export const FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED = "LEGACY_FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED";

export const FETCHING_PERFORMANCE_TOP_LEADS_CONTENT = "LEGACY_FETCHING_PERFORMANCE_TOP_LEADS_CONTENT";
export const FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED = "LEGACY_FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED";
export const FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED = "LEGACY_FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED";

export const FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS = "LEGACY_FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS";
export const FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED = "LEGACY_FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED";
export const FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED = "LEGACY_FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED";

export const FETCHING_CLOSED_DEALS_DETAIL_REPORT = "LEGACY_FETCHING_CLOSED_DEALS_DETAIL_REPORT";
export const FETCHING_CLOSED_DEALS_DETAIL_REPORT_SUCCEEDED = "LEGACY_FETCHING_CLOSED_DEALS_DETAIL_REPORT_SUCCEEDED";
export const FETCHING_CLOSED_DEALS_DETAIL_REPORT_FAILED = "LEGACY_FETCHING_CLOSED_DEALS_DETAIL_REPORT_FAILED";

export const FETCHING_DEALS_REQUEST_DETAIL_REPORT = "LEGACY_FETCHING_DEALS_REQUEST_DETAIL_REPORT";
export const FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED = "LEGACY_FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED";
export const FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED = "LEGACY_FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED";

export const FETCHING_LEADS_DETAIL_REPORT = "LEGACY_FETCHING_LEADS_DETAIL_REPORT";
export const FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED = "LEGACY_FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED";
export const FETCHING_LEADS_DETAIL_REPORT_FAILED = "LEGACY_FETCHING_LEADS_DETAIL_REPORT_FAILED";

//Fetch Collaborated Users and Usergroups
export const FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_REQUEST = "LEGACY_FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_REQUEST";
export const FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_SUCCEEDED = "LEGACY_FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_SUCCEEDED";
export const FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_FAILED = "LEGACY_FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_FAILED";

//Fetch Line Item By Id
export const SEARCHING_LINE_ITEM = "LEGACY_SEARCHING_LINE_ITEM";
export const SEARCHING_LINE_ITEM_SUCCEDDED = "LEGACY_SEARCHING_LINE_ITEM_SUCCEDDED";
export const SEARCHING_LINE_ITEM_FAILED = "LEGACY_SEARCHING_LINE_ITEM_FAILED";

//Invalidate line Items
export const INVALIDATE_LINE_ITEMS = "LEGACY_INVALIDATE_LINE_ITEMS";

//Create Rss Datasource
export const CREATING_RSS_DATA_SOURCE_REQUEST = "LEGACY_CREATING_RSS_DATA_SOURCE_REQUEST";
export const CREATING_RSS_DATA_SOURCE_SUCCEDDED = "LEGACY_CREATING_RSS_DATA_SOURCE_SUCCEDDED";
export const CREATING_RSS_DATA_SOURCE_FAILED = "LEGACY_CREATING_RSS_DATA_SOURCE_FAILED";

//Live Talk
export const INITIATING_SMALL_TALK_CLIENT_REQUEST = "LEGACY_INITIATING_SMALL_TALK_CLIENT_REQUEST";
export const INITIATING_SMALL_TALK_CLIENT_SUCCEDDED = "LEGACY_INITIATING_SMALL_TALK_CLIENT_SUCCEDDED";
export const INITIATING_SMALL_TALK_CLIENT_FAILED = "LEGACY_INITIATING_SMALL_TALK_CLIENT_FAILED";

export const INITIATE_SMALL_TALK_SESSION = "LEGACY_INITIATE_SMALL_TALK_SESSION";
export const INVALIDATE_SMALL_TALK_SESSION = "LEGACY_INVALIDATE_SMALL_TALK_SESSION";
export const TOGGLE_SMALL_TALK_WINDOW_VISIBILITY = "LEGACY_TOGGLE_SMALL_TALK_WINDOW_VISIBILITY";

export const SENDING_SMALL_TALK_MESSAGE_REQUEST = "LEGACY_SENDING_SMALL_TALK_MESSAGE_REQUEST";
export const SENDING_SMALL_TALK_MESSAGE_SUCCEDDED = "LEGACY_SENDING_SMALL_TALK_MESSAGE_SUCCEDDED";
export const SENDING_SMALL_TALK_MESSAGE_FAILED = "LEGACY_SENDING_SMALL_TALK_MESSAGE_FAILED";

export const FETCHING_SMALL_TALK_MESSAGES_REQUEST =
  "LEGACY_FETCHING_SMALL_TALK_MESSAGES_REQUEST";
export const FETCHING_SMALL_TALK_MESSAGES_SUCCEDDED =
  "LEGACY_FETCHING_SMALL_TALK_MESSAGES_SUCCEDDED";
export const FETCHING_SMALL_TALK_MESSAGES_FAILED =
  "LEGACY_FETCHING_SMALL_TALK_MESSAGES_FAILED";

export const RECEIVED_SMALL_TALK_MESSAGE = "LEGACY_RECEIVED_SMALL_TALK_MESSAGE";

export const TOGGLE_SMALL_TALK_CONTACT_PRESENCE =
  "LEGACY_TOGGLE_SMALL_TALK_CONTACT_PRESENCE";

export const FETCHING_SMALL_TALK_CONTACT_PRESENCE_REQUEST =
  "LEGACY_FETCHING_SMALL_TALK_CONTACT_PRESENCE_REQUEST";
export const FETCHING_SMALL_TALK_CONTACT_PRESENCE_SUCCEDDED =
  "LEGACY_FETCHING_SMALL_TALK_CONTACT_PRESENCE_SUCCEDDED";
export const FETCHING_SMALL_TALK_CONTACT_PRESENCE_FAILED =
  "LEGACY_FETCHING_SMALL_TALK_CONTACT_PRESENCE_FAILED";

//Update Reports Filter
export const UPDATE_FILTERS_IN_REPORTS = "LEGACY_UPDATE_FILTERS_IN_REPORTS";

//Save Filter
export const SAVE_FILTER_REQUEST = "LEGACY_SAVE_FILTER_REQUEST";
export const SAVING_FILTER_REQUEST_SUCCEEDED =
  "LEGACY_SAVING_FILTER_REQUEST_SUCCEEDED";
export const SAVING_FILTER_REQUEST_FAILED = "LEGACY_SAVING_FILTER_REQUEST_FAILED";

//Fetch All Filters
export const FETCH_ALL_FILTERS_REQUEST = "LEGACY_FETCH_ALL_FILTERS_REQUEST";
export const FETCHING_ALL_FILTERS_SUCCEEDED = "LEGACY_FETCHING_ALL_FILTERS_SUCCEEDED";
export const FETCHING_ALL_FILTERS_FAILED = "LEGACY_FETCHING_ALL_FILTERS_FAILED";

//Select Filter
export const SELECT_FILTER_REQUEST = "LEGACY_SELECT_FILTER_REQUEST";

//Update Filter
export const UPDATE_FILTER_REQUEST = "LEGACY_UPDATE_FILTER_REQUEST";
export const UPDATING_FILTER_REQUEST_SUCCEEDED =
  "LEGACY_UPDATING_FILTER_REQUEST_SUCCEEDED";
export const UPDATING_FILTER_REQUEST_FAILED = "LEGACY_UPDATING_FILTER_REQUEST_FAILED";

//Fetch Filter
export const FETCH_FILTER_REQUEST = "LEGACY_FETCH_FILTER_REQUEST";
export const FETCHING_FILTER_REQUEST_SUCCEEDED =
  "LEGACY_FETCHING_FILTER_REQUEST_SUCCEEDED";
export const FETCHING_FILTER_REQUEST_FAILED = "LEGACY_FETCHING_FILTER_REQUEST_FAILED";

//Set Collection as Template
export const SET_COLLECTION_AS_TEMPLATE_REQUEST =
  "LEGACY_SET_COLLECTION_AS_TEMPLATE_REQUEST";
export const SET_COLLECTION_AS_TEMPLATE_SUCCEEDED =
  "LEGACY_SET_COLLECTION_AS_TEMPLATE_SUCCEEDED";
export const SET_COLLECTION_AS_TEMPLATE_FAILED =
  "LEGACY_SET_COLLECTION_AS_TEMPLATE_FAILED";

//Set Collection as Internal
export const SET_COLLECTION_AS_INTERNAL_REQUEST =
  "LEGACY_SET_COLLECTION_AS_INTERNAL_REQUEST";
export const SET_COLLECTION_AS_INTERNAL_SUCCEEDED =
  "LEGACY_SET_COLLECTION_AS_INTERNAL_SUCCEEDED";
export const SET_COLLECTION_AS_INTERNAL_FAILED =
  "LEGACY_SET_COLLECTION_AS_INTERNAL_FAILED";

//User Roles
export const FETCH_USER_ROLES_FOR_ACCOUNT = "LEGACY_FETCH_USER_ROLES_FOR_ACCOUNT";
export const FETCH_USER_ROLES_FOR_ACCOUNT_SUCCEEDED =
  "LEGACY_FETCH_USER_ROLES_FOR_ACCOUNT_SUCCEEDED";
export const FETCH_USER_ROLES_FOR_ACCOUNT_FAILED =
  "LEGACY_FETCH_USER_ROLES_FOR_ACCOUNT_FAILED";

export const FETCH_USER_ROLE = "LEGACY_FETCH_USER_ROLE";
export const FETCH_USER_ROLE_SUCCEEDED = "LEGACY_FETCH_USER_ROLE_SUCCEEDED";
export const FETCH_USER_ROLE_FAILED = "LEGACY_FETCH_USER_ROLE_FAILED";

export const ASSIGN_USER_ROLE = "LEGACY_ASSIGN_USER_ROLE";
export const ASSIGN_USER_ROLE_SUCCEEDED = "LEGACY_ASSIGN_USER_ROLE_SUCCEEDED";
export const ASSIGN_USER_ROLE_FAILED = "LEGACY_ASSIGN_USER_ROLE_FAILED";

export const CREATE_USER_ROLE = "LEGACY_CREATE_USER_ROLE";
export const CREATING_USER_ROLE_SUCCEEDED = "LEGACY_CREATING_USER_ROLE_SUCCEEDED";
export const CREATING_USER_ROLE_FAILED = "LEGACY_CREATING_USER_ROLE_FAILED";

export const UPDATE_USER_ROLE = "LEGACY_UPDATE_USER_ROLE";
export const UPDATING_USER_ROLE_SUCCEEDED = "LEGACY_UPDATING_USER_ROLE_SUCCEEDED";
export const UPDATING_USER_ROLE_FAILED = "LEGACY_UPDATING_USER_ROLE_FAILED";

export const DELETE_USER_ROLE = "LEGACY_DELETE_USER_ROLE";
export const DELETING_USER_ROLE_SUCCEEDED = "LEGACY_DELETING_USER_ROLE_SUCCEEDED";
export const DELETING_USER_ROLE_FAILED = "LEGACY_DELETING_USER_ROLE_FAILED";

export const SEARCH_USER_ROLES_FOR_AUTO_COMPLETE = "LEGACY_SEARCH_USER_ROLES_FOR_AUTO_COMPLETE";
export const SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_SUCCEEDED = "LEGACY_SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_SUCCEEDED";
export const SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_FAILED = "LEGACY_SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_FAILED";


//Usermanagement
export const FETCHING_USER_MANAGEMENT_LIST_REQUEST =
  "LEGACY_FETCHING_USER_MANAGEMENT_LIST_REQUEST";
export const FETCHING_USER_MANAGEMENT_LIST_SUCCEEDED =
  "LEGACY_FETCHING_USER_MANAGEMENT_LIST_SUCCEEDED";
export const FETCHING_USER_MANAGEMENT_LIST_FAILED =
  "LEGACY_FETCHING_USER_MANAGEMENT_LIST_FAILED";

export const FETCHING_USER_MANAGEMENT_USER_REQUEST =
  "LEGACY_FETCHING_USER_MANAGEMENT_USER_REQUEST";
export const FETCHING_USER_MANAGEMENT_USER_SUCCEEDED =
  "LEGACY_FETCHING_USER_MANAGEMENT_USER_SUCCEEDED";
export const FETCHING_USER_MANAGEMENT_USER_FAILED =
  "LEGACY_FETCHING_USER_MANAGEMENT_USER_FAILED";

export const INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_REQUEST =
  "LEGACY_INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_REQUEST";
export const INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_SUCCEDDED =
  "LEGACY_INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_SUCCEDDED";
export const INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_FAILED =
  "LEGACY_INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_FAILED";

export const FETCHING_USER_GROUPS_FOR_USER_REQUEST =
  "LEGACY_FETCHING_USER_GROUPS_FOR_USER_REQUEST";
export const FETCHING_USER_GROUPS_FOR_USER_SUCCEEDED =
  "LEGACY_FETCHING_USER_GROUPS_FOR_USER_SUCCEEDED";
export const FETCHING_USER_GROUPS_FOR_USER_FAILED =
  "LEGACY_FETCHING_USER_GROUPS_FOR_USER_FAILED";

export const INVALIDATE_USER_GROUPS = "LEGACY_INVALIDATE_USER_GROUPS";

//product
export const FETCHING_APPLICATION_VERSION = "LEGACY_FETCHING_APPLICATION_VERSION";
export const FETCHING_APPLICATION_VERSION_SUCCEDDED =
  "LEGACY_FETCHING_APPLICATION_VERSION_SUCCEDDED";
export const FETCHING_APPLICATION_VERSION_FAILED =
  "LEGACY_FETCHING_APPLICATION_VERSION_FAILED";

// Custom Hub
export const TOGGLE_EDIT_HUB_SECTION = "LEGACY_TOGGLE_EDIT_HUB_SECTION";
export const UPDATE_HUB_SECTION_CONTENTS = "LEGACY_UPDATE_HUB_SECTION_CONTENTS";
export const UPDATING_HUB_SECTION_CONTENTS_SUCCEEDED =
  "LEGACY_UPDATING_HUB_SECTION_CONTENTS_SUCCEEDED";
export const UPDATING_HUB_SECTION_CONTENTS_FAILED =
  "LEGACY_UPDATING_HUB_SECTION_CONTENTS_FAILED";


//Create Hub
export const UPDATING_HUB_SECTION_REQUEST = "LEGACY_UPDATING_HUB_SECTION_REQUEST";
export const UPDATING_HUB_SECTION_SUCCEEDED = "LEGACY_UPDATING_HUB_SECTION_SUCCEEDED";
export const UPDATING_HUB_SECTION_FAILED = "LEGACY_UPDATING_HUB_SECTION_FAILED";

//Create Hub
export const CREATING_HUB_SECTION_REQUEST = "LEGACY_CREATING_HUB_SECTION_REQUEST";
export const CREATING_HUB_SECTION_SUCCEEDED = "LEGACY_CREATING_HUB_SECTION_SUCCEEDED";
export const CREATING_HUB_SECTION_FAILED = "LEGACY_CREATING_HUB_SECTION_FAILED";


export const FETCHING_DUPLICATE_ASSET = "LEGACY_FETCHING_DUPLICATE_ASSET";
export const FETCHING_DUPLICATE_ASSET_SUCCEEDED =
  "LEGACY_FETCHING_DUPLICATE_ASSET_SUCCEEDED";
export const FETCHING_DUPLICATE_ASSET_FAILED =
  "LEGACY_FETCHING_DUPLICATE_ASSET_FAILED";

//organizations
export const FETCHING_ORGANIZATIONS_REQUEST = "LEGACY_FETCHING_ORGANIZATIONS_REQUEST";
export const FETCHING_ORGANIZATIONS_SUCCEEDED =
  "LEGACY_FETCHING_ORGANIZATIONS_SUCCEEDED";
export const FETCHING_ORGANIZATIONS_FAILED = "LEGACY_FETCHING_ORGANIZATIONS_FAILED";
export const INVALIDATE_ORGANIZATIONS = "LEGACY_INVALIDATE_ORGANIZATIONS";

//Chat Users
export const FETCHING_ALL_CHAT_USERS_REQUEST =
  "LEGACY_FETCHING_ALL_CHAT_USERS_REQUEST";
export const FETCHING_ALL_CHAT_USERS_SUCCEEDED =
  "LEGACY_FETCHING_ALL_CHAT_USERS_SUCCEEDED";
export const FETCHING_ALL_CHAT_USERS_FAILED = "LEGACY_FETCHING_ALL_CHAT_USERS_FAILED";

//My Chat Users
export const FETCHING_MY_CHAT_USERS_REQUEST = "LEGACY_FETCHING_MY_CHAT_USERS_REQUEST";
export const FETCHING_MY_CHAT_USERS_SUCCEEDED =
  "LEGACY_FETCHING_MY_CHAT_USERS_SUCCEEDED";
export const FETCHING_MY_CHAT_USERS_FAILED = "LEGACY_FETCHING_MY_CHAT_USERS_FAILED";

//My Live Chat Users
export const FETCHING_LIVE_CHAT_USERS_REQUEST =
  "LEGACY_FETCHING_LIVE_CHAT_USERS_REQUEST";
export const FETCHING_LIVE_CHAT_USERS_SUCCEEDED =
  "LEGACY_FETCHING_LIVE_CHAT_USERS_SUCCEEDED";
export const FETCHING_LIVE_CHAT_USERS_FAILED =
  "LEGACY_FETCHING_LIVE_CHAT_USERS_FAILED";

//My Engaged Chat Users
export const FETCHING_ENGAGED_CHAT_USERS_REQUEST =
  "LEGACY_FETCHING_ENGAGED_CHAT_USERS_REQUEST";
export const FETCHING_ENGAGED_CHAT_USERS_SUCCEEDED =
  "LEGACY_FETCHING_ENGAGED_CHAT_USERS_SUCCEEDED";
export const FETCHING_ENGAGED_CHAT_USERS_FAILED =
  "LEGACY_FETCHING_ENGAGED_CHAT_USERS_FAILED";

//Chat User
export const FETCHING_CHAT_USER_REQUEST = "LEGACY_FETCHING_CHAT_USER_REQUEST";
export const FETCHING_CHAT_USER_SUCCEEDED = "LEGACY_FETCHING_CHAT_USER_SUCCEEDED";
export const FETCHING_CHAT_USER_FAILED = "LEGACY_FETCHING_CHAT_USER_FAILED";

//Associate Chat User
export const ASSOCIATE_CHAT_USER_REQUEST = "LEGACY_ASSOCIATE_CHAT_USER_REQUEST";
export const ASSOCIATING_CHAT_USER_SUCCEEDED =
  "LEGACY_ASSOCIATING_CHAT_USER_SUCCEEDED";
export const ASSOCIATING_CHAT_USER_FAILED = "LEGACY_ASSOCIATING_CHAT_USER_FAILED";

//Associate Chat User
export const SEND_MESSAGE_AS_EMAIL = "LEGACY_SEND_MESSAGE_AS_EMAIL";
export const SEND_MESSAGE_AS_EMAIL_SUCCEEDED =
  "LEGACY_SEND_MESSAGE_AS_EMAIL_SUCCEEDED";
export const SEND_MESSAGE_AS_EMAIL_FAILED = "LEGACY_SEND_MESSAGE_AS_EMAIL_FAILED";

//Locations For Chat Users
export const FETCHING_LOCATIONS_FOR_CHAT_USERS_REQUEST =
  "LEGACY_FETCH_LOCATIONS_FOR_CHAT_USERS_REQUEST";
export const FETCHING_LOCATIONS_FOR_CHAT_USERS_SUCCEEDED =
  "LEGACY_FETCH_LOCATIONS_FOR_CHAT_USERS_SUCCEEDED";
export const FETCHING_LOCATIONS_FOR_CHAT_USERS_FAILED =
  "LEGACY_FETCH_LOCATIONS_FOR_CHAT_USERS_FAILED";

//Nudges For User
export const FETCHING_NUDGES_REQUEST = "LEGACY_FETCHING_NUDGES_REQUEST";
export const FETCHING_NUDGES_SUCCEEDED = "LEGACY_FETCHING_NUDGES_SUCCEEDED";
export const FETCHING_NUDGES_FAILED = "LEGACY_FETCHING_NUDGES_FAILED";

//Update unread for chat user
export const UPDATING_UNREAD_FOR_CHAT_USER_REQUEST =
  "LEGACY_UPDATING_UNREAD_FOR_CHAT_USER_REQUEST";
export const UPDATING_UNREAD_FOR_CHAT_USER_SUCCEEDED =
  "LEGACY_UPDATING_UNREAD_FOR_CHAT_USER_SUCCEEDED";
export const UPDATING_UNREAD_FOR_CHAT_USER_FAILED =
  "LEGACY_UPDATING_UNREAD_FOR_CHAT_USER_FAILED";

//Fetch Currently Viewing Asset for Chat User

export const FETCH_CURRENTLY_VIEWING_ASSET = "LEGACY_FETCH_CURRENTLY_VIEWING_ASSET";
export const FETCH_CURRENTLY_VIEWING_ASSET_SUCCEEDED =
  "LEGACY_FETCH_CURRENTLY_VIEWING_ASSET_SUCCEEDED";
export const FETCH_CURRENTLY_VIEWING_ASSET_FAILED =
  "LEGACY_FETCH_CURRENTLY_VIEWING_ASSET_FAILED";
export const INVALIDATE_LIVE_VIEW_DATA = "LEGACY_INVALIDATE_LIVE_VIEW_DATA";

//Block Chat User
export const BLOCK_CHAT_USER = "LEGACY_BLOCK_CHAT_USER";
export const BLOCK_CHAT_USER_SUCCEEDED = "LEGACY_BLOCK_CHAT_USER_SUCCEEDED";
export const BLOCK_CHAT_USER_FAILED = "LEGACY_BLOCK_CHAT_USER_FAILED";

// Media Library Categories
export const FETCHING_MEDIA_LIBRARY_CATEGORIES = "LEGACY_FETCHING_MEDIA_LIBRARY_CATEGORIES";
export const FETCHING_MEDIA_LIBRARY_CATEGORIES_SUCCEEDED = "LEGACY_FETCHING_MEDIA_LIBRARY_CATEGORIES_SUCCEEDED";
export const FETCHING_MEDIA_LIBRARY_CATEGORIES_FAILED = "LEGACY_FETCHING_MEDIA_LIBRARY_CATEGORIES_FAILED";

export const FETCHING_MEDIA_LIBRARY_FOR_CATEGORY = "LEGACY_FETCHING_MEDIA_LIBRARY_FOR_CATEGORY";
export const FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_SUCCEEDED = "LEGACY_FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_SUCCEEDED";
export const FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_FAILED = "LEGACY_FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_FAILED";

// content manager
export const AUTHORIZING_NETSUITE_REQUEST = "LEGACY_AUTHORIZING_NETSUITE_REQUEST";
export const AUTHORIZING_NETSUITE_SUCCEDDED = "LEGACY_AUTHORIZING_NETSUITE_SUCCEDDED";
export const AUTHORIZING_NETSUITE_FAILED = "LEGACY_AUTHORIZING_NETSUITE_FAILED";

export const AUTHENTICATING_NETSUITE_REQUEST = "LEGACY_AUTHENTICATING_NETSUITE_REQUEST";
export const AUTHENTICATING_NETSUITE_SUCCEDDED = "LEGACY_AUTHENTICATING_NETSUITE_SUCCEDDED";
export const AUTHENTICATING_NETSUITE_FAILED = "LEGACY_AUTHENTICATING_NETSUITE_FAILED";

export const FETCHING_ASSETS_RESOURCE = "LEGACY_FETCHING_ASSETS_RESOURCE";
export const FETCHING_ASSETS_RESOURCE_SUCCEEDED = "LEGACY_FETCHING_ASSETS_RESOURCE_SUCCEEDED";
export const FETCHING_ASSETS_RESOURCE_FAILED = "LEGACY_FETCHING_ASSETS_RESOURCE_FAILED";
export const FETCHING_NETSUITE_INTEGRATION_REQUEST = "LEGACY_FETCHING_NETSUITE_INTEGRATION_REQUEST";
export const FETCHING_NETSUITE_INTEGRATION_SUCCEDDED = "LEGACY_FETCHING_NETSUITE_INTEGRATION_SUCCEDDED";
export const FETCHING_NETSUITE_INTEGRATION_FAILED = "LEGACY_FETCHING_NETSUITE_INTEGRATION_FAILED";

export const UPDATING_NETSUITE_REQUEST = "LEGACY_UPDATING_NETSUITE_REQUEST";
export const UPDATING_NETSUITE_SUCCEDDED = "LEGACY_UPDATING_NETSUITE_SUCCEDDED";
export const UPDATING_NETSUITE_FAILED = "LEGACY_UPDATING_NETSUITE_FAILED";

export const DEACTIVATING_NETSUITE_INTEGRATION_REQUEST = "LEGACY_DEACTIVATING_NETSUITE_INTEGRATION_REQUEST";
export const DEACTIVATING_NETSUITE_INTEGRATION_SUCCEDDED = "LEGACY_DEACTIVATING_NETSUITE_INTEGRATION_SUCCEDDED";
export const DEACTIVATING_NETSUITE_INTEGRATION_FAILED = "LEGACY_DEACTIVATING_NETSUITE_INTEGRATION_FAILED";

//Fetching deals
export const FETCHING_DEALS_REQUEST = "LEGACY_FETCHING_DEALS_REQUEST"
export const FETCHING_DEALS_SUCCEEDED = "LEGACY_FETCHING_DEALS_SUCCEEDED";
export const FETCHING_DEALS_FAILED = "LEGACY_FETCHING_DEALS_FAILED";

// fetching deals metrics
export const FETCHING_DEALS_METRICS_REQUEST = "LEGACY_FETCHING_DEALS_METRICS_REQUEST"
export const FETCHING_DEALS_METRICS_SUCCEEDED = "LEGACY_FETCHING_DEALS_METRICS_SUCCEEDED";
export const FETCHING_DEALS_METRICS_FAILED = "LEGACY_FETCHING_DEALS_METRICS_FAILED";

// fetching deal history
export const FETCHING_DEAL_HISTORY_REQUEST = "LEGACY_FETCHING_DEAL_HISTORY_REQUEST"
export const FETCHING_DEAL_HISTORY_SUCCEEDED = "LEGACY_FETCHING_DEAL_HISTORY_SUCCEEDED";
export const FETCHING_DEAL_HISTORY_FAILED = "LEGACY_FETCHING_DEAL_HISTORY_FAILED";

// fetching deal timeline
export const FETCHING_DEAL_TIMELINE_REQUEST = "LEGACY_FETCHING_DEAL_TIMELINE_REQUEST"
export const FETCHING_DEAL_TIMELINE_SUCCEEDED = "LEGACY_FETCHING_DEAL_TIMELINE_SUCCEEDED";
export const FETCHING_DEAL_TIMELINE_FAILED = "LEGACY_FETCHING_DEAL_TIMELINE_FAILED";

// fetching deal shared assets
export const FETCHING_DEAL_SHARED_ASSETS_REQUEST = "LEGACY_FETCHING_DEAL_SHARED_ASSETS_REQUEST"
export const FETCHING_DEAL_SHARED_ASSETS_SUCCEEDED = "LEGACY_FETCHING_DEAL_SHARED_ASSETS_SUCCEEDED";
export const FETCHING_DEAL_SHARED_ASSETS_FAILED = "LEGACY_FETCHING_DEAL_SHARED_ASSETS_FAILED";

// fetching deal shared collections
export const FETCHING_DEAL_SHARED_COLLECTIONS_REQUEST = "LEGACY_FETCHING_DEAL_SHARED_COLLECTIONS_REQUEST"
export const FETCHING_DEAL_SHARED_COLLECTIONS_SUCCEEDED = "LEGACY_FETCHING_DEAL_SHARED_COLLECTIONS_SUCCEEDED";
export const FETCHING_DEAL_SHARED_COLLECTIONS_FAILED = "LEGACY_FETCHING_DEAL_SHARED_COLLECTIONS_FAILED";

export const FETCHING_EXTERNAL_LIBRARY = "LEGACY_FETCHING_EXTERNAL_LIBRARY"
export const FETCHING_EXTERNAL_LIBRARY_SUCCEDED = "LEGACY_FETCHING_EXTERNAL_LIBRARY_SUCCEDED"
export const FETCHING_EXTERNAL_LIBRARY_FAILED = "LEGACY_FETCHING_EXTERNAL_LIBRARY_FAILED"
export const RESET_EXTERNAL_LIBRARY = "LEGACY_RESET_EXTERNAL_LIBRARY"

//fetching single deal
export const FETCHING_DEAL_REQUEST = "LEGACY_FETCHING_DEAL_REQUEST"
export const FETCHING_DEAL_SUCCEEDED = "LEGACY_FETCHING_DEAL_SUCCEEDED";
export const FETCHING_DEAL_FAILED = "LEGACY_FETCHING_DEAL_FAILED";
export const INVALIDATE_DEAL = "LEGACY_INVALIDATE_DEAL"

//excluding user
export const EXCLUDING_USER = "LEGACY_EXCLUDING_USER";
export const EXCLUDING_USER_SUCCEEDED = "LEGACY_EXCLUDING_USER_SUCCEEDED";
export const EXCLUDING_USER_FAILED = "LEGACY_EXCLUDING_USER_FAILED";

//OPEN AI Experiments
export const SEEK_ANSWER_FOR_QUESTION_REQUEST = "LEGACY_SEEK_ANSWER_FOR_QUESTION_REQUEST";
export const SEEK_ANSWER_FOR_QUESTION_SUCCEEDED = "LEGACY_SEEK_ANSWER_FOR_QUESTION_SUCCEEDED";
export const SEEK_ANSWER_FOR_QUESTION_FAILED = "LEGACY_SEEK_ANSWER_FOR_QUESTION_FAILED";
export const INVALIDATE_SEEK_SESSION = "LEGACY_INVALIDATE_SEEK_SESSION";

//Fetching OpenAI Sessions
export const FETCHING_SEEKQA_SESSIONS = "LEGACY_FETCHING_SEEKQA_SESSIONS";
export const FETCHING_SEEKQA_SESSIONS_SUCCEEDED = "LEGACY_FETCHING_SEEKQA_SESSIONS_SUCCEEDED";
export const FETCHING_SEEKQA_SESSIONS_FAILED = "LEGACY_FETCHING_SEEKQA_SESSIONS_FAILED";

//Fetching OpenAI Session by ID
export const FETCHING_SEEKQA_CHATS = "LEGACY_FETCHING_SEEKQA_CHATS";
export const FETCHING_SEEKQA_CHATS_SUCCEEDED = "LEGACY_FETCHING_SEEKQA_CHATS_SUCCEEDED";
export const FETCHING_SEEKQA_CHATS_FAILED = "LEGACY_FETCHING_SEEKQA_CHATS_FAILED";

// soft delete seekqa session
export const DELETING_SEEKQA_SESSION = "LEGACY_DELETING_SEEKQA_SESSION";
export const DELETING_SEEKQA_SESSION_SUCCEEDED = "LEGACY_DELETING_SEEKQA_SESSION_SUCCEEDED";
export const DELETING_SEEKQA_SESSION_FAILED = "LEGACY_DELETING_SEEKQA_SESSION_FAILED";

// soft delete seekqa sessions
export const DELETING_SEEKQA_SESSIONS = "LEGACY_DELETING_SEEKQA_SESSIONS";
export const DELETING_SEEKQA_SESSIONS_SUCCEEDED = "LEGACY_DELETING_SEEKQA_SESSIONS_SUCCEEDED";
export const DELETING_SEEKQA_SESSIONS_FAILED = "LEGACY_DELETING_SEEKQA_SESSIONS_FAILED";

// fetch seek qa suggestions
export const FETCHING_SEEKQA_SUGGESTIONS = "LEGACY_FETCHING_SEEKQA_SUGGESTIONS";
export const FETCHING_SEEKQA_SUGGESTIONS_SUCCEEDED = "LEGACY_FETCHING_SEEKQA_SUGGESTIONS_SUCCEEDED";
export const FETCHING_SEEKQA_SUGGESTIONS_FAILED = "LEGACY_FETCHING_SEEKQA_SUGGESTIONS_FAILED";
export const SORT_ASSET_RESOURCE = "LEGACY_SORT_ASSET_RESOURCE"

export const SAVING_CLUSTER = "LEGACY_SAVING_CLUSTER"
export const SAVING_CLUSTER_SUCCEDED = "LEGACY_SAVING_CLUSTER_SUCCEDED"
export const SAVING_CLUSTER_FAILED = "LEGACY_SAVING_CLUSTER_FAILED"

export const FETCHING_SAVED_CONTENT_FILTERS ="LEGACY_FETCHING_SAVED_CONTENT_FILTERS"
export const FETCHING_SAVED_CONTENT_FILTERS_SUCCEDED ="LEGACY_FETCHING_SAVED_CONTENT_FILTERS_SUCCEDED"
export const FETCHING_SAVED_CONTENT_FILTERS_FAILED ="LEGACY_FETCHING_SAVED_CONTENT_FILTERS_FAILED"

export const FETCHING_CLUSTER = "LEGACY_FETCHING_CLUSTER"
export const FETCHING_CLUSTER_SUCCEEDED = "LEGACY_FETCHING_CLUSTER_SUCCEEDED"
export const FETCHING_CLUSTER_FAILED = "LEGACY_FETCHING_CLUSTER_FAILED"

export const UPDATING_CLUSTER = "LEGACY_UPDATING_CLUSTER"
export const UPDATING_CLUSTER_SUCCEEDED = "LEGACY_UPDATING_CLUSTER_SUCCEEDED"
export const UPDATING_CLUSTER_FAILED = "LEGACY_UPDATING_CLUSTER_FAILED"

export const DELETING_CLUSTER = "LEGACY_DELETING_CLUSTER"
export const DELETING_CLUSTER_SUCCEEDED = "LEGACY_DELETING_CLUSTER_SUCCEEDED"
export const DELETING_CLUSTER_FAILED = "LEGACY_DELETING_CLUSTER_FAILED"

export const DELETING_CONTENT_ASSETS = "LEGACY_DELETING_CONTENT_ASSETS"
export const DELETING_CONTENT_ASSETS_SUCCEEDED = "LEGACY_DELETING_CONTENT_ASSETS_SUCCEEDED"
export const DELETING_CONTENT_ASSETS_FAILED = "LEGACY_DELETING_CONTENT_ASSETS_FAILED"

export const UPDATING_CONTENT_ASSETS = "LEGACY_UPDATING_CONTENT_ASSETS"
export const UPDATING_CONTENT_ASSETS_FAILED = "LEGACY_UPDATING_CONTENT_ASSETS_FAILED"
export const UPDATING_CONTENT_ASSETS_SUCCEEDED = "LEGACY_UPDATING_CONTENT_ASSETS_SUCCEEDED"


// Production Adoption Referral Capturing
export const RECORDING_REFERRAL_INFO = "LEGACY_RECORDING_REFERRAL_INFO";
export const RECORDING_REFERRAL_INFO_SUCCEEDED = "LEGACY_RECORDING_REFERRAL_INFO_SUCCEEDED";
export const RECORDING_REFERRAL_INFO_FAILED = "LEGACY_RECORDING_REFERRAL_INFO_FAILED";

//Seek helpful
export const UPDATING_SEEK_HELPFUL= "LEGACY_UPDATING_SEEK_HELPFUL";
export const UPDATING_SEEK_HELPFUL_SUCCEEDED = "LEGACY_UPDATING_SEEK_HELPFUL_SUCCEEDED";
export const UPDATING_SEEK_HELPFUL_FAILED = "LEGACY_UPDATING_SEEK_HELPFUL_FAILED";

//Application Communication
export const FETCH_APPLICATION_COMMUNICATION = "LEGACY_FETCH_APPLICATION_COMMUNICATION";
export const FETCH_APPLICATION_COMMUNICATION_SUCCEEDED = "LEGACY_FETCH_APPLICATION_COMMUNICATION_SUCCEEDED";
export const FETCH_APPLICATION_COMMUNICATION_FAILED = "LEGACY_FETCH_APPLICATION_COMMUNICATION_FAILED";

//Update Communication
export const UPDATE_COMMUNICATION = "LEGACY_UPDATE_COMMUNICATION";
export const UPDATE_COMMUNICATION_SUCCEEDED = "LEGACY_UPDATE_COMMUNICATION_SUCCEEDED";
export const UPDATE_COMMUNICATION_FAILED = "LEGACY_UPDATE_COMMUNICATION_FAILED";

//fetch email for seek response
export const FETCHING_EMAIL_FOR_SEEK_RESPONSE = "LEGACY_FETCHING_EMAIL_FOR_SEEK_RESPONSE" 
export const FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED = "LEGACY_FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED"
export const FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED = "LEGACY_FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED"

// Identify User
export const IDENTIFY_USER_REQUEST = "LEGACY_IDENTIFY_USER_REQUEST";
export const IDENTIFY_USER_SUCCEEDED = "LEGACY_IDENTIFY_USER_SUCCEEDED";
export const IDENTIFY_USER_FAILED = "LEGACY_IDENTIFY_USER_FAILED";

//getting seek limit for user
export const FETCHING_SEEK_LIMIT = "LEGACY_FETCHING_SEEK_LIMIT";
export const FETCHING_SEEK_LIMIT_FAILED = "LEGACY_FETCHING_SEEK_LIMIT_FAILED";
export const FETCHING_SEEK_LIMIT_SUCCEEDED = "LEGACY_FETCHING_SEEK_LIMIT_SUCCEEDED";

//salesforce new workflow
export const CHANGING_PRIMARY_CONFIGURATION = "LEGACY_CHANGING_PRIMARY_CONFIGURATION";
export const CHANGING_PRIMARY_CONFIGURATION_FAILED = "LEGACY_CHANGING_PRIMARY_CONFIGURATION_FAILED";
export const CHANGING_PRIMARY_CONFIGURATION_SUCCEEDED = "LEGACY_CHANGING_PRIMARY_CONFIGURATION_SUCCEEDED";

export const OVERIDING_PRIMARY_EVENTS = "LEGACY_OVERIDING_PRIMARY_EVENTS"
export const OVERIDING_PRIMARY_EVENTS_SUCCEEDED = "LEGACY_OVERIDING_PRIMARY_EVENTS_SUCCEEDED"
export const OVERIDING_PRIMARY_EVENTS_FAILED = "LEGACY_OVERIDING_PRIMARY_EVENTS_FAILED"

export const FETCHING_TOTAL_SALESFORCE_INTEGRATIONS = "LEGACY_FETCHING_TOTAL_SALESFORCE_INTEGRATIONS"
export const FETCHING_TOTAL_SALESFORCE_INTEGRATIONS_SUCCEEDED = "LEGACY_FETCHING_TOTAL_SALESFORCE_INTEGRATIONS_SUCCEEDED"
export const FETCHING_TOTAL_SALESFORCE_INTEGRATIONS_FAILED = "LEGACY_FETCHING_TOTAL_SALESFORCE_INTEGRATIONS_FAILED"

//getting seek questions count
export const FETCHING_SEEK_QUESTION_COUNT = "LEGACY_FETCHING_SEEK_QUESTION_COUNT";
export const FETCHING_SEEK_QUESTION_COUNT_SUCCEEDED = "LEGACY_FETCHING_SEEK_QUESTION_COUNT_SUCCEEDED";
export const FETCHING_SEEK_QUESTION_COUNT_FAILED = "LEGACY_FETCHING_SEEK_QUESTION_COUNT_FAILED";

//getting frequently shared assets
export const FETCHING_FREQUENTLY_SHARED_ASSETS = "LEGACY_FETCHING_FREQUENTLY_SHARED_ASSETS"
export const FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEEDED = "LEGACY_FETCHING_FREQUENTLY_SHARED_ASSETS_SUCCEEDED"
export const FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED = "LEGACY_FETCHING_FREQUENTLY_SHARED_ASSETS_FAILED"

//select, remove, invalidate and rearrange asset pages 
export const SELECT_ASSET_PAGE = "LEGACY_SELECT_ASSET_PAGE";
export const REMOVE_ASSET_PAGE = "LEGACY_REMOVE_ASSET_PAGE";
export const INVALIDATE_SELECTED_ASSET_PAGES = "LEGACY_INVALIDATE_SELECTED_ASSET_PAGES";
export const  REARRANGE_ASSET_PAGES = "LEGACY_REARRANGE_ASSET_PAGES";

//create asset from hub
export const CREATING_ASSET_FROM_HUB = "LEGACY_CREATING_ASSET_FROM_HUB";
export const CREATING_ASSET_FROM_HUB_SUCCEEDED = "LEGACY_CREATING_ASSET_FROM_HUB_SUCCEEDED";
export const CREATING_ASSET_FROM_HUB_FAILED = "LEGACY_CREATING_ASSET_FROM_HUB_FAILED";

//create asset progress
export const CREATING_ASSET_ID = "LEGACY_CREATING_ASSET_ID";
export const INVALIDATE_SELECTED_ASSET_ID = "LEGACY_INVALIDATE_SELECTED_ASSET_ID";
export const INVALIDATE_PROCESSED_ASSET_ID = "LEGACY_INVALIDATE_PROCESSED_ASSET_ID";

//stakeholders for deal room
export const FETCHING_STAKEHOLDERS_SUCCEEDED = "LEGACY_FETCHING_STAKEHOLDERS_SUCCEEDED";
export const FETCHING_STAKEHOLDERS_FAILED = "LEGACY_FETCHING_STAKEHOLDERS_FAILED";
export const FETCHING_STAKEHOLDERS = "LEGACY_FETCHING_STAKEHOLDERS";

//Frequently Shared Assets
export const FETCHING_CONTENT_RECOMMENDATIONS_REQUEST = 'LEGACY_FETCHING_CONTENT_RECOMMENDATIONS_REQUEST';
export const FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED = 'LEGACY_FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED';
export const FETCHING_CONTENT_RECOMMENDATIONS_FAILED = 'LEGACY_FETCHING_CONTENT_RECOMMENDATIONS_FAILED';

// adoption - tracking event
export const TRACKING_EVENT_REQUEST = "LEGACY_TRACKING_EVENT_REQUEST";
export const TRACKING_EVENT_SUCCEEDED = "LEGACY_TRACKING_EVENT_SUCCEEDED";
export const TRACKING_EVENT_FAILED = "LEGACY_TRACKING_EVENT_FAILED";

// adoption - identifying user
export const IDENTIFYING_USER_REQUEST = "LEGACY_IDENTIFYING_USER_REQUEST";
export const IDENTIFYING_USER_SUCCEEDED = "LEGACY_IDENTIFYING_USER_SUCCEEDED";
export const IDENTIFYING_USER_FAILED = "LEGACY_IDENTIFYING_USER_FAILED";


//fetch asset master report
export const FETCHING_ASSET_MASTER_REPORT = "LEGACY_FETCHING_ASSET_MASTER_REPORT";
export const FETCHING_ASSET_MASTER_REPORT_SUCCEEDED = "LEGACY_FETCHING_ASSET_MASTER_REPORT_SUCCEEDED";
export const FETCHING_ASSET_MASTER_REPORT_FAILED = "LEGACY_FETCHING_ASSET_MASTER_REPORT_FAILED";

//record asset click event
export const RECORD_SEARCH_CLICK = "LEGACY_RECORD_SEARCH_CLICK";
export const RECORD_SEARCH_CLICK_SUCCEEDED = "LEGACY_RECORD_SEARCH_CLICK_SUCCEEDED";
export const RECORD_SEARCH_CLICK_FAILED = "LEGACY_RECORD_SEARCH_CLICK_FAILED";

//deal insights signals
export const FETCHING_DEAL_INSIGHTS_SIGNALS = "LEGACY_FETCHING_DEAL_INSIGHTS_SIGNALS";
export const FETCHING_DEAL_INSIGHTS_SIGNALS_SUCCEEDED = "LEGACY_FETCHING_DEAL_INSIGHTS_SIGNALS_SUCCEEDED";
export const FETCHING_DEAL_INSIGHTS_SIGNALS_FAILED = "LEGACY_FETCHING_DEAL_INSIGHTS_SIGNALS_FAILED";
export const INVALIDATE_DEAL_INSIGHTS_SIGNALS = "LEGACY_INVALIDATE_DEAL_INSIGHTS_SIGNALS";
export const INVALIDATE_DEAL_INSIGHTS = "LEGACY_INVALIDATE_DEAL_INSIGHTS";

export const UPDATE_ASSET_ADDITIONAL_DATA_IN_COLLECTION = "LEGACY_UPDATE_ASSET_ADDITIONAL_DATA_IN_COLLECTION";
export const UPDATE_ASSET_ADDITIONAL_DATA_IN_CONVERSATION= "LEGACY_UPDATE_ASSET_ADDITIONAL_DATA_IN_CONVERSATION";

//asset processing
export const TRIGGERING_ASSET_PROCESSING_REQUEST = "LEGACY_TRIGGER_ASSET_PROCESSING_REQUEST";
export const TRIGGERING_ASSET_PROCESSING_SUCCEEDED = "LEGACY_TRIGGER_ASSET_PROCESSING_SUCCEEDED";
export const TRIGGERING_ASSET_PROCESSING_FAILED = "LEGACY_TRIGGER_ASSET_PROCESSING_FAILED";

//media
export const UPLOADING_MEDIA_REQUEST = "LEGACY_UPLOADING_MEDIA";
export const UPLOADING_MEDIA_SUCCEEDED = "LEGACY_UPLOADING_MEDIA_SUCCEEDED";
export const UPLOADING_MEDIA_FAILED = "LEGACY_UPLOADING_MEDIA_FAILED";

//cleverstory activation
export const FETCHING_ALL_WORKSPACES = "LEGACY_FETCHING_ALL_WORKSPACES";
export const FETCHING_ALL_WORKSPACES_SUCCEEDED = "LEGACY_FETCHING_ALL_WORKSPACES_SUCCEEDED";
export const FETCHING_ALL_WORKSPACES_FAILED = "LEGACY_FETCHING_ALL_WORKSPACES_FAILED";

export const FETCHING_STORYBOARDS_REQUEST = "LEGACY_FETCHING_STORYBOARDS_REQUEST";
export const FETCHING_STORYBOARDS_SUCCEEDED = "LEGACY_FETCHING_STORYBOARDS_SUCCEEDED";
export const FETCHING_STORYBOARDS_FAILED = "LEGACY_FETCHING_STORYBOARDS_FAILED";

export const ACTIVATING_CLEVERSTORY_WORKSPACE = "LEGACY_ACTIVATING_CLEVERSTORY_WORKSPACE";
export const ACTIVATING_CLEVERSTORY_WORKSPACE_SUCCEEDED = "LEGACY_ACTIVATING_CLEVERSTORY_WORKSPACE_SUCCEEDED";
export const ACTIVATING_CLEVERSTORY_WORKSPACE_FAILED = "LEGACY_ACTIVATING_CLEVERSTORY_WORKSPACE_FAILED";

export const FETCHING_ACTIVATED_WORKSPACES = "LEGACY_FETCHING_ACTIVATED_WORKSPACES";
export const FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED = "LEGACY_FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED";
export const FETCHING_ACTIVATED_WORKSPACES_FAILED = "LEGACY_FETCHING_ACTIVATED_WORKSPACES_FAILED";

export const FETCHING_PAGES_FROM_STORYBOARD = "LEGACY_FETCHING_PAGES_FROM_STORYBOARD";
export const FETCHING_PAGES_FROM_STORYBOARD_SUCCEEDED = "LEGACY_FETCHING_PAGES_FROM_STORYBOARD_SUCCEEDED";
export const FETCHING_PAGES_FROM_STORYBOARD_FAILED = "LEGACY_FETCHING_PAGES_FROM_STORYBOARD_FAILED";

export const CREATING_PAGE_FROM_STORYBOARD = "LEGACY_CREATING_PAGE_FROM_STORYBOARD";
export const CREATING_PAGE_FROM_STORYBOARD_SUCCEEDED = "LEGACY_CREATING_PAGE_FROM_STORYBOARD_SUCCEEDED";
export const CREATING_PAGE_FROM_STORYBOARD_FAILED = "LEGACY_CREATING_PAGE_FROM_STORYBOARD_FAILED";

export const UPDATING_CLEVERSTORY_ASSET_METADATA = "LEGACY_UPDATING_CLEVERSTORY_ASSET_METADATA";
export const UPDATING_CLEVERSTORY_ASSET_METADATA_SUCCEEDED = "LEGACY_UPDATING_CLEVERSTORY_ASSET_METADATA_SUCCEEDED";
export const UPDATING_CLEVERSTORY_ASSET_METADATA_FAILED = "LEGACY_UPDATING_CLEVERSTORY_ASSET_METADATA_FAILED";

export const INVALIDATE_CLEVERSTORY_PAGE_CREATION = "LEGACY_INVALIDATE_CLEVERSTORY_PAGE_CREATION";

//Account Summary
export const FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST =
"LEGACY_FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST";
export const FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED =
"LEGACY_FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED";
export const FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED =
"LEGACY_FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED";


//Report Download State Reset
export const RESET_REPORT_DOWNLOAD = "LEGACY_REPORT_DOWNLOAD_RESET";